import * as React from "react";
import {
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Chip,
  Typography,
  Tooltip,
  Button,
  Slider,
  FormControl,
  Select,
  MenuItem,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import DoneIcon from "@mui/icons-material/Done";
import ClearIcon from "@mui/icons-material/Clear";
import StarOutlineIcon from "@mui/icons-material/StarOutline";
import StarIcon from "@mui/icons-material/Star";

import {
  ActiveRallyVideo,
  upsertGlobalTurn,
  AiTurn,
  deleteGlobalTurn,
  buildErrorTurn,
  type ActiveRallyLensMoment,
} from "./ActiveRallyVideo";
import { AskAiPanel } from "./RallyColumnAskAIPanel";
import {
  KitchenArrivalRow,
  rallyKey,
  ReportResponse,
  ShotNumberOverlay,
} from "./RallyBoardPopup";
import { CondensedRallyTimeline } from "./CondensedRallyTimeline";
import { SideoutGameInfluenceReport } from "./RallyPopup";
import {
  buildPlayerIdToTeamMap,
  teamOfPlayerIdFromMap,
} from "./playerTeams";

import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import ReplyIcon from "@mui/icons-material/Reply";
import SportsTennisIcon from "@mui/icons-material/SportsTennis";
import CallSplitIcon from "@mui/icons-material/CallSplit";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import FlashOnIcon from "@mui/icons-material/FlashOn";
import TimerOutlinedIcon from "@mui/icons-material/TimerOutlined";
import LinkOffIcon from "@mui/icons-material/LinkOff";
import NorthEastIcon from "@mui/icons-material/NorthEast";
import { LeftRightCoverageIcon } from "./LeftRightCoverageIcon";
import {
  RallyVideoPreviewSeg,
  TeamReasonsTable,
} from "./GameStory_ReasonsLostEtc";
import { PBVRally } from "./pbvTypes";
import { FourthShotLocationsPopup } from "./GameStory_4thShotPopup_Mar_18_2026"; //  "./GameStory_4thShotPopup";
import { Close } from "@mui/icons-material";
import {
  buildFastReactionClip,
  computeFastReactionsForRally,
  FastReactionEvent,
  FastReactionsPopup,
} from "./GameStory_fastReactions";
import {
  buildFastShotClip,
  computeFastShotsForRally,
  FastShotEvent,
  FastShotsPopup,
} from "./GameStory_FastShotsPopup";
import { AllRallyVideosPopup_FromKitchenArrivalRows } from "./GameStory_ViewAllRallies";
import {
  computeFirefightsForAllRows,
  FirefightClip,
  FirefightsPopup,
} from "./GameStory_firefights";
import { InsightsJson } from "../../shared/types/insightsEtcTypes";
import {
  buildMatchImpactFactsFromInsights,
  MatchImpactFacts,
} from "./GameStory_buildMatchImpactFactsFromInsights";

import {
  AiAskRallyBasicQuestionBody,
  ClipFocus,
  RallyLocator,
} from "../../shared/types/askAiBasicQuestionTypes";
//import { ThirdShotLocationsPopup } from "./GameStory_3rdShotPopup";
import { ThirdShotLocationsPopup } from "./GameStory_3rdShotPopup_only_updated_v2_Mar_18_2026";
import {
  buildDinkSegmentClip,
  computeDinkSegmentsForRally,
  DinkSegmentEvent,
  DinkSegmentPopup,
} from "./GameStory_DinkRallies";
import {
  ServeLocationsPopup,
  ReturnLocationsPopup,
  ServeReturnRiskRewardPopup,
} from "./GameStory_ServeReturnPopups_New_New_Mar_18_2026";
import {
  buildLobClip,
  computeLobEventsForRally,
  LobClip,
  LobsPopup,
} from "./GameStory_LobsPopup";
import { yellow } from "@mui/material/colors";
import {
  AiTurnsHistoryPopup,
  deletePerRallyTurn,
  readPerRallyTurns,
  writePerRallyTurns,
} from "./GameStory_AITurnsHistoryPopup";

import { PbSkillsSolar } from "./pbSkillsSolar/PBSkillsSolar"; //"pbSkillsSolar/PbSkillsSolar";
import { PbSkillsSolarPopup } from "./PBSkillsSolarPopup";
import { computeErneClipsFromRows, ErnePopup } from "./GameStory_ernes";
import { GameStoryGameAIPopup } from "./GameStory_GameAIPopup";
import { CvJson } from "../../shared/types/cvJson";
import { buildPlayerIdentityDisplayMap } from "./GameStory_PlayerIdentityDisplay";
import { FrontSide } from "three";
import { PounceWindowRow } from "../../shared/types/pounceEtc";
import { PounceWindowsPopup } from "./GameStory_pounceWindows";
import { ATPPopup, computeAtpClipsFromRows } from "./GameStory_ATPPopup";
import {
  FAST_SHOT_MPH_THRESHOLD,
  FIREFIGHT_MIN_SHOTS,
  FIREFIGHT_REACTION_THRESHOLD_MS,
} from "./GameStory_thresholds";

import PounceCatIcon from "./pounceCatIcon";
import { displayPartsToString } from "typescript";

import {
  buildShotQualityClip,
  computeShotQualityEventsForRally,
  ShotQualityEvent,
  ShotQualityPopup,
} from "./GameStory_shotQuality";
import { GameStoryTriagePopup } from "./GameStory_TriagePopup";
import { RallyQualityOverviewPopup } from "./GameStory_RallyQualityOverview";
import { RallyCausalityOverviewPopup } from "./GameStory_RallyCausality_Popup";

import {
  buildSingleTopFocusCard,
  buildSingleTopFocus,
} from "./buildSingleTopFocus";

import { SingleTopFocusPopup } from "./GameStory_SingleTopFocusPopup";
import { FifthShotLocationsPopup } from "./GameStory_5thShotPopup_Apr_23_2026";
import { MatchIdentityPopup } from "./GameStory_MatchIdentityPopup";
import { ThreeMinuteReviewPopup } from "./GameStory_ThreeMinuteReviewPopup";
import { PlayerLensReviewPopup } from "./GameStory_PlayerLensReviewPopup";
import { PositioningPatternsPopup } from "./GameStory_PositioningPatternsPopup";
import { RallyTrajectoryWallPopup } from "./RallyTrajectoryWallPopup";
import { GameStoryShotUniversePopup } from "./GameStory_ShotUniversePopup";
import {
  OpportunityFinderPopup,
  type ShotOpportunityLabContext,
} from "./GameStory_OpportunityFinderPopup";
import { PointsAddedPopup } from "./GameStory_PointsAddedPopup";
import {
  buildCandidateBodybagMoments,
  buildCandidateSpeedupMoments,
  buildPossiblePopupMoments,
  buildDinkReadinessMoments,
  buildLeftSideCoverageMoments,
  buildPaddleReadinessMoments,
  CandidateBodybagsPopup,
  CandidateSpeedupsPopup,
  PossiblePopupsPopup,
  DinkReadinessReviewPopup,
  LeftSideCoverageReviewPopup,
  PaddleReadinessIcon,
  PaddleReadinessReviewPopup,
  type CoachViewMoment,
} from "./GameStory_CoachViewPopups";
import { ShotBookmarksPopup } from "./ShotBookmarksPopup";
import {
  deleteShotBookmark,
  updateShotBookmarkDescription,
  upsertShotBookmark,
  useShotBookmarks,
  type ShotBookmark,
} from "./shotBookmarks";
import { pauseAllActiveVideos } from "./activeVideoPlaybackCoordinator";

const SHOW_CANDIDATE_BODYBAGS_POPUP = false;
const TITO_SHOT_LAB_CANDIDATE = {
  packageId: "tito_qtrs_may_30_2026",
  rallyNumber: 24,
  rallyIndex: 23,
  playerId: 0,
  shotNumber: 19,
};

/* ----------------------------- helpers ----------------------------- */

function activeRallyLensPlayerPosition(
  overlay: ShotNumberOverlay | null | undefined,
  playerId: number | null | undefined,
): { x: number; y: number } | null {
  if (!overlay || typeof playerId !== "number") return null;
  const positions = overlay.player_positions ?? overlay.rawShot?.player_positions;
  if (!Array.isArray(positions)) return null;
  const pos = positions[playerId];
  if (!pos || typeof pos.x !== "number" || typeof pos.y !== "number") {
    return null;
  }
  if (!Number.isFinite(pos.x) || !Number.isFinite(pos.y)) return null;
  return { x: pos.x, y: pos.y };
}

function activeRallyLensCourtPlayers(
  overlay: ShotNumberOverlay | null | undefined,
  moment: CoachViewMoment,
  playerIdToTeam: (playerId: number | null) => 0 | 1 | null,
): ActiveRallyLensMoment["courtPlayers"] {
  const ids = [
    {
      playerId: moment.reviewedPlayerId,
      role: "reviewed" as const,
    },
    {
      playerId: moment.hitterPlayerId,
      role: "hitter" as const,
    },
    typeof moment.partnerPlayerId === "number"
      ? {
          playerId: moment.partnerPlayerId,
          role: "partner" as const,
        }
      : null,
  ].filter(Boolean) as Array<{
    playerId: number;
    role: "reviewed" | "hitter" | "partner";
  }>;

  const seen = new Set<number>();
  const players: NonNullable<ActiveRallyLensMoment["courtPlayers"]> = [];

  for (const item of ids) {
    if (seen.has(item.playerId)) continue;
    seen.add(item.playerId);
    const pos = activeRallyLensPlayerPosition(overlay, item.playerId);
    if (!pos) continue;
    players.push({
      playerId: item.playerId,
      role: item.role,
      x: pos.x,
      y: pos.y,
      team: playerIdToTeam(item.playerId),
    });
  }

  return players;
}

function normalizeCandidateOverlayMsForVideo(
  row: KitchenArrivalRow,
  rawMs: number,
): number {
  if (!Number.isFinite(rawMs)) return NaN;
  const segmentStartMs = Number(row.segmentStartMs ?? row.startMs ?? 0);
  const segmentEndMs = Number(row.segmentEndMs ?? row.endMs ?? segmentStartMs);
  const durationMs = Math.max(0, segmentEndMs - segmentStartMs);
  if (rawMs >= -500 && rawMs <= durationMs + 3000) return Math.max(0, rawMs);
  const fromSegmentStart = rawMs - segmentStartMs;
  if (fromSegmentStart >= -500 && fromSegmentStart <= durationMs + 3000) {
    return Math.max(0, fromSegmentStart);
  }
  return rawMs;
}

function getCandidateShotMsRel(
  row: KitchenArrivalRow,
  overlay: ShotNumberOverlay | null | undefined,
): number {
  const candidates = [
    overlay?.atMsRel,
    overlay?.trajectoryStart?.ms,
    overlay?.rawShot?.resulting_ball_movement?.trajectory?.start?.ms,
    overlay?.rawShot?.start_ms,
  ];
  for (const candidate of candidates) {
    const ms = Number(candidate);
    if (!Number.isFinite(ms)) continue;
    return normalizeCandidateOverlayMsForVideo(row, ms);
  }
  return NaN;
}

function buildShotLabCandidateLoopSeed(
  row: KitchenArrivalRow,
  shotNumber: number,
) {
  const overlays = [...(row.shotNumberOverlays ?? [])]
    .filter((overlay) => Number.isFinite(getCandidateShotMsRel(row, overlay)))
    .sort((a, b) => getCandidateShotMsRel(row, a) - getCandidateShotMsRel(row, b));
  const selectedIndex = overlays.findIndex((overlay) => overlay.shotNumber === shotNumber);
  const selectedOverlay = selectedIndex >= 0 ? overlays[selectedIndex] : null;
  if (!selectedOverlay) return null;
  const selectedMs = getCandidateShotMsRel(row, selectedOverlay);
  if (!Number.isFinite(selectedMs)) return null;
  const nextOverlay = overlays[selectedIndex + 1] ?? null;
  const nextMs = nextOverlay ? getCandidateShotMsRel(row, nextOverlay) : NaN;
  const segmentStartMs = Number(row.segmentStartMs ?? row.startMs ?? 0);
  const segmentEndMs = Number(row.segmentEndMs ?? row.endMs ?? segmentStartMs + 1000);
  const durationSec = Math.max(0.5, (segmentEndMs - segmentStartMs) / 1000);
  const selectedSec = selectedMs / 1000;
  const aSec = Math.max(0, selectedSec - 0.18);
  const rawEndSec = Number.isFinite(nextMs) ? nextMs / 1000 + 0.65 : durationSec;
  return {
    timeSec: aSec,
    enabled: true,
    aSec,
    bSec: Math.max(aSec + 0.3, Math.min(durationSec, rawEndSec)),
  };
}

function activeRallyLensMomentTitle(moment: CoachViewMoment): string {
  if (moment.kind === "candidateSpeedup") {
    return `Speedup candidate: shot ${moment.shotNumber}`;
  }
  if (moment.kind === "candidateBodybag") {
    return `Bodybag candidate: shot ${moment.shotNumber}`;
  }
  if (moment.kind === "possiblePopup") {
    return `Possible popup: shot ${moment.shotNumber}`;
  }
  if (moment.kind === "paddleReadiness") {
    return `Paddle check: player ${moment.reviewedPlayerId}`;
  }
  return `Coverage candidate: player ${moment.reviewedPlayerId}`;
}

function activeRallyLensMomentDetail(moment: CoachViewMoment): string {
  const pieces = [
    moment.candidateReason,
    moment.shotType ? `shot type: ${moment.shotType}` : null,
    moment.gameStageLabel,
  ].filter(Boolean);
  return pieces.join(" · ");
}

function SingleTopFocusCardView(props: {
  card: ReturnType<typeof buildSingleTopFocusCard>;
  winnerKey?: string | null;
  winnerScore?: number | null;
  onOpenEvidence?: (ev: {
    rallyIndex: number;
    shotIndex: number;
    startMs: number;
    endMs: number;
    whyItCounts: string;
  }) => void;
}) {
  const { card, winnerKey, winnerScore, onOpenEvidence } = props;
  if (!card) {
// console.error("no card");
    return null;
  }

  return (
    <Box
      sx={{
        border: "1px solid rgba(255,255,255,0.16)",
        borderRadius: "10px",
        p: 1.25,
        bgcolor: "rgba(255,255,255,0.035)",
      }}
    >
      <Box sx={{ fontWeight: 800, mb: 0.5 }}>One thing before next play</Box>

      <Box sx={{ fontSize: 15, fontWeight: 700, mb: 0.35 }}>{card.label}</Box>

      <Box sx={{ fontSize: 13, color: "rgba(255,255,255,0.82)", mb: 0.9 }}>
        {card.shortInstruction}
      </Box>

      {card.whyThisWon.map((line, idx) => (
        <Box
          key={idx}
          sx={{ fontSize: 12, color: "rgba(255,255,255,0.78)", mb: 0.35 }}
        >
          • {line}
        </Box>
      ))}

      <Box sx={{ mt: 1, mb: 0.45, fontSize: 12, fontWeight: 700 }}>
        Supporting evidence
      </Box>

      {card.evidence.map((ev, idx) => (
        <Box
          key={`${ev.rallyIndex}-${ev.shotIndex}-${idx}`}
          onClick={() => onOpenEvidence?.(ev)}
          sx={{
            mt: 0.5,
            p: 0.75,
            borderRadius: "8px",
            bgcolor: "rgba(255,255,255,0.04)",
            border: "1px solid rgba(255,255,255,0.08)",
            cursor: onOpenEvidence ? "pointer" : "default",
            "&:hover": onOpenEvidence
              ? {
                  borderColor: "rgba(255,255,255,0.22)",
                  bgcolor: "rgba(255,255,255,0.06)",
                }
              : undefined,
          }}
        >
          <Box sx={{ fontSize: 12, fontWeight: 700 }}>
            Rally {ev.rallyIndex + 1}
          </Box>
          <Box sx={{ fontSize: 11, color: "rgba(255,255,255,0.72)" }}>
            {ev.whyItCounts}
          </Box>
        </Box>
      ))}

      {!!card.notChosen.length && (
        <>
          <Box sx={{ mt: 1, mb: 0.4, fontSize: 12, fontWeight: 700 }}>
            Not chosen
          </Box>
          {card.notChosen.map((item, idx) => (
            <Box
              key={`${item.label}-${idx}`}
              sx={{ fontSize: 11, color: "rgba(255,255,255,0.68)", mb: 0.3 }}
            >
              <Box component="span" sx={{ fontWeight: 700 }}>
                {item.label}:
              </Box>{" "}
              {item.note}
            </Box>
          ))}
        </>
      )}

      {(winnerKey || winnerScore != null) && (
        <Box
          sx={{
            mt: 1,
            pt: 0.75,
            borderTop: "1px solid rgba(255,255,255,0.08)",
            fontSize: 10,
            color: "rgba(255,255,255,0.5)",
          }}
        >
          winner: {winnerKey ?? "—"} | score:{" "}
          {winnerScore != null ? winnerScore.toFixed(2) : "—"}
        </Box>
      )}
    </Box>
  );
}

function ThirdDropIcon(props: { size?: number }) {
  const s = props.size ?? 20;

  return (
    <svg width={s} height={s} viewBox="0 0 16 16">
      <text
        x="8"
        y="9"
        textAnchor="middle"
        fontSize="8"
        fill="currentColor"
        fontWeight="bold"
      >
        3
      </text>
      <line
        x1="3"
        y1="13"
        x2="13"
        y2="13"
        stroke="currentColor"
        strokeWidth="1.5"
      />
    </svg>
  );
}

function ThirdDriveIcon(props: { size?: number }) {
  const s = props.size ?? 20;

  return (
    <svg width={s} height={s} viewBox="0 0 16 16">
      <line
        x1="3"
        y1="3"
        x2="13"
        y2="3"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <text
        x="8"
        y="12"
        textAnchor="middle"
        fontSize="8"
        fill="currentColor"
        fontWeight="bold"
      >
        3
      </text>
    </svg>
  );
}

export type FocusedReasonStakeForTeam = {
  team: Team01;
  reason: StoryFilterKey;
  stake: StakeKey;
};

function deriveFocusedReasonStakeForSingleTeam(
  active: StakeReasonTeamFilters | null | undefined,
): FocusedReasonStakeForTeam | null {
  if (!active) return null;

  let found: FocusedReasonStakeForTeam | null = null;

  for (const stake of ["gamePointLost", "opportunityLost"] as const) {
    const byReason = active[stake];
    if (!byReason) continue;

    for (const reason of Object.keys(byReason) as StoryFilterKey[]) {
      const byTeam = byReason[reason];
      if (!byTeam) continue;

      for (const team of [0, 1] as const) {
        if (!byTeam[team]) continue;

        const cur: FocusedReasonStakeForTeam = { team, reason, stake };

        // If there's more than one selected filter anywhere, not focused.
        if (found) return null;
        found = cur;
      }
    }
  }

  return found;
}

export type ActiveBadgeFilter = {
  team: Team01;
  key: StoryFilterKey;
  stake: StakeKey | "both";
};

export function deriveActiveBadgeFilter(
  active: StakeReasonTeamFilters | null | undefined,
): ActiveBadgeFilter | null {
  if (!active) return null;

  const hits: Array<{ team: Team01; key: StoryFilterKey; stake: StakeKey }> =
    [];

  (["gamePointLost", "opportunityLost"] as const).forEach((stake) => {
    const byReason = active[stake];
    if (!byReason) return;

    (Object.keys(byReason) as StoryFilterKey[]).forEach((key) => {
      const byTeam = byReason[key];
      if (!byTeam) return;

      ([0, 1] as const).forEach((team) => {
        if (byTeam[team]) hits.push({ team, key, stake });
      });
    });
  });

  if (hits.length === 0) return null;

  // If the user selected exactly one stake+reason+team => straightforward
  if (hits.length === 1) {
    return { team: hits[0].team, key: hits[0].key, stake: hits[0].stake };
  }

  // If exactly two selections and they are same team+key but different stake,
  // interpret as "both".
  if (hits.length === 2) {
    const a = hits[0];
    const b = hits[1];
    if (a.team === b.team && a.key === b.key && a.stake !== b.stake) {
      return { team: a.team, key: a.key, stake: "both" };
    }
  }

  // Anything else means “multiple filters” => timeline badges would be noisy/ambiguous
  return null;
}

export type Team01 = 0 | 1;
type TeamChoice = "both" | Team01;

type TeamCounts = { t0: number; t1: number; total?: number };

export const Team_0: Team01 = 0;
export const Team_1: Team01 = 1;

export const TEAM_RGB: Record<Team01, readonly [number, number, number]> = {
  0: [80, 160, 255], // ✅ matches your blue bars
  1: [120, 220, 140], // ✅ matches your green bars
} as const;

export function teamRgba(team: Team01, a = 1): string {
  const [r, g, b] = TEAM_RGB[team];
  return `rgba(${r},${g},${b},${a})`;
}

// Useful shared neutrals so you don't retype them everywhere
export const NEUTRAL_DIM = "rgba(255,255,255,0.12)";
export const NEUTRAL_TEXT = "rgba(0,0,0,0.70)";

export type StakeKey = "opportunityLost" | "gamePointLost";

function toggleStakeFilter(active: StakeKey[], k: StakeKey): StakeKey[] {
  return active.includes(k) ? active.filter((x) => x !== k) : [...active, k];
}

type StakesFilter = "all" | "opportunityLost" | "gamePointLost";
type StakesKind = "opportunityLost" | "gamePointLost" | "other";

function matchingRallyIndexes(args: {
  team: Team01;
  reason: StoryFilterKey;
  stake?: StakeKey; // optional
  badgesByRallyIndex: Map<number, RallyBadge[]>;
}): number[] {
  const out: number[] = [];
  // for (const [ri, arr] of args.badgesByRallyIndex.entries()) {
  Array.from(args.badgesByRallyIndex.entries()).forEach(([ri, arr]) => {
    if (
      arr.some(
        (b) =>
          b.team === args.team &&
          b.key === args.reason &&
          (args.stake ? b.stake === args.stake : true),
      )
    ) {
      out.push(ri);
    }
  });

  out.sort((a, b) => b - a);
  return out;
}

function last3ShotsSegFromRow(
  r: KitchenArrivalRow,
): { startSec: number; endSec: number } | null {
  const shotsOverlays = Array.isArray(r?.shotNumberOverlays)
    ? r.shotNumberOverlays
    : [];
  const shots = shotsOverlays;

  if (!shots.length) return null;

  const n = Math.min(3, shots.length);
  const first = shots[shots.length - n];
  const last = shots[shots.length - 1];

  // assume each has startMs/endMs OR startSec/endSec; normalize
  const toSec = (x: any) => (typeof x === "number" ? x : 0);

  //first.
  // const firstStartSec =
  //   typeof first.atMsRel === "number" ? first.atMsRel :
  //   typeof first.startMs === "number" ? first.startMs / 1000 :
  //   0;

  let durationSec = r.segmentEndMs - r.segmentStartMs;
  // return ms > 0 ? ms / 1000 : null;
  // const lastEndSec =
  //   typeof last.endSec === "number" ? last.endSec :
  //   typeof last.endMs === "number" ? last.endMs / 1000 :
  //   (typeof last.startSec === "number" ? last.startSec : 0);

  const padBefore = 0.35,
    padAfter = 0.35;
  return {
    startSec:
      Math.max(0, first.atMsRel / 1000) - padBefore - r.segmentStartMs / 1000, // firstStartSec - padBefore),
    endSec: Math.max(0, r.segmentEndMs / 1000) - r.segmentStartMs / 1000,
  };
}

function stakesForErrTeam(row: any, errTeam: Team01): StakesKind {
  const servingTeam: Team01 | null =
    row?.servingTeam === 0 || row?.servingTeam === 1 ? row.servingTeam : null;

  const winnerTeam: Team01 | null =
    row?.winnerTeam === 0 || row?.winnerTeam === 1 ? row.winnerTeam : null;

  const scoredPoint: boolean | null =
    typeof row?.scoredPoint === "boolean" ? row.scoredPoint : null;

  if (servingTeam == null || winnerTeam == null || scoredPoint == null)
    return "other";

  // only meaningful if this errTeam actually LOST the rally
  if (winnerTeam === errTeam) return "other";

  const weWereServing = servingTeam === errTeam;

  // Sideout scoring semantics:
  // - If we were serving and lost, that’s an opportunity lost (no point scored).
  if (weWereServing && scoredPoint === false) return "opportunityLost";

  // - If opponent was serving and we lost, they scored a point (game point lost).
  if (!weWereServing && scoredPoint === true) return "gamePointLost";

  return "other";
}

const STORY_TO_RALLY_FILTER: Record<StoryFilterKey, RallyFilterKey> = {
  missedServe: "missedServe",
  missedReturn: "missedReturn",
  missed3rdDrop: "missedThirdDrop",
  missed3rdDrive: "missedThirdDrive",

  faultNet: "faultNet",
  faultOut: "faultOut",
  unforcedError: "unforcedError",
  forcedFault: "forcedFault",
  popupExploited: "popupExploited",
};

export type StoryFilterKey =
  | "missedServe"
  | "missedReturn"
  | "missed3rdDrop"
  | "missed3rdDrive"
  | "faultNet"
  | "faultOut"
  | "unforcedError"
  | "forcedFault"
  | "popupExploited";

export const STORY_FILTER_ICON: Record<StoryFilterKey, React.ElementType> = {
  missedServe: SportsTennisIcon,
  missedReturn: ReplyIcon,

  missed3rdDrop: ThirdDropIcon, // CallSplitIcon,
  missed3rdDrive: ThirdDriveIcon, //  NorthEastIcon,

  faultNet: LinkOffIcon,
  faultOut: NorthEastIcon,

  unforcedError: ErrorOutlineIcon,
  forcedFault: FlashOnIcon,

  popupExploited: TrendingUpIcon,
};

export type RallyFilterKey =
  | "missedServe"
  | "missedReturn"
  | "missedThirdDrop"
  | "missedThirdDrive"
  | "faultNet"
  | "faultOut"
  | "unforcedError"
  | "forcedFault"
  | "popupExploited";

export type StakeCounts = {
  rallyIndexes: Set<number>; // all teams
  t0: number;
  t1: number;
  teams: Record<Team01, Set<number>>; // per-team rally indexes
  players: Record<number, Set<number>>; // per-player rally indexes
  playerCounts: Record<number, number>;
};

export type FilterBucket = {
  key: StoryFilterKey;
  label: string;

  // all rallies matching this reason
  rallyIndexes: Set<number>;
  t0: number;
  t1: number;

  // NEW: reason × stake
  stakes: Record<StakeKey, StakeCounts>;
};

/**
 * Extract any “factor-ish” strings that might already be on KitchenArrivalRow.
 * (This is intentionally defensive so it works with whatever shape you currently have.)
 */
function getFactorStrings(row: any): string[] {
  const out: string[] = [];

  const push = (v: any) => {
    if (typeof v === "string") {
      const s = v.trim();
      if (s) out.push(s);
    }
  };

  // shallow common-ish
  const pushArr = (v: any) => {
    if (Array.isArray(v)) v.forEach(push);
  };

  // recursive: pull strings from nested objects/arrays (bounded depth)
  const walk = (v: any, depth: number) => {
    if (depth <= 0) return;
    if (v == null) return;

    if (typeof v === "string") {
      push(v);
      return;
    }
    if (Array.isArray(v)) {
      for (const it of v) walk(it, depth - 1);
      return;
    }
    if (typeof v === "object") {
      // If objects contain common label-ish fields, grab those
      push(v.label);
      push(v.name);
      push(v.title);
      push(v.text);
      push(v.reason);
      push(v.tag);

      // walk all values
      for (const key of Object.keys(v)) {
        walk((v as any)[key], depth - 1);
      }
    }
  };

  // old places you already tried
  pushArr(row?.factors);
  pushArr(row?.factorStrings);
  pushArr(row?.factorLabels);
  pushArr(row?.tags);
  pushArr(row?.reasons);
  pushArr(row?.triageTags);
  pushArr(row?.notes);

  // common nested
  pushArr(row?.debug?.factors);
  pushArr(row?.debug?.tags);

  // ✅ NEW: backend often attaches “hurts/helps” per team, per category, etc.
  // We don’t assume exact shapes — just walk a couple levels and harvest strings.
  walk(row?.hurts, 4);
  walk(row?.helps, 4);
  walk(row?.hurtsByTeam, 5);
  walk(row?.helpsByTeam, 5);
  walk(row?.factorsByTeam, 5);
  walk(row?.team0Hurts, 4);
  walk(row?.team1Hurts, 4);
  walk(row?.team0Helps, 4);
  walk(row?.team1Helps, 4);
  walk(row?.insights, 5);
  walk(row?.gameStory, 5);

  return out;
}

function losingTeamForRow(row: any): Team01 | null {
  const w: any = row?.winnerTeam;
  if (w === 0) return 1;
  if (w === 1) return 0;
  return null;
}

function stakeForTeam(row: any, team: Team01): StakeKey | null {
  const servingTeam: any = row?.servingTeam;
  const scoredPoint: any = row?.scoredPoint;

  if (!(servingTeam === 0 || servingTeam === 1)) return null;
  if (typeof scoredPoint !== "boolean") return null;

  // Opportunity lost: team was serving and lost => no point awarded
  if (scoredPoint === false && team === servingTeam) return "opportunityLost";

  // Game point lost: team was receiving and lost => opponent (server) scored
  if (scoredPoint === true && team !== servingTeam) return "gamePointLost";

  return null;
}
function computeStakeCounts(args: {
  rows: any[];
  // if provided, only consider these rallyIndexes (e.g. those matching selected reasons)
  scopeRallyIndexes?: Set<number> | null;
}): Record<StakeKey, TeamCounts> {
  const out: Record<StakeKey, TeamCounts> = {
    opportunityLost: { t0: 0, t1: 0 },
    gamePointLost: { t0: 0, t1: 0 },
  };

  const scope = args.scopeRallyIndexes;

  (args.rows ?? []).forEach((r) => {
    const idx = r?.rallyIndex;
    if (scope && !scope.has(idx)) return;

    const loser = losingTeamForRow(r);
    if (loser == null) return;

    const st = stakeForTeam(r, loser);
    if (!st) return;

    if (loser === 0) out[st].t0 += 1;
    if (loser === 1) out[st].t1 += 1;
  });

  return out;
}

/**
 * Try to get the PBV “shots” array if it exists on this row.
 * Your own numShots logic already checks row.shots, so we mirror that.
 */
function getShotsArray(row: any): any[] {
  if (Array.isArray(row?.shots)) return row.shots;
  if (Array.isArray(row?.pbvRally?.shots)) return row.pbvRally.shots;
  if (Array.isArray(row?.rally?.shots)) return row.rally.shots;
  return [];
}

/**
 * Heuristic: does a shot object look like an “error/miss”?
 * This is deliberately permissive — tune as you learn your exact shot schema.
 */
function shotLooksLikeMiss(shot: any): boolean {
  const s = shot ?? {};
  const str = (v: any) => (typeof v === "string" ? v.toLowerCase() : "");

  // common flags
  if (s.isError === true || s.error === true || s.fault === true) return true;

  // common fields
  const outcome = str(s.outcome || s.result || s.shotOutcome || s.endingType);
  if (
    outcome.includes("fault") ||
    outcome.includes("miss") ||
    outcome.includes("error") ||
    outcome.includes("out") ||
    outcome.includes("net")
  ) {
    return true;
  }

  const desc = str(s.description || s.reason);
  if (
    desc.includes("fault") ||
    desc.includes("miss") ||
    desc.includes("error") ||
    desc.includes("out") ||
    desc.includes("net")
  ) {
    return true;
  }

  return false;
}

function shotTypeIsDrop(shot: any): boolean {
  const s = (shot?.shotType || shot?.type || shot?.name || "")
    .toString()
    .toLowerCase();
  return s.includes("drop");
}
function shotTypeIsDrive(shot: any): boolean {
  const s = (shot?.shotType || shot?.type || shot?.name || "")
    .toString()
    .toLowerCase();
  return s.includes("drive");
}

/**
 * Decide whether a rally matches each filter bucket.
 * Priority:
 *  1) factor strings already computed by backend
 *  2) fallback: shot-based heuristics (serve=shot1, return=shot2, third=shot3)
 */
// function classifyRallyForStoryFilters(
//   row: any,
// ): Record<StoryFilterKey, boolean> {
//   const factors = getFactorStrings(row).map((s) => s.toLowerCase());
//   const joined = factors.join(" | ");

//   const has = (re: RegExp) => re.test(joined);

//   const fromFactors = {
//     missedServe: has(
//       /miss(?:ed)?\s+serve|serve\s+fault|fault.*serve|serve.*fault/i,
//     ),
//     missedReturn: has(
//       /miss(?:ed)?\s+return|return\s+fault|fault.*return|return.*fault/i,
//     ),

//     // ✅ match “3rd shot”, “third shot”, “shot 3”, etc.
//     missed3rdDrop: has(
//       /(miss(?:ed)?|error|fault).*(3(?:rd)?|third|shot\s*3).*(drop)/i,
//     ),
//     missed3rdDrive: has(
//       /(miss(?:ed)?|error|fault).*(3(?:rd)?|third|shot\s*3).*(drive)/i,
//     ),
//   };

//   // If factor strings already identify *any* of these, trust them and stop.
//   const anyFromFactors =
//     fromFactors.missedServe ||
//     fromFactors.missedReturn ||
//     fromFactors.missed3rdDrop ||
//     fromFactors.missed3rdDrive;

//   if (anyFromFactors) return fromFactors;

//   // ---- fallback: infer from shots array ----
//   const shots = getShotsArray(row);

//   // “shot 1” = serve, “shot 2” = return, “shot 3” = third
//   const s1 = shots[0] ?? null;
//   const s2 = shots[1] ?? null;
//   const s3 = shots[2] ?? null;

//   const missedServe = s1 ? shotLooksLikeMiss(s1) : false;
//   const missedReturn = s2 ? shotLooksLikeMiss(s2) : false;

//   // third shot: only count if we can also recognize drive vs drop
//   const thirdMiss = s3 ? shotLooksLikeMiss(s3) : false;
//   const missed3rdDrop = thirdMiss && shotTypeIsDrop(s3);
//   const missed3rdDrive = thirdMiss && shotTypeIsDrive(s3);

//   return { missedServe, missedReturn, missed3rdDrop, missed3rdDrive };
// }

function incCount(acc: TeamCounts, team: 0 | 1 | null | undefined) {
  if (team === 0) acc.t0 += 1;
  else if (team === 1) acc.t1 += 1;
  acc.total = acc.t0 + acc.t1;
}

function emptyCounts(): TeamCounts {
  return { t0: 0, t1: 0, total: 0 };
}

function getNumShotsLoose(row: any): number | null {
  if (typeof row?.numShots === "number") return row.numShots;
  if (Array.isArray(row?.shots)) return row.shots.length;
  if (typeof row?.shotsCount === "number") return row.shotsCount;
  if (Array.isArray(row?.shotNumberOverlays))
    return row.shotNumberOverlays.length;
  return null;
}

function getThirdShotKindLoose(row: any): "drop" | "drive" | null {
  // 1) direct fields (if you ever send them)
  const s = (row?.shotType ?? row?.thirdShotType ?? row?.third_shot_type ?? "")
    .toString()
    .toLowerCase();
  if (s.includes("drop")) return "drop";
  if (s.includes("drive")) return "drive";

  // 2) overlays: IMPORTANT — prefer structured shotType over label
  const ov3 = Array.isArray(row?.shotNumberOverlays)
    ? row.shotNumberOverlays.find((o: any) => Number(o?.shotNumber) === 3)
    : null;

  const ovShotType = (ov3?.shotType ?? ov3?.shot_type ?? "")
    .toString()
    .toLowerCase();
  if (ovShotType.includes("drop")) return "drop";
  if (ovShotType.includes("drive")) return "drive";

  // 3) fallback to any text (label/text)
  const label = (ov3?.label ?? ov3?.text ?? "").toString().toLowerCase();
  if (label.includes("drop")) return "drop";
  if (label.includes("drive")) return "drive";

  return null;
}

export function teamOfPlayerId(pid: any): Team01 | null {
  // common PBV convention: 0/1 = team0, 2/3 = team1
  if (pid === 0 || pid === 1) return 0;
  if (pid === 2 || pid === 3) return 1;
  return null; //0; //fallback
}

function getOverlays(row: KitchenArrivalRow): ShotNumberOverlay[] {
  return Array.isArray(row?.shotNumberOverlays) ? row.shotNumberOverlays : [];
}

function overlayHasKind(o: ShotNumberOverlay, kind: string): boolean {
  const ks: string[] = Array.isArray(o?.storyKinds) ? o.storyKinds : [];
  // if (kind === "unforced_error") {
  //   if (ks.includes(kind)) {
  //     console.error("Checking unforced_error kind on overlay:", { o, kind });
  //   }
  // }
  return ks.includes(kind);
}

const isFinalOverlay = (x: ShotNumberOverlay) => x?.rawShot?.is_final === true;

function findOverlayByShotNumber(
  row: KitchenArrivalRow,
  shotNumber: number,
): ShotNumberOverlay | null {
  const ovs = getOverlays(row);
  for (const ov of ovs) {
    if (Number(ov?.shotNumber) === shotNumber) return ov;
  }
  return null;
}

function findLastOverlaySatisfyingPred(
  row: KitchenArrivalRow,
  pred: (o: ShotNumberOverlay) => boolean,
): ShotNumberOverlay | null {
  const ovs: ShotNumberOverlay[] = getOverlays(row);
  for (let i = ovs.length - 1; i >= 0; i--) {
    const o = ovs[i];
    if (o && pred(o)) return o;
  }
  return null;
}

type MatchWithPlayer = {
  match: boolean;
  errTeam: 0 | 1 | null;
  errPlayerId: number | null;
  errShotNumber: number | null;
};

type ImpactFacts = {
  version: 1;
  packageId: string;
  finalScore: [number, number] | null;

  players: Array<{ playerId: 0 | 1 | 2 | 3; team: 0 | 1 }>;

  // per-player negatives, keyed by your StoryFilterKey-ish buckets
  negatives: Record<
    number,
    Partial<
      Record<
        StoryFilterKey,
        {
          opportunityLost: {
            count: number;
            examples: Array<{ rallyIndex: number; shotNumber?: number | null }>;
          };
          gamePointLost: {
            count: number;
            examples: Array<{ rallyIndex: number; shotNumber?: number | null }>;
          };
        }
      >
    >
  >;

  // optional team rollups if you want
  teamTotals?: any;
};
/**
 * Returns:
 * - match: does this row qualify for this filter?
 * - errTeam: which team *made* the error (used for per-team chip counts)
 */

function matchFilter(
  row: KitchenArrivalRow,
  k: RallyFilterKey,
): { match: boolean; errTeam: 0 | 1 | null; errPlayerId: number | null } {
  const n = getNumShotsLoose(row);
  const servingTeam: 0 | 1 | null =
    row?.servingTeam === 0 || row?.servingTeam === 1 ? row.servingTeam : null;

  const winnerTeam: 0 | 1 | null =
    row?.winnerTeam === 0 || row?.winnerTeam === 1 ? row.winnerTeam : null;

  const scoredPoint: boolean | null =
    typeof row?.scoredPoint === "boolean" ? row.scoredPoint : null;

  const losingTeam: 0 | 1 | null =
    winnerTeam != null ? otherTeam(winnerTeam) : null;

  // --- Existing heuristics (already “loss-oriented”) ---

  if (k === "missedServe") {
    const ov1 = findOverlayByShotNumber(row, 1);
    const errPlayerId = typeof ov1?.playerId === "number" ? ov1.playerId : null;

    const match =
      n === 1 &&
      servingTeam != null &&
      winnerTeam != null &&
      servingTeam !== winnerTeam &&
      scoredPoint === false;

    return {
      match,
      errTeam: match ? servingTeam : null,
      errPlayerId: match ? errPlayerId : null,
    };
  }

  if (k === "missedReturn") {
    const ov2 = findOverlayByShotNumber(row, 2);
    const errPlayerId = typeof ov2?.playerId === "number" ? ov2.playerId : null;

    const match =
      n === 2 &&
      servingTeam != null &&
      winnerTeam != null &&
      servingTeam === winnerTeam &&
      scoredPoint === true;

    return {
      match,
      errTeam: match ? otherTeam(servingTeam) : null,
      errPlayerId: match ? errPlayerId : null,
    };
  }

  if (k === "missedThirdDrop" || k === "missedThirdDrive") {
    const kind = getThirdShotKindLoose(row);
    const want = k === "missedThirdDrop" ? "drop" : "drive";
    const ov3 = findOverlayByShotNumber(row, 3);
    const errPlayerId = typeof ov3?.playerId === "number" ? ov3.playerId : null;

    const match =
      n === 3 &&
      servingTeam != null &&
      winnerTeam != null &&
      servingTeam !== winnerTeam &&
      scoredPoint === false &&
      kind === want;

    return {
      match,
      errTeam: match ? servingTeam : null,
      errPlayerId: match ? errPlayerId : null,
    };
  }

  // if (k === "missedServe") {
  //   const match =
  //     n === 1 &&
  //     servingTeam != null &&
  //     winnerTeam != null &&
  //     servingTeam !== winnerTeam &&
  //     scoredPoint === false;
  //   return { match, errTeam: match ? servingTeam : null };
  // }

  // if (k === "missedReturn") {
  //   const match =
  //     n === 2 &&
  //     servingTeam != null &&
  //     winnerTeam != null &&
  //     servingTeam === winnerTeam &&
  //     scoredPoint === true;
  //   return { match, errTeam: match ? otherTeam(servingTeam) : null };
  // }

  // if (k === "missedThirdDrop" || k === "missedThirdDrive") {
  //   const kind = getThirdShotKindLoose(row);
  //   const want = k === "missedThirdDrop" ? "drop" : "drive";
  //   const match =
  //     n === 3 &&
  //     servingTeam != null &&
  //     winnerTeam != null &&
  //     servingTeam !== winnerTeam &&
  //     scoredPoint === false &&
  //     kind === want;

  //   return { match, errTeam: match ? servingTeam : null };
  // }

  // --- NEW: overlay-derived whys (also “loss-oriented”) ---

  // helper: only accept an errTeam if that team actually lost the rally
  // const acceptLoss = (errTeam: Team01 | null) => {
  //   if (errTeam == null) return { match: false, errTeam: null };
  //   if (losingTeam == null) return { match: false, errTeam: null };
  //   const match = errTeam === losingTeam;
  //   return { match, errTeam: match ? errTeam : null };
  // };

  const acceptLoss = (errTeam: Team01 | null, errPlayerId: number | null) => {
    if (errTeam == null)
      return { match: false, errTeam: null, errPlayerId: null };
    if (losingTeam == null)
      return { match: false, errTeam: null, errPlayerId: null };
    const match = errTeam === losingTeam;
    return {
      match,
      errTeam: match ? errTeam : null,
      errPlayerId: match ? errPlayerId : null,
    };
  };

  // if (k === "faultNet") {
  //   const o = findLastOverlaySatisfyingPred(
  //     row,
  //     (x) => overlayHasKind(x, "fault_net") || x?.faultType === "net",
  //   );
  //   const err = teamOfPlayerId(o?.playerId);
  //   return acceptLoss(err);
  // }

  // if (k === "faultOut") {
  //   const o = findLastOverlaySatisfyingPred(
  //     row,
  //     (x) => overlayHasKind(x, "fault_out") || x?.faultType === "out",
  //   );
  //   const err = teamOfPlayerId(o?.playerId);
  //   return acceptLoss(err);
  // }

  // if (k === "unforcedError") {
  //   const o = findLastOverlaySatisfyingPred(row, (x) =>
  //     overlayHasKind(x, "unforced_error"),
  //   );
  //   const err = teamOfPlayerId(o?.playerId);
  //   if (o) {
  //     console.error("Checking unforced_error kind on overlay:", {
  //       rally: row.rallyIndex,
  //       o,
  //       k,
  //       losingTeam,
  //       errTeam: err,
  //     });
  //   }
  //   return acceptLoss(err);
  // }

  // if (k === "forcedFault") {
  //   // In your sample you have both "forced_fault" and "winner_type:forced_fault"
  //   const o = findLastOverlaySatisfyingPred(
  //     row,
  //     (x) =>
  //       overlayHasKind(x, "forced_fault") ||
  //       overlayHasKind(x, "winner_type:forced_fault"),
  //   );
  //   // forced-fault is attributed to the *losing* side (the side that faulted),
  //   // which is usually the opposite team of the hitter on the “winner” shot.
  //   const hitterTeam = teamOfPlayerId(o?.playerId);
  //   const err = hitterTeam != null ? otherTeam(hitterTeam) : null;
  //   return acceptLoss(err);
  // }

  // if (k === "popupExploited") {
  //   const o = findLastOverlaySatisfyingPred(
  //     row,
  //     (x) =>
  //       x?.popupExploited === true ||
  //       overlayHasKind(x, "popup_exploited") ||
  //       overlayHasKind(x, "popup:exploited"),
  //   );
  //   // popup exploited => losing team is the team that *popped it up* (other team of hitter)
  //   const hitterTeam = teamOfPlayerId(o?.playerId);
  //   const err = hitterTeam != null ? otherTeam(hitterTeam) : null;
  //   return acceptLoss(err);
  // }

  if (k === "faultNet") {
    const o = findLastOverlaySatisfyingPred(
      row,
      (x) => overlayHasKind(x, "fault_net") || x?.faultType === "net",
    );
    const errTeam = teamOfPlayerId(o?.playerId);
    const errPlayerId = typeof o?.playerId === "number" ? o.playerId : null;
    return acceptLoss(errTeam, errPlayerId);
  }

  if (k === "faultOut") {
    const o = findLastOverlaySatisfyingPred(
      row,
      (x) => overlayHasKind(x, "fault_out") || x?.faultType === "out",
    );
    const errTeam = teamOfPlayerId(o?.playerId);
    const errPlayerId = typeof o?.playerId === "number" ? o.playerId : null;
    return acceptLoss(errTeam, errPlayerId);
  }

  if (k === "unforcedError") {
    const o = findLastOverlaySatisfyingPred(row, (x) =>
      overlayHasKind(x, "unforced_error"),
    );
    const errTeam = teamOfPlayerId(o?.playerId);
    const errPlayerId = typeof o?.playerId === "number" ? o.playerId : null;
    return acceptLoss(errTeam, errPlayerId);
  }

  if (k === "forcedFault") {
    const o = findLastOverlaySatisfyingPred(
      row,
      (x) =>
        overlayHasKind(x, "forced_fault") ||
        overlayHasKind(x, "winner_type:forced_fault"),
    );

    const losingOverlays = getOverlays(row).filter(
      (x) => teamOfPlayerId(x?.playerId) === losingTeam,
    );
    const lastLosingOverlay =
      losingOverlays.length > 0
        ? losingOverlays[losingOverlays.length - 1]
        : null;

    const hitterTeam = teamOfPlayerId(o?.playerId);
    const errTeam = hitterTeam != null ? otherTeam(hitterTeam) : null;
    const errPlayerId =
      typeof lastLosingOverlay?.playerId === "number"
        ? lastLosingOverlay.playerId
        : null;

    return acceptLoss(errTeam, errPlayerId);
  }

  if (k === "popupExploited") {
    const o = findLastOverlaySatisfyingPred(
      row,
      (x) =>
        x?.popupExploited === true ||
        overlayHasKind(x, "popup_exploited") ||
        overlayHasKind(x, "popup:exploited"),
    );

    const losingOverlays = getOverlays(row).filter(
      (x) => teamOfPlayerId(x?.playerId) === losingTeam,
    );
    const lastLosingOverlay =
      losingOverlays.length > 0
        ? losingOverlays[losingOverlays.length - 1]
        : null;

    const hitterTeam = teamOfPlayerId(o?.playerId);
    const errTeam = hitterTeam != null ? otherTeam(hitterTeam) : null;
    const errPlayerId =
      typeof lastLosingOverlay?.playerId === "number"
        ? lastLosingOverlay.playerId
        : null;

    return acceptLoss(errTeam, errPlayerId);
  }

  return { match: false, errTeam: null, errPlayerId: null };
}

type KeyMoment = {
  id: string;
  rallyIndex: number;
  segmentStartMs: number;
  segmentEndMs: number;
  title: string;
  detail: string;
  kind?: string;
  pointIndex?: number | null;
  pointAwardedToTeam?: number | null;
};

type GameStory = {
  winner: number | null;
  finalScore: [number, number];
  keyMoments: KeyMoment[];
};

/**
 * Best-effort accessors so this doesn't explode if your row shape shifts.
 * We intentionally don't type-narrow too hard yet.
 */
function getRunningScore(row: any): [number, number] | null {
  const rs =
    row?.runningScore ?? row?.running_score ?? row?.insight?.running_score;
  if (Array.isArray(rs) && rs.length === 2) {
    const a = Number(rs[0]);
    const b = Number(rs[1]);
    if (Number.isFinite(a) && Number.isFinite(b)) return [a, b];
  }
  return null;
}

function getPointAwardedTeam(row: any): 0 | 1 | null {
  const t =
    row?.pointAwardedTeam ?? // ✅ KitchenArrivalRow
    row?.pointAwardedToTeam ??
    row?.point_awarded_to_team ??
    row?.insight?.point_awarded_to_team ??
    null;

  if (t === 0 || t === 1) return t;
  if (typeof t === "string") {
    const s = t.trim();
    if (s === "T0" || s === "0") return 0;
    if (s === "T1" || s === "1") return 1;
  }
  const n = typeof t === "number" ? t : Number(t);
  return n === 0 || n === 1 ? (n as 0 | 1) : null;
}

function getScoreBeforeAfter(row: any): {
  before: [number, number] | null;
  after: [number, number] | null;
} {
  const b = Array.isArray(row?.scoreBefore) ? row.scoreBefore : null;
  const a = Array.isArray(row?.scoreAfter) ? row.scoreAfter : null;

  const norm = (x: any): [number, number] | null => {
    if (!Array.isArray(x) || x.length !== 2) return null;
    const n0 = Number(x[0]);
    const n1 = Number(x[1]);
    if (!Number.isFinite(n0) || !Number.isFinite(n1)) return null;
    return [n0, n1];
  };

  return { before: norm(b), after: norm(a) };
}

function getPointAwarded(row: any): boolean {
  // ✅ Backend truth: scoredPoint means a point was scored
  if (row?.scoredPoint === true) return true;

  // ✅ Fallback: score delta check (most robust)
  const before = Array.isArray(row?.scoreBefore) ? row.scoreBefore : null;
  const after = Array.isArray(row?.scoreAfter) ? row.scoreAfter : null;

  if (before && after) {
    return before[0] !== after[0] || before[1] !== after[1];
  }

  return false;
}

function getWinningTeam(row: any): number | null {
  const t =
    row?.winningTeam ?? row?.winning_team ?? row?.insight?.winning_team ?? null;
  const n = typeof t === "number" ? t : Number(t);
  return Number.isFinite(n) ? n : null;
}

function getServingTeam(row: any): number | null {
  const t =
    row?.servingTeam ?? row?.serving_team ?? row?.insight?.serving_team ?? null;
  const n = typeof t === "number" ? t : Number(t);
  return Number.isFinite(n) ? n : null;
}

function getServerNumber(row: any): number | null {
  const t =
    row?.serverNumber ??
    row?.server_number ??
    row?.insight?.server_number ??
    null;
  const n = typeof t === "number" ? t : Number(t);
  return Number.isFinite(n) ? n : null;
}

function getRallyIndex(row: any): number | null {
  const n = row?.rallyIndex ?? row?.rally_index ?? row?.rally ?? null;
  const v = typeof n === "number" ? n : Number(n);
  return Number.isFinite(v) ? v : null;
}

function getSegmentBounds(row: any): { start: number; end: number } | null {
  const a =
    row?.segmentStartMs ??
    row?.segment_start_ms ??
    row?.segmentStartMsAbs ??
    null;
  const b =
    row?.segmentEndMs ?? row?.segment_end_ms ?? row?.segmentEndMsAbs ?? null;
  const start = typeof a === "number" ? a : Number(a);
  const end = typeof b === "number" ? b : Number(b);
  if (Number.isFinite(start) && Number.isFinite(end)) return { start, end };
  return null;
}

function computeScoreTimeline(rows: any[]) {
  // scoreBefore/scoreAfter per rallyIndex
  const before = new Map<number, [number, number]>();
  const after = new Map<number, [number, number]>();

  // Current running score (used only as fallback if backend didn't send before/after)
  let s0 = 0;
  let s1 = 0;

  const sorted = [...(Array.isArray(rows) ? rows : [])]
    .filter(Boolean)
    .sort(
      (a, b) => Number(getRallyIndex(a) ?? 0) - Number(getRallyIndex(b) ?? 0),
    );

  for (const r of sorted) {
    const rallyIndex = getRallyIndex(r);
    if (rallyIndex == null) continue;

    const { before: b, after: a } = getScoreBeforeAfter(r);

    // ✅ Prefer backend truth if present
    if (b) {
      before.set(rallyIndex, b);
      // also sync running score so later “fallback” rallies stay consistent
      s0 = b[0];
      s1 = b[1];
    } else if (!before.has(rallyIndex)) {
      before.set(rallyIndex, [s0, s1]);
    }

    if (a) {
      after.set(rallyIndex, a);
      s0 = a[0];
      s1 = a[1];
      continue;
    }

    // ---- fallback path only if backend did NOT provide scoreAfter ----
    if (getPointAwarded(r)) {
      // best-effort: try pointAwardedTeam first, else infer from row.scoreAfter (if any)
      let awarded = getPointAwardedTeam(r);

      // If no awarded team, we can't safely increment; leave score unchanged.
      if (awarded === 0) s0 += 1;
      else if (awarded === 1) s1 += 1;
    }

    after.set(rallyIndex, [s0, s1]);
  }

  return { before, after, final: [s0, s1] as [number, number] };
}

function computeScoreTimeline_old(rows: any[]) {
  // scoreBefore/scoreAfter per rallyIndex
  const before = new Map<number, [number, number]>();
  const after = new Map<number, [number, number]>();

  let s0 = 0;
  let s1 = 0;

  // Defensive: ensure stable chronological order (your rows are usually already sorted)
  const sorted = [...(Array.isArray(rows) ? rows : [])]
    .filter(Boolean)
    .sort(
      (a, b) => Number(getRallyIndex(a) ?? 0) - Number(getRallyIndex(b) ?? 0),
    );

  for (const r of sorted) {
    const rallyIndex = getRallyIndex(r);
    if (rallyIndex == null) continue;

    // "before" score for this rally
    if (!before.has(rallyIndex)) before.set(rallyIndex, [s0, s1]);

    // Only increment if this row represents a point being awarded
    if (getPointAwarded(r)) {
      let awarded = getPointAwardedTeam(r);

      // ✅ fallback: infer from scoreAfter - scoreBefore
      const b = before.get(rallyIndex) ?? [s0, s1];
      const a = Array.isArray(r.scoreAfter) ? r.scoreAfter : null;

      if (awarded == null && a) {
        if (a[0] === b[0] + 1) awarded = 0;
        if (a[1] === b[1] + 1) awarded = 1;
      }

      if (awarded === 0) s0 += 1;
      else if (awarded === 1) s1 += 1;
    }

    // "after" score for this rally
    after.set(rallyIndex, [s0, s1]);
  }

  return { before, after, final: [s0, s1] as [number, number] };
}

/**
 * A first-pass story builder:
 * - Uses running score / point awarded / serving context if present
 * - Adds: biggest run, run-stopper, comeback attempt, close finish
 *
 * IMPORTANT FIX:
 * - Only considers “point-awarded” rows as scoring events.
 *   Otherwise you get bogus “48 in a row” style run lengths when the report rows
 *   include non-point rows.
 */

/* ----------------------------- component ----------------------------- */
export function computeStory(rows: any[]): GameStory {
  const safeRows = Array.isArray(rows) ? rows.filter(Boolean) : [];

  const sorted = [...safeRows]
    .filter(Boolean)
    .sort(
      (a, b) => Number(getRallyIndex(a) ?? 0) - Number(getRallyIndex(b) ?? 0),
    );

  // Representative row per rallyIndex (for segment bounds / jumping)
  const rowByRally = new Map<number, any>();
  for (const r of sorted) {
    const ri = getRallyIndex(r);
    if (ri == null) continue;
    if (!rowByRally.has(ri)) rowByRally.set(ri, r);
  }

  const scoreTimeline = computeScoreTimeline(sorted);
  const finalScore: [number, number] = scoreTimeline.final;

  // Winner: explicit winning_team preferred, else infer from final score
  let winner: number | null = null;
  for (let i = sorted.length - 1; i >= 0; i--) {
    const wt = getWinningTeam(sorted[i]);
    if (wt === 0 || wt === 1) {
      winner = wt;
      break;
    }
  }
  if (winner == null) {
    if (finalScore[0] > finalScore[1]) winner = 0;
    else if (finalScore[1] > finalScore[0]) winner = 1;
  }

  const fmtScore = (s: [number, number] | null | undefined) =>
    s ? `${s[0]}–${s[1]}` : "—";

  const scoreChanged = (
    before: [number, number] | null | undefined,
    after: [number, number] | null | undefined,
  ) => {
    if (!before || !after) return false;
    return before[0] !== after[0] || before[1] !== after[1];
  };

  // Infer awarded team from score delta (authoritative)
  const awardedTeamFromDelta = (
    before: [number, number] | null,
    after: [number, number] | null,
  ): 0 | 1 | null => {
    if (!before || !after) return null;
    const d0 = after[0] - before[0];
    const d1 = after[1] - before[1];
    if (d0 === 1 && d1 === 0) return 0;
    if (d1 === 1 && d0 === 0) return 1;
    return null;
  };

  const getNumShots = (row: any): number | null => {
    const v =
      row?.numShots ??
      row?.num_shots ??
      row?.shotCount ??
      row?.shot_count ??
      row?.numShotsInRally ??
      row?.insight?.num_shots ??
      null;

    if (typeof v === "number" && Number.isFinite(v)) return v;
    const n = Number(v);
    return Number.isFinite(n) ? n : null;
  };

  const mkByRally = (
    rallyIndex: number,
    title: string,
    detail: string,
    kind?: string,
    pointAwardedToTeam?: 0 | 1 | null,
  ): KeyMoment | null => {
    const r = rowByRally.get(rallyIndex);
    if (!r) return null;

    const seg = getSegmentBounds(r);
    if (!seg) return null;

    return {
      id: `${kind ?? "m"}_${rallyIndex}_${seg.start}`,
      rallyIndex,
      segmentStartMs: seg.start,
      segmentEndMs: seg.end,
      title,
      detail,
      kind,
      pointIndex: rallyIndex, // debug only
      // pointAwardedToTeam: pointAwardedToTeam ?? getPointAwardedTeam(r),

      // Prefer explicit override, else derive from score delta (authoritative)
      pointAwardedToTeam:
        pointAwardedToTeam ??
        awardedTeamFromDelta(
          scoreTimeline.before.get(rallyIndex) ?? null,
          scoreTimeline.after.get(rallyIndex) ?? null,
        ) ??
        getPointAwardedTeam(r),
    };
  };

  type RallyInfo = {
    rallyIndex: number;
    row: any;
    before: [number, number] | null;
    after: [number, number] | null;
    scoredPoint: boolean;
    awardedTo: 0 | 1 | null;
    numShots: number | null;
  };

  const rallies: RallyInfo[] = [];
  const rallyIndices = Array.from(rowByRally.keys()).sort((a, b) => a - b);

  for (const ri of rallyIndices) {
    const r = rowByRally.get(ri);
    if (!r) continue;

    const before = scoreTimeline.before.get(ri) ?? null;
    const after = scoreTimeline.after.get(ri) ?? null;

    const scoredPoint = scoreChanged(before, after);
    const awardedTo = scoredPoint ? awardedTeamFromDelta(before, after) : null;

    rallies.push({
      rallyIndex: ri,
      row: r,
      before,
      after,
      scoredPoint,
      awardedTo,
      numShots: getNumShots(r),
    });
  }

  rallies.sort((a, b) => a.rallyIndex - b.rallyIndex);

  const keyMoments: KeyMoment[] = [];

  // -------------------------
  // Runs (pickleball sane, matching the score strip):
  // "run" = consecutive points by same team (scoring streak).
  // IMPORTANT: run size is derived from score delta from first->last point, not from count.
  // -------------------------
  const scoringRallies = rallies.filter(
    (r) => r.scoredPoint && (r.awardedTo === 0 || r.awardedTo === 1),
  );

  type Run = {
    team: 0 | 1;
    startIdx: number;
    endIdx: number;
  };

  const runs: Run[] = [];
  let curTeam: 0 | 1 | null = null;
  let curStartIdx = -1;

  for (let i = 0; i < scoringRallies.length; i++) {
    const t = scoringRallies[i].awardedTo as 0 | 1 | null;
    if (t !== 0 && t !== 1) continue;

    if (curTeam === t) {
      // continue
    } else {
      // close previous
      if (curTeam != null) {
        runs.push({ team: curTeam, startIdx: curStartIdx, endIdx: i - 1 });
      }
      curTeam = t;
      curStartIdx = i;
    }
  }
  if (curTeam != null && scoringRallies.length > 0) {
    runs.push({
      team: curTeam,
      startIdx: curStartIdx,
      endIdx: scoringRallies.length - 1,
    });
  }

  // Emit only meaningful runs (>= 3 points by score delta)
  for (const run of runs) {
    const startR = scoringRallies[run.startIdx];
    const endR = scoringRallies[run.endIdx];

    const scoreFrom = scoreTimeline.before.get(startR.rallyIndex) ?? null;
    const scoreTo = scoreTimeline.after.get(endR.rallyIndex) ?? null;
    if (!scoreFrom || !scoreTo) continue;

    // run size derived from actual score delta
    const runPoints = scoreTo[run.team] - scoreFrom[run.team];
    if (runPoints < 3) continue;

    // sanity: if score moved weirdly, skip (avoids “(+3)” with +1 score)
    if (runPoints !== scoreTo[run.team] - scoreFrom[run.team]) continue;

    const title = `T${run.team}: ${runPoints}-point run`;
    const detail = `${fmtScore(scoreFrom)} → ${fmtScore(scoreTo)}`;

    const mStart = mkByRally(
      startR.rallyIndex,
      title,
      detail,
      "run_start",
      run.team,
    );
    if (mStart) keyMoments.push(mStart);

    const mEnd = mkByRally(
      endR.rallyIndex,
      `T${run.team}: run ends`,
      detail,
      "run_end",
      run.team,
    );
    if (mEnd) keyMoments.push(mEnd);

    // Sideout that ends the run: first subsequent point by the other team
    const nextIdx = run.endIdx + 1;
    if (nextIdx < scoringRallies.length) {
      const stopR = scoringRallies[nextIdx];
      const stopTeam = stopR.awardedTo;
      if (stopTeam !== run.team && (stopTeam === 0 || stopTeam === 1)) {
        const b = scoreTimeline.before.get(stopR.rallyIndex) ?? null;
        const a = scoreTimeline.after.get(stopR.rallyIndex) ?? null;
        if (b && a && scoreChanged(b, a)) {
          const mStop = mkByRally(
            stopR.rallyIndex,
            `T${stopTeam}: sideout stops their run`,
            `${fmtScore(b)} → ${fmtScore(a)}`,
            "run_stopped",
            stopTeam,
          );
          if (mStop) keyMoments.push(mStop);
        }
      }
    }
  }

  // -------------------------
  // Largest lead checkpoints (team-labeled, only on scored points)
  // -------------------------
  let bestMargin = -1;
  for (const r of scoringRallies) {
    if (!r.before || !r.after) continue;
    const margin = Math.abs(r.after[0] - r.after[1]);
    if (margin <= bestMargin) continue;

    bestMargin = margin;
    if (margin < 3) continue;

    const leader = r.after[0] > r.after[1] ? 0 : 1;
    const m = mkByRally(
      r.rallyIndex,
      `T${leader}: largest lead (${margin})`,
      `${fmtScore(r.before)} → ${fmtScore(r.after)}`,
      "largest_lead",
      r.awardedTo,
    );
    if (m) keyMoments.push(m);
  }

  // -------------------------
  // Longest / shortest rally by shots (neutral, no team claim)
  // -------------------------
  const withShots = rallies.filter((r) => (r.numShots ?? 0) > 0);
  if (withShots.length >= 3) {
    let longest = withShots[0];
    let shortest = withShots[0];

    for (const r of withShots) {
      if ((r.numShots ?? 0) > (longest.numShots ?? 0)) longest = r;
      if ((r.numShots ?? 1e9) < (shortest.numShots ?? 1e9)) shortest = r;
    }

    const shotsDetail = (ri: number): string => {
      const b = scoreTimeline.before.get(ri) ?? null;
      const a = scoreTimeline.after.get(ri) ?? null;
      if (!b) return "";
      if (a && scoreChanged(b, a)) return `${fmtScore(b)} → ${fmtScore(a)}`;
      return `${fmtScore(b)}`;
    };

    const mLong = mkByRally(
      longest.rallyIndex,
      `Longest rally (${longest.numShots} shots)`,
      shotsDetail(longest.rallyIndex),
      "longest_rally",
      longest.awardedTo,
    );
    if (mLong) keyMoments.push(mLong);

    const mShort = mkByRally(
      shortest.rallyIndex,
      `Shortest rally (${shortest.numShots} shots)`,
      shotsDetail(shortest.rallyIndex),
      "shortest_rally",
      shortest.awardedTo,
    );
    if (mShort) keyMoments.push(mShort);
  }

  // -------------------------
  // Final point (jumpable)
  // -------------------------
  if (rallies.length > 0) {
    const last = rallies[rallies.length - 1];
    const mFinal = mkByRally(
      last.rallyIndex,
      `Final point`,
      `Ends ${fmtScore(finalScore)}`,
      "final_point",
      last.awardedTo,
    );
    if (mFinal) keyMoments.push(mFinal);
  }

  // Dedup + sort
  const seen = new Set<string>();
  const deduped = keyMoments
    .filter((m) => {
      if (!m?.id) return false;
      if (seen.has(m.id)) return false;
      seen.add(m.id);
      return true;
    })
    .sort((a, b) => a.rallyIndex - b.rallyIndex);

  return { winner, finalScore, keyMoments: deduped };
}

function hasStakeStoryFilter(
  activeByStake: Partial<Record<StakeKey, StoryFilterKey[]>>,
  stake: StakeKey,
  k: StoryFilterKey,
): boolean {
  const arr = activeByStake[stake] ?? [];
  return arr.includes(k);
}

function toggleStakeStoryFilter(
  activeByStake: Partial<Record<StakeKey, StoryFilterKey[]>>,
  stake: StakeKey,
  k: StoryFilterKey,
): Partial<Record<StakeKey, StoryFilterKey[]>> {
  const curr = activeByStake[stake] ?? [];
  const next = curr.includes(k) ? curr.filter((x) => x !== k) : [...curr, k];
  const out: Partial<Record<StakeKey, StoryFilterKey[]>> = { ...activeByStake };
  if (!next.length) delete out[stake];
  else out[stake] = next;
  return out;
}

function TeamPipsAndCounts(props: { t0: number; t1: number }) {
  return (
    <Box
      component="span"
      sx={{ display: "inline-flex", alignItems: "center", gap: 0.6 }}
    >
      <Box
        sx={{
          width: 6,
          height: 6,
          borderRadius: 999,
          bgcolor: teamRgba(Team_0, 0.95), //) "rgba(80,160,255,0.95)",
        }}
      />
      <Box component="span" sx={{ fontWeight: 800 }}>
        {props.t0}
      </Box>
      {/* <Box component="span" sx={{ opacity: 0.55 }}>–</Box> */}
      <Box
        sx={{
          width: 6,
          height: 6,
          borderRadius: 999,
          // bgcolor: "rgba(120,220,140,0.95)",
          bgcolor: teamRgba(Team_1, 0.95), //) "rgba(80,160,255,0.95)",
        }}
      />
      <Box component="span" sx={{ fontWeight: 800 }}>
        {props.t1}
      </Box>
    </Box>
  );
}

function CountPill(props: {
  n: number;
  bg: string; // rgba(...)
  fg?: string;
  onClick?: () => void;
  selected?: boolean;
}) {
  const { n, bg, fg = "rgba(0,0,0,0.82)", onClick, selected } = props;

  return (
    <Box
      onClick={onClick}
      sx={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        minWidth: 22,
        height: 18,
        px: 0.9,
        borderRadius: 999,
        fontSize: 10,
        fontWeight: 900,
        lineHeight: 1,
        color: fg,
        bgcolor: bg,
        ml: 0.55,

        cursor: onClick ? "pointer" : "default",
        userSelect: "none",

        border: selected
          ? "1px solid rgba(0,0,0,0.55)"
          : "1px solid rgba(0,0,0,0.18)",
        boxShadow: selected ? "0 0 0 2px rgba(255,255,255,0.28)" : "none",

        "&:hover": { filter: "brightness(1.05)" },
      }}
    >
      {/* {n} */}

      <Box sx={{ display: "inline-flex", alignItems: "center", gap: 0.35 }}>
        {selected ? <DoneIcon sx={{ fontSize: 12 }} /> : null}
        <span>{n}</span>
      </Box>
    </Box>
  );
}

function CountPill_old(props: {
  n: number;
  bg: string; // rgba(...)
  fg?: string; // text color
}) {
  const { n, bg, fg = "rgba(0,0,0,0.82)" } = props;

  const isZero = n === 0;

  const chipBg = "rgba(255,255,255,0.92)"; // or whatever you like

  const bg0 = bg; //pillBg(bg, isZero, chipBg);

  return (
    <Box
      sx={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        minWidth: 22,
        height: 18,
        px: 0.9,
        borderRadius: 999,
        fontSize: 10,
        fontWeight: 900,
        lineHeight: 1,
        color: fg,

        // ✅ subtle background (was likely too saturated)
        bgcolor: bg0, //bg, //isZero ? "rgba(0,0,0,0.06)" : bg,

        // ✅ thin outline helps legibility on light/grey chip bg
        // border: isZero
        //   ? "1px solid rgba(0,0,0,0.08)"
        //   : "1px solid rgba(0,0,0,0.12)",
        textShadow: "1px 1px 1px rgba(255,255,255,0.5)",
        boxShadow: "0 0 0 1px rgba(0,0,0,0.10) inset",

        // ✅ tiny inner highlight keeps it “pill-y” without adding clutter
        // boxShadow: "inset 0 1px 0 rgba(255,255,255,0.65)",
      }}
    >
      {n}
    </Box>
  );
}

export type RallyBadge = { stake: StakeKey; key: StoryFilterKey; team: Team01 };

//export const rallyBadges = new Map<number, RallyBadge[]>();

export type StakeReasonTeamFilters = Partial<
  Record<
    StakeKey,
    Partial<Record<StoryFilterKey, Partial<Record<Team01, true>>>>
  >
>;

function otherTeam(t: Team01): Team01 {
  return t === 0 ? 1 : 0;
}

function normalizeKind(s: string): string {
  return String(s).trim().toLowerCase().replace(/\s+/g, "_");
}

function kindSet(o: ShotNumberOverlay): Set<string> {
  const out = new Set<string>();
  for (const k of o.storyKinds ?? []) out.add(normalizeKind(k));
  const ks = (o.story as any)?.kinds;
  if (Array.isArray(ks)) for (const k of ks) out.add(normalizeKind(k));
  return out;
}

const REASON_KIND_ALIASES: Record<StoryFilterKey, string[]> = {
  missedServe: ["missed_serve"],
  missedReturn: ["missed_return", "return_missed", "fault_return"],
  missed3rdDrop: ["missed_3rd_drop", "third_drop_missed", "3rd_drop_missed"],
  missed3rdDrive: [
    "missed_3rd_drive",
    "third_drive_missed",
    "3rd_drive_missed",
  ],

  faultNet: ["fault_net", "net", "tape", "fault_type:net"],
  faultOut: ["fault_out", "out", "end_zone:out", "fault_type:out"],
  unforcedError: ["unforced_error"],
  forcedFault: ["forced_fault", "winner_type:forced_fault"],
  popupExploited: ["popup_exploited", "popup:exploited"],
};

function attributedTeamForReason(
  o: ShotNumberOverlay,
  reason: StoryFilterKey,
): Team01 | null {
  const shooterTeam = teamOfPlayerId(o.playerId);

  if (shooterTeam == null) return null;

  // IMPORTANT: align to matchFilter() semantics (errTeam = losing side)
  if (reason === "forcedFault" || reason === "popupExploited") {
    return otherTeam(shooterTeam);
  }

  // Most other “error on this shot” reasons: shooter is the error team.
  return shooterTeam;
}

export function shotMatchesFocusedFilter(
  o: ShotNumberOverlay,
  f: FocusedReasonStakeForTeam,
): boolean {
  const kinds = kindSet(o);
  const hasAnyKind = (arr: string[]) =>
    arr.some((k) => kinds.has(normalizeKind(k)));

  // 0) If you ever explicitly set focusedBadge upstream, trust it.
  if (o.focusedBadge) {
    return (
      o.focusedBadge.team === f.team &&
      o.focusedBadge.reason === f.reason &&
      o.focusedBadge.stake === f.stake
    );
  }

  // 1) Must attribute to focused team (NOT necessarily shooter team)
  const attributed = attributedTeamForReason(o, f.reason);
  if (attributed !== f.team) return false;

  // 2) If stake tags exist in kinds, enforce; otherwise do not block on stake.
  // (Shots usually can’t know stake unless you explicitly add it.)
  const stakeTagA = normalizeKind(`stake:${f.stake}`);
  const stakeTagB = normalizeKind(`stake_${f.stake}`);
  const hasStakeTag = kinds.has(stakeTagA) || kinds.has(stakeTagB);

  if (hasStakeTag) {
    // only pass if stake tag matches (it does, because we built from f)
    // (if you later add multiple stake tags, tighten this)
  }

  // 3) Match via known kind aliases
  if (hasAnyKind(REASON_KIND_ALIASES[f.reason])) return true;

  if (o.rallyIndex === 7) {
// console.error("rally index 7", o?.shotNumber, o?.rallyIndex, o?.rawShot);
  }
  // 4) Field-based fallback (when kinds missing)
  switch (f.reason) {
    case "faultNet":
      return (
        o.faultType === "net" ||
        kinds.has("fault_net") ||
        o?.rawShot?.errors?.faults?.net === true
      );

    //  "errors": {
    //       "faults": {
    //         "net": true,
    //         "short": false,
    //         "kitchen": false,
    //         "excess_bounce": false,
    //         "paddle_hit_net": false

    case "faultOut":
      return (
        o.faultType === "out" ||
        o.endZone === "out" ||
        kinds.has("fault_out") ||
        kinds.has("end_zone:out") ||
        o.rawShot?.resulting_ball_movement?.trajectory?.end?.zone === "out"
      );

    case "popupExploited":
      return (
        o.popupExploited === true ||
        kinds.has("popup_exploited") ||
        o?.rawShot?.errors?.popup === "exploited"
      );

    case "forcedFault":
      return o.winnerType === "forced_fault" || kinds.has("forced_fault");

    case "unforcedError":
      return o?.rawShot?.errors?.unforced === true; // && o.winnerType !== "forced_fault";

    default:
      return false;
  }
}

export function EmojiIcon(props: {
  children: string; // the emoji glyph
  size?: number; // px
  y?: number; // px baseline tweak (negative lifts)
  opacity?: number;
}) {
  const { children, size = 14, y = -0.5, opacity = 1 } = props;

  return (
    <Box
      component="span"
      sx={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        width: size,
        height: size,
        fontSize: size,
        lineHeight: `${size}px`,
        transform: `translateY(${y}px)`,
        opacity,
        userSelect: "none",
      }}
    >
      {children}
    </Box>
  );
}

export function DinkSvgIcon(props: { size: number; color?: string }) {
  const { size, color = "rgba(255,255,255,0.9)" } = props;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      role="img"
      aria-label="Dinks"
      style={{ display: "inline-block", verticalAlign: "middle" }}
    >
      {/* Net line */}
      <path
        d="M4 12.2 H20"
        fill="none"
        stroke={color} // "rgba(0,0,0,0.9)"}
        strokeWidth="1.8"
        strokeLinecap="round"
        opacity="0.55"
      />

      {/* Cross-court dink arc (single) */}
      <path
        d="M6.2 17.6 C10.2 15.1, 12.1 14.1, 13.0 12.2 C13.9 10.4, 15.9 8.8, 18.0 6.9"
        fill="none"
        stroke={color}
        strokeWidth="1.6"
        strokeLinecap="round"
        opacity="0.95"
      />

      {/* Ball dots */}
      <circle cx="6.2" cy="17.6" r="2.7" fill={"yellow"} opacity="0.95" />
      <circle cx="18.0" cy="6.9" r="2.7" fill={"yellow"} opacity="0.95" />
    </svg>
  );
}

export function iconDinks(size: number, color?: string) {
  return <DinkSvgIcon size={size} color={color} />;
}

export function DinkSvgIcon_first(props: { size: number; color?: string }) {
  const { size, color = "rgba(255,255,255,0.9)" } = props;

  // ViewBox is 24x24 to match MUI icon conventions.
  // Strokes are kept fairly thick so it reads at small sizes.
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      role="img"
      aria-label="Dinks"
      style={{ display: "inline-block", verticalAlign: "middle" }}
    >
      {/* Net line */}
      <path
        d="M4 12.5 H20"
        fill="none"
        stroke={color}
        strokeWidth="1.6"
        strokeLinecap="round"
        opacity="0.55"
      />

      {/* Cross-court exchange arcs (two opposing diagonals) */}
      <path
        d="M6 18 C9 15, 11 14, 12 12.5 C13 11, 15 9, 18 6"
        fill="none"
        stroke={color}
        strokeWidth="2.1"
        strokeLinecap="round"
        opacity="0.95"
      />
      <path
        d="M6 6 C9 9, 11 10, 12 12.5 C13 14, 15 15, 18 18"
        fill="none"
        stroke={color}
        strokeWidth="2.1"
        strokeLinecap="round"
        opacity="0.65"
      />

      {/* “Ball” dots at ends */}
      <circle cx="6" cy="18" r="3.7" fill={"yellow"} opacity="0.95" />
      <circle cx="18" cy="6" r="3.7" fill={"yellow"} opacity="0.95" />

      {/* Optional subtle mid-dot (gives “rally” feel) */}
      <circle cx="12" cy="12.5" r="1.2" fill={color} opacity="0.55" />
    </svg>
  );
}

export function iconDinks_first(size: number, color?: string) {
  return <DinkSvgIcon size={size} color={color} />;
}

export function iconLob(size: number, color?: string) {
  // emoji ignores color; keep arg for signature consistency
  return <EmojiIcon size={size}>🎈</EmojiIcon>;
}

export function iconReaction(size: number, color?: string) {
  if (!color) color = "rgba(255,255,255,0.9)";
  // return <EmojiIcon size={size}>⏱</EmojiIcon>;
  return <TimerOutlinedIcon sx={{ fontSize: size, color: color }} />;
}

export function iconFastShot(size: number) {
  return <EmojiIcon size={size}>🚀</EmojiIcon>;
}

export type CourtPlayerPos = { x: number; y: number };

export type PlayerIndexMap = [number, number, number, number];

// export type PlayerIndexMap = {
//   insightsToCvPlayerIndex: [number, number, number, number];
//   playerIdToAvatarBase64: Record<number, string | null | undefined>;
// };

const IDENTITY_PLAYER_INDEX_MAP: PlayerIndexMap = [0, 1, 2, 3];

function sqDistPos(
  a: CourtPlayerPos | null | undefined,
  b: CourtPlayerPos | null | undefined,
) {
  if (!a || !b) return Number.POSITIVE_INFINITY;
  const dx = a.x - b.x;
  const dy = a.y - b.y;
  return dx * dx + dy * dy;
}

function buildPlayerIndexPermutations(): PlayerIndexMap[] {
  const nums = [0, 1, 2, 3];
  const out: PlayerIndexMap[] = [];

  function rec(prefix: number[], remaining: number[]) {
    if (remaining.length === 0) {
      out.push(prefix as PlayerIndexMap);
      return;
    }
    for (let i = 0; i < remaining.length; i++) {
      rec(
        [...prefix, remaining[i]],
        [...remaining.slice(0, i), ...remaining.slice(i + 1)],
      );
    }
  }

  rec([], nums);
  return out;
}

const ALL_PLAYER_INDEX_PERMUTATIONS = buildPlayerIndexPermutations();

function getOverlayPlayerPositions(
  ov: ShotNumberOverlay | null | undefined,
): Array<CourtPlayerPos | null> | null {
  if (!ov) return null;

  const src = ov.player_positions ?? ov.rawShot?.player_positions ?? null;

  if (!Array.isArray(src) || src.length < 4) return null;

  return [0, 1, 2, 3].map((i) => {
    const p = src[i];
    if (!p || typeof p.x !== "number" || typeof p.y !== "number") return null;
    return { x: p.x, y: p.y };
  });
}

function getCvCourtPositionsAtPlayhead(args: {
  cvJson: CvJson | null | undefined;
  rallyIndex: number | null | undefined;
  playheadSec: number;
}): Array<CourtPlayerPos | null> | null {
  const { cvJson, rallyIndex, playheadSec } = args;

  if (!cvJson) return null;
  if (rallyIndex == null || rallyIndex < 0) return null;

  const session = cvJson.sessions?.[0];
  const rally = session?.rallies?.[rallyIndex];
  const frames = rally?.frames;
  if (!Array.isArray(frames) || frames.length === 0) return null;

  const fpsRaw = cvJson.camera?.fps;
  const fps =
    typeof fpsRaw === "number" && Number.isFinite(fpsRaw) && fpsRaw > 0
      ? fpsRaw
      : 29.97;

  const exactFrame = Math.max(0, playheadSec * fps);
  const lo = Math.max(0, Math.floor(exactFrame));
  const hi = Math.min(frames.length - 1, Math.ceil(exactFrame));
  const t = Math.max(0, Math.min(1, exactFrame - lo));

  const out: Array<CourtPlayerPos | null> = [];

  for (let playerId = 0; playerId < 4; playerId++) {
    const loPos = frames[lo]?.player_court_positions?.[playerId];
    const hiPos = frames[hi]?.player_court_positions?.[playerId];

    if (!loPos || typeof loPos.x !== "number" || typeof loPos.y !== "number") {
      out.push(null);
      continue;
    }

    const x =
      hiPos && typeof hiPos.x === "number"
        ? loPos.x + (hiPos.x - loPos.x) * t
        : loPos.x;

    const y =
      hiPos && typeof hiPos.y === "number"
        ? loPos.y + (hiPos.y - loPos.y) * t
        : loPos.y;

    out.push({ x, y });
  }

  return out;
}

function scorePlayerIndexMap(args: {
  rows: KitchenArrivalRow[];
  cvJson: CvJson | null | undefined;
  map: PlayerIndexMap;
}) {
  const { rows, cvJson, map } = args;
  if (!cvJson) return Number.POSITIVE_INFINITY;

  let total = 0;
  let used = 0;

  const sortedRows = [...rows].sort((a, b) => a.rallyIndex - b.rallyIndex);

  outer: for (const r of sortedRows) {
    const overlays = r.shotNumberOverlays as ShotNumberOverlay[] | undefined;
    if (!Array.isArray(overlays) || overlays.length === 0) continue;

    for (const ov of overlays) {
      const insightsPositions = getOverlayPlayerPositions(ov);
      if (!insightsPositions) continue;

      const tSec = Math.max(0, (ov.atMsRel ?? 0) / 1000);
      const cvPositions = getCvCourtPositionsAtPlayhead({
        cvJson,
        rallyIndex: r.rallyIndex,
        playheadSec: tSec,
      });

      if (!cvPositions) continue;

      let shotScore = 0;
      let shotUsed = 0;

      for (let insightsPlayerId = 0; insightsPlayerId < 4; insightsPlayerId++) {
        const insightsPos = insightsPositions[insightsPlayerId];
        const cvPos = cvPositions[map[insightsPlayerId]];
        const d = sqDistPos(insightsPos, cvPos);
        if (!Number.isFinite(d)) continue;
        shotScore += d;
        shotUsed += 1;
      }

      if (shotUsed >= 3) {
        total += shotScore;
        used += 1;
      }

      if (used >= 12) break outer;
    }
  }

  if (used === 0) return Number.POSITIVE_INFINITY;
  return total / used;
}

function deriveInsightsToCvPlayerIndexMap_old(args: {
  rows: KitchenArrivalRow[];
  cvJson: CvJson | null | undefined;
}): PlayerIndexMap {
  const { rows, cvJson } = args;
  if (!cvJson || !rows.length) return IDENTITY_PLAYER_INDEX_MAP;

  let bestMap = IDENTITY_PLAYER_INDEX_MAP;
  let bestScore = Number.POSITIVE_INFINITY;

  for (const candidate of ALL_PLAYER_INDEX_PERMUTATIONS) {
    const score = scorePlayerIndexMap({
      rows,
      cvJson,
      map: candidate,
    });

    if (score < bestScore) {
      bestScore = score;
      bestMap = candidate;
    }
  }

  return bestMap;
}

function deriveInsightsToCvPlayerIndexMapFromAvatarIds(
  insightsJson: InsightsJson | null | undefined,
): PlayerIndexMap | null {
  const players = insightsJson?.player_data;
  if (!players || players.length < 4) return null;

  const ids = players.slice(0, 4).map((p) => p?.avatar_id);

  if (
    ids.length !== 4 ||
    ids.some((id) => typeof id !== "number") ||
    new Set(ids).size !== 4 ||
    ids.some((id) => id! < 0 || id! > 3)
  ) {
    return null;
  }

  return ids as PlayerIndexMap;
}

function deriveInsightsToCvPlayerIndexMapFromGeometry(args: {
  rows: KitchenArrivalRow[];
  cvJson: CvJson | null | undefined;
}): PlayerIndexMap {
  const { rows, cvJson } = args;
  if (!cvJson || !rows.length) return IDENTITY_PLAYER_INDEX_MAP;

  let bestMap = IDENTITY_PLAYER_INDEX_MAP;
  let bestScore = Number.POSITIVE_INFINITY;

  for (const candidate of ALL_PLAYER_INDEX_PERMUTATIONS) {
    const score = scorePlayerIndexMap({
      rows,
      cvJson,
      map: candidate,
    });

    if (score < bestScore) {
      bestScore = score;
      bestMap = candidate;
    }
  }

  return bestMap;
}
function deriveInsightsToCvPlayerIndexMap(args: {
  insightsJson: InsightsJson | null | undefined;
  rows: KitchenArrivalRow[];
  cvJson: CvJson | null | undefined;
}): PlayerIndexMap {
  const { insightsJson, rows, cvJson } = args;

  const avatarIdMap =
    deriveInsightsToCvPlayerIndexMapFromAvatarIds(insightsJson);
  if (avatarIdMap) {
// console.error("must drive player from avatar IDs");
    return avatarIdMap;
  }

// console.error(
// "must drive player index map from geometry; avatar IDs missing or invalid",
// );

  return deriveInsightsToCvPlayerIndexMapFromGeometry({
    rows,
    cvJson,
  });
}

export type RenderPlayerIdentityArgs = {
  playerId: number | null | undefined;
  labelOnly?: boolean;
  size: number;
  borderRadius?: number;
  fontSize?: number;
  fontColor?: string;
  noLabel?: boolean;
  borderWidth?: number | string;
  avatarOnly?: boolean;
};

export type RenderPlayerIdentity = (
  args: RenderPlayerIdentityArgs,
) => React.ReactNode | null;

export function toDisplayPlayerId(
  insightsPlayerId: number,
  insightsToCvPlayerIndex: PlayerIndexMap,
): number {
  return insightsToCvPlayerIndex[insightsPlayerId] ?? insightsPlayerId;
}

export function toDisplayPlayerLabel(
  insightsPlayerId: number,
  insightsToCvPlayerIndex: PlayerIndexMap,
): string {
  return `p${toDisplayPlayerId(insightsPlayerId, insightsToCvPlayerIndex)}`;
}

export function renderIdentityFromInsightsPlayerId(args: {
  insightsPlayerId: number;
  insightsToCvPlayerIndex: PlayerIndexMap;
  renderPlayerIdentity: RenderPlayerIdentity;
  size: number;
  fontSize: number;
  borderRadius: number;
  fontColor?: string;
}) {
  const {
    insightsPlayerId,
    insightsToCvPlayerIndex,
    renderPlayerIdentity,
    size,
    fontSize,
    borderRadius,
    fontColor,
  } = args;

  return renderPlayerIdentity({
    playerId: toDisplayPlayerId(insightsPlayerId, insightsToCvPlayerIndex),
    size,
    fontSize,
    borderRadius,
    fontColor,
  });
}

// 1) new: the inline panel (same content)
export function GameStoryPanel(props: {
  packageId: string;
  onSetTopMatchOutcomeBanner?: (node: React.ReactNode) => void;
  openQuickTriage?: boolean;
  onCloseQuickTriage: () => void;
  onLoadingChange?: (loading: boolean) => void;
  openSingleTopFocus?: boolean;
  onCloseSingleTopFocus: () => void;
  openThreeMinuteReview?: boolean;
  onCloseThreeMinuteReview: () => void;
  openPlayerLensReview?: boolean;
  onClosePlayerLensReview: () => void;
  openPositioningPatterns?: boolean;
  onClosePositioningPatterns: () => void;
  featureLaunchRequest?: { key: string; nonce: number } | null;
}) {
  const groupLabelLeft = "22px";
  const filterButtonSx = {
    // pill container
    borderRadius: 1,
    px: 1.25,
    py: 0.5,
    minHeight: 30,

    // legibility
    fontSize: 13,
    fontWeight: 600,
    textTransform: "none",
    color: "#66b3ff",

    // subtle structure
    border: "1px solid rgba(102,179,255,0.35)",
    backgroundColor: "rgba(102,179,255,0.08)",

    marginLeft: "12px",
    "&:hover": {
      backgroundColor: "rgba(102,179,255,0.18)",
      borderColor: "rgba(102,179,255,0.6)",
    },

    // icon styling
    "& .MuiButton-startIcon": {
      marginRight: "6px",
    },
    "& .MuiButton-startIcon > *:nth-of-type(1)": {
      // ensures SVG inherits the readable blue
      color: "inherit",
      fontSize: 18,
    },
  };

  const [openRallyCausalityOverviewPopup, setOpenRallyCausalityOverviewPopup] =
    React.useState(false);

  const [openRallyQualityOverviewPopup, setOpenRallyQualityOverviewPopup] =
    React.useState(false);
  const [rallyQualityOverviewAnchorEl, setRallyQualityOverviewAnchorEl] =
    React.useState<HTMLElement | null>(null);

  const [focusedPlayerId, setFocusedPlayerId] = React.useState<number | null>(
    null,
  );

  // CondensedRallyTimeline reads badge data from a ref so it can access
  // the latest computed rally badge map without re-plumbing all callers.
  const rallyBadgesRef = React.useRef<Map<number, RallyBadge[]>>(new Map());

  const [openAllVideos, setOpenAllVideos] = React.useState(false);

  const FAST_REACTION_MS_OPTIONS = [
    250, 300, 350, 400, 500, 600, 700, 800,
  ] as const;
  const FAST_SHOT_MPH_OPTIONS = [20, 25, 30, 35, 40, 45, 50, 55, 60] as const;

  const [askOpen, setAskOpen] = React.useState(false);

  const ASK_W_OPEN = 420; // tweak
  const ASK_W_CLOSED = 32; //46; // tweak (enough for an icon button)

  const [openExperimentSingleTopFocus, setOpenExperimentSingleTopFocus] =
    React.useState(false);
  const [
    openExperimentPositioningPatterns,
    setOpenExperimentPositioningPatterns,
  ] = React.useState(false);
  const [openTrajectoryWall, setOpenTrajectoryWall] = React.useState(false);
  const [openShotUniverse, setOpenShotUniverse] = React.useState(false);
  const [openOpportunityFinder, setOpenOpportunityFinder] = React.useState(false);

  const [openGameAiPopup, setOpenGameAiPopup] = React.useState(false);
  const [openPointsAddedPopup, setOpenPointsAddedPopup] = React.useState(false);
  const [matchIdentityOpen, setMatchIdentityOpen] = React.useState(false);

  const openExperiment = React.useCallback((experimentKey: string) => {
    switch (experimentKey) {
      case "positioningPatterns":
        setOpenExperimentPositioningPatterns(true);
        break;
      case "matchIdentity":
        setMatchIdentityOpen(true);
        break;
      case "rallyCausality":
        setOpenRallyCausalityOverviewPopup(true);
        break;
      case "singleTopFocus":
        setOpenExperimentSingleTopFocus(true);
        break;
      case "trajectoryWall":
        setOpenTrajectoryWall(true);
        break;
      case "pointsAddedReport":
        setOpenPointsAddedPopup(true);
        break;
      case "shotUniverse":
        setOpenShotUniverse(true);
        break;
      default:
        break;
    }
  }, []);


  const [aiHistoryOpen, setAiHistoryOpen] = React.useState(false);
  const [openThirdShotPopup, setOpenThirdShotPopup] = React.useState(false);
  const [thirdShotAnchorEl, setThirdShotAnchorEl] =
    React.useState<HTMLElement | null>(null);

  const [openFourthShotPopup, setOpenFourthShotPopup] = React.useState(false);
  const [fourthShotAnchorEl, setFourthShotAnchorEl] =
    React.useState<HTMLElement | null>(null);

  const [openFifthShotPopup, setOpenFifthShotPopup] = React.useState(false);
  const [fifthShotAnchorEl, setFifthShotAnchorEl] =
    React.useState<HTMLElement | null>(null);

  const [openDinkSegmentsPopup, setOpenDinkSegmentsPopup] =
    React.useState(false);

  const [openErnePopup, setOpenErnePopup] = React.useState(false);
  const [openAtpPopup, setOpenAtpPopup] = React.useState(false);
  const [openCandidateSpeedupsPopup, setOpenCandidateSpeedupsPopup] =
    React.useState(false);
  const [openCandidateBodybagsPopup, setOpenCandidateBodybagsPopup] =
    React.useState(false);
  const [openPossiblePopupsPopup, setOpenPossiblePopupsPopup] =
    React.useState(false);
  const [openPaddleReadinessPopup, setOpenPaddleReadinessPopup] =
    React.useState(false);
  const [openDinkReadinessPopup, setOpenDinkReadinessPopup] =
    React.useState(false);
  const [openLeftSideCoveragePopup, setOpenLeftSideCoveragePopup] =
    React.useState(false);

  const [serveOpen, setServeOpen] = React.useState(false);
  const [returnOpen, setReturnOpen] = React.useState(false);

  const [serveAnchorEl, setServeAnchorEl] = React.useState<HTMLElement | null>(
    null,
  );
  const [returnAnchorEl, setReturnAnchorEl] =
    React.useState<HTMLElement | null>(null);
  const [serveReturnRiskAnchorEl, setServeReturnRiskAnchorEl] =
    React.useState<HTMLElement | null>(null);

  const [openServePopup, setOpenServePopup] = React.useState(false);
  const [openReturnPopup, setOpenReturnPopup] = React.useState(false);
  const [openServeReturnRiskPopup, setOpenServeReturnRiskPopup] =
    React.useState(false);

  const [dinkSegmentsAnchorEl, setDinkSegmentsAnchorEl] =
    React.useState<HTMLElement | null>(null);

  const [erneAnchorEl, setErneAnchorEl] = React.useState<HTMLElement | null>(
    null,
  );
  const [atpAnchorEl, setAtpAnchorEl] = React.useState<HTMLElement | null>(
    null,
  );

  // knobs (keep simple)
  const [dinkMinPhaseShots, setDinkMinPhaseShots] = React.useState<number>(6);
  const [dinkGapAllowedShots, setDinkGapAllowedShots] =
    React.useState<number>(1);

  const [activeStoryFiltersByStake, setActiveStoryFiltersByStake] =
    React.useState<Partial<Record<StakeKey, StoryFilterKey[]>>>(() => ({}));

  const [stakesFilter, setStakesFilter] = React.useState<StakesFilter>("all");

  const [activeStoryFilters, setActiveStoryFilters] =
    React.useState<StakeReasonTeamFilters>({});

  const [activeStakeFilters, setActiveStakeFilters] = React.useState<
    StakeKey[]
  >(() => []);

  const {
    packageId,
    onSetTopMatchOutcomeBanner,
    openQuickTriage,
    onCloseQuickTriage,
    onLoadingChange,
    openSingleTopFocus,
    onCloseSingleTopFocus,
    openThreeMinuteReview,
    onCloseThreeMinuteReview,
    openPlayerLensReview,
    onClosePlayerLensReview,
    openPositioningPatterns,
    onClosePositioningPatterns,
    featureLaunchRequest,
  } = props;

  const [rows, setRows] = React.useState<KitchenArrivalRow[]>([]);
  const [turnsByKey, setTurnsByKey] = React.useState<Record<string, any[]>>({});
  const [loading, setLoading] = React.useState(false);
  const [err, setErr] = React.useState<string | null>(null);

  const [iInsightsJson, setInsightsJson] = React.useState<InsightsJson | null>(
    null,
  );

  const playerIdToTeamMap = React.useMemo(
    () => buildPlayerIdToTeamMap(iInsightsJson),
    [iInsightsJson],
  );

  const playerIdToTeamForPopup = React.useCallback(
    (playerId: number | null): Team01 | null => {
      if (playerId == null) return null;
      return teamOfPlayerIdFromMap(playerId, playerIdToTeamMap);
    },
    [playerIdToTeamMap],
  );

  const [cvJson, setCvJson] = React.useState<CvJson | null>(null);

  const [firefightClips, setFirefightClips] = React.useState<FirefightClip[]>(
    [],
  );

  const [activeRow, setActiveRow] = React.useState<KitchenArrivalRow | null>(
    null,
  );

  const [hoveredBadge, setHoveredBadge] = React.useState<RallyBadge | null>(
    null,
  );

  const [activeShotNumber, setActiveShotNumber] = React.useState<number | null>(
    null,
  );
  const [shotUniverseOpenShotNumber, setShotUniverseOpenShotNumber] =
    React.useState<number | null>(null);
  const [shotUniverseOpportunityContext, setShotUniverseOpportunityContext] =
    React.useState<ShotOpportunityLabContext | null>(null);
  const [pendingShotUniverseOpenShotNumber, setPendingShotUniverseOpenShotNumber] =
    React.useState<number | null>(null);
  const { bookmarks: shotBookmarks } = useShotBookmarks(packageId);
  const [shotBookmarksOpen, setShotBookmarksOpen] = React.useState(false);
  const [bookmarkPlaybackSeed, setBookmarkPlaybackSeed] = React.useState<{
    timeSec: number;
    paused: boolean;
    nonce: number;
  } | null>(null);
  const [mainPlaybackSeed, setMainPlaybackSeed] = React.useState<{
    rallyIndex: number;
    timeSec: number;
    paused: boolean;
    nonce: number;
  } | null>(null);
  const [mainLoopSeed, setMainLoopSeed] = React.useState<{
    rallyIndex: number;
    enabled: boolean;
    aSec: number;
    bSec: number;
    nonce: number;
  } | null>(null);
  const [shotUniverseBookmarkRestore, setShotUniverseBookmarkRestore] =
    React.useState<{ bookmark: ShotBookmark; nonce: number } | null>(null);
  const [pendingVideoBookmark, setPendingVideoBookmark] = React.useState<{
    rallyIndex: number;
    shotNumber: number;
    timeSec: number | null;
    playerId: number | null;
  } | null>(null);
  const [videoBookmarkDescriptionDraft, setVideoBookmarkDescriptionDraft] =
    React.useState("");

  const [matchImpactFacts, setMatchImpactFacts] =
    React.useState<MatchImpactFacts | null>(null);

  const [sideOutGameInfluenceReport, setSideOutGameInfluenceReport] =
    React.useState<SideoutGameInfluenceReport | null>(null);

  const [playerIdToAvatarBase64, setPlayerIdToAvatarBase64] = React.useState<
    Record<number, string>
  >({});

  const [pounceWindowRows, setPounceWindowRows] = React.useState<
    PounceWindowRow[]
  >([]);

  function isTeamSelected(
    stake: StakeKey,
    reason: StoryFilterKey,
    team: Team01,
  ): boolean {
    return !!activeStoryFilters?.[stake]?.[reason]?.[team];
  }

  function toggleTeam(stake: StakeKey, reason: StoryFilterKey, team: Team01) {
    setActiveStoryFilters((prev) => {
      const next: StakeReasonTeamFilters = { ...(prev ?? {}) };

      const stakeObj = { ...(next[stake] ?? {}) };
      const reasonObj = { ...(stakeObj[reason] ?? {}) };

      if (reasonObj[team]) {
        // turn off
        const { [team]: _removed, ...restTeams } = reasonObj;
        if (Object.keys(restTeams).length === 0) {
          // remove reason
          const { [reason]: _r, ...restReasons } = stakeObj;
          next[stake] = restReasons;
          if (Object.keys(restReasons).length === 0) {
            const { [stake]: _s, ...restStakes } = next;
            return restStakes;
          }
        } else {
          stakeObj[reason] = restTeams as any;
          next[stake] = stakeObj;
        }
      } else {
        // turn on
        reasonObj[team] = true;
        stakeObj[reason] = reasonObj as any;
        next[stake] = stakeObj;
      }

      return next;
    });
  }

  function clearStake(stake: StakeKey) {
    setActiveStoryFilters((prev) => {
      const next = { ...(prev ?? {}) };
      delete next[stake];
      return next;
    });
  }

  function clearAll() {
    setActiveStoryFilters({});
  }

  const [timelineBarsH, setTimelineBarsH] = React.useState<number>(80);
  const resizeDragRef = React.useRef<{
    startY: number;
    startH: number;
  } | null>(null);

  const clearAllStoryFilters = React.useCallback(() => {
    setActiveStoryFilters({});
    setActiveStoryFiltersByStake({});
    setActiveStakeFilters([]);
    setStakesFilter("all");
    setFocusedPlayerId(null);
  }, [
    setActiveStoryFilters,
    setActiveStoryFiltersByStake,
    setActiveStakeFilters,
    setStakesFilter,
    setFocusedPlayerId,
  ]);

  React.useEffect(() => {
    if (!packageId || !rows?.length) return;

    const next: Record<string, AiTurn[]> = {};

    for (const row of rows) {
      if (!row || typeof row.rallyIndex !== "number") continue;

      const stored = readPerRallyTurns(packageId, row.rallyIndex);
      if (stored.length > 0) {
        next[rallyKey(row)] = stored;
      }
    }

    setTurnsByKey(next);
  }, [packageId, rows]);

  // const selectedRallyBadges = React.useMemo(() => {
  //   const rallyIndex = activeRow?.rallyIndex ?? null;
  //   if (rallyIndex == null) return [];
  //   return rallyBadges.get(rallyIndex) ?? [];
  // }, [activeRow?.rallyIndex, rallyBadges]);

  const addBadge = (rallyIndex: number, b: RallyBadge) => {
    const arr = rallyBadgesRef.current.get(rallyIndex);
    if (arr) arr.push(b);
    else rallyBadgesRef.current.set(rallyIndex, [b]);
  };

  const insightsToCvPlayerIndex = React.useMemo(() => {
    return deriveInsightsToCvPlayerIndexMap({
      insightsJson: iInsightsJson,
      rows,
      cvJson,
    });
  }, [rows, cvJson, iInsightsJson]);

  //   const singleTopFocusResult = React.useMemo(() => {
  //   if (!iInsightsJson || focusedPlayerId == null) return null;

  //   return buildSingleTopFocus({
  //     insightsJson:iInsightsJson,
  //     cvJson,
  //     pounceWindowRows,
  //     selectedPlayerId:focusedPlayerId,
  //   });
  // }, [iInsightsJson, cvJson, pounceWindowRows, focusedPlayerId]);

  // const singleTopFocusCard = React.useMemo(() => {
  //   if (!iInsightsJson || focusedPlayerId == null) return null;

  //   return buildSingleTopFocusCard({
  //     insightsJson: iInsightsJson,
  //     cvJson,
  //     pounceWindowRows,
  //     selectedPlayerId:focusedPlayerId,
  //   });
  // }, [iInsightsJson, cvJson, pounceWindowRows, focusedPlayerId]);

  //     const playerIdentityDisplayMap = React.useMemo(() => {
  //   return buildPlayerIdentityDisplayMap({
  //     playerIdToAvatarBase64,
  //   });
  // }, [playerIdToAvatarBase64]);

  const renderPlayerIdentity_old = React.useCallback<RenderPlayerIdentity>(
    ({
      playerId,
      labelOnly = false,
      size, // = 30,
      borderRadius = 6,
      fontSize = 11,
    }) => {
      if (playerId == null) return null;

      if (labelOnly) {
        return `P${playerId}`;
      }

      const raw = playerIdToAvatarBase64?.[playerId];

      if (typeof raw === "string" && raw.trim()) {
        const src = raw.startsWith("data:")
          ? raw
          : `data:image/jpeg;base64,${raw}`;

        return (
          <Box
            className="player-avatar"
            sx={{
              width: size,
              height: size,
              borderRadius: `${borderRadius}px`,
              overflow: "hidden", // "visible", // "hidden",
              display: "block",
              boxSizing: "border-box",
            }}
          >
            <img
              src={src}
              alt=""
              style={{
                width: "100%",
                height: "100%",
                objectFit: "fill", // "contain", //"fill", // "contain",
                objectPosition: "center",
                background: "#111",
                display: "block",
              }}
            />
          </Box>
        );
      }

      const team = playerIdToTeamForPopup(playerId) ?? (playerId <= 1 ? 0 : 1);

      return (
        <Box
          sx={{
            width: size,
            height: size,
            borderRadius: `${borderRadius}px`,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: `${fontSize}px`,
            fontWeight: 700,
            lineHeight: 1,
            color: "white",
            background:
              team === 0 ? "rgba(90,170,255,0.72)" : "rgba(90,235,150,0.72)",
            border: "1px solid rgba(255,255,255,0.7)",
            boxSizing: "border-box",
          }}
        >
          {`P${playerId}`}
        </Box>
      );
    },
    [playerIdToAvatarBase64, playerIdToTeamForPopup],
  );

  const renderPlayerIdentity = React.useCallback<RenderPlayerIdentity>(
    ({
      playerId,
      labelOnly = false,
      size,
      borderRadius = 6,
      fontSize = 14,
      noLabel = false,
      fontColor = "black",
      borderWidth = "2px",
      avatarOnly = false,
    }) => {
      if (playerId == null) return null;

      const playerLabel = `p${playerId}`;
      const team = playerIdToTeamForPopup(playerId) ?? teamOfPlayerId(playerId) ?? 0;

      const raw = playerIdToAvatarBase64?.[playerId];

      if (avatarOnly) {
        if (typeof raw === "string" && raw.trim()) {
          const src = raw.startsWith("data:")
            ? raw
            : `data:image/jpeg;base64,${raw}`;

          const avatarNode = (
            <Box
              className="player-avatar"
              sx={{
                width: size,
                height: size,
                borderRadius: `${borderRadius}px`,
                overflow: "hidden",
                display: "block",
                boxSizing: "border-box",
                flexShrink: 0,
                border:
                  (borderWidth || "2px") + " " + teamRgba(team, 1) + " solid",
              }}
            >
              <img
                src={src}
                alt=""
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "fill",
                  objectPosition: "center",
                  background: "#111",
                  display: "block",
                }}
              />
            </Box>
          );

          return avatarNode;
        } else {
          return null;
        }
      }

      if (labelOnly) {
        return playerLabel;
      }

      if (typeof raw === "string" && raw.trim()) {
        const src = raw.startsWith("data:")
          ? raw
          : `data:image/jpeg;base64,${raw}`;

        return (
          <Box
            sx={{
              display: "inline-flex",
              alignItems: "center",
              gap: 0.5,
              minWidth: 0,
            }}
          >
            {noLabel ? null : (
              <Box
                sx={{
                  fontSize: `${fontSize}px`,
                  fontWeight: 700,
                  lineHeight: 1,
                  color: fontColor, //  "black", //"rgba(255,255,255,0.82)",
                  whiteSpace: "nowrap",
                  flexShrink: 0,
                }}
              >
                {playerLabel}
              </Box>
            )}

            <Box
              className="player-avatar"
              sx={{
                width: size,
                height: size,
                borderRadius: `${borderRadius}px`,
                overflow: "hidden",
                display: "block",
                boxSizing: "border-box",
                flexShrink: 0,
                border:
                  (borderWidth || "2px") + " " + teamRgba(team, 1) + " solid",
              }}
            >
              <img
                src={src}
                alt=""
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "fill",
                  objectPosition: "center",
                  background: "#111",
                  display: "block",
                }}
              />
            </Box>
          </Box>
        );
      }

      return (
        <Box
          sx={{
            width: size,
            height: size,
            borderRadius: `${borderRadius}px`,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: `${fontSize}px`,
            fontWeight: 700,
            lineHeight: 1,
            color: "black",
            background:
              team === 0 ? "rgba(90,170,255,0.72)" : "rgba(90,235,150,0.72)",
            border: "1px solid rgba(255,255,255,0.7)",
            boxSizing: "border-box",
            flexShrink: 0,
          }}
        >
          {playerLabel}
        </Box>
      );
    },
    [playerIdToAvatarBase64, playerIdToTeamForPopup],
  );

  const resolvePlayerAvatarSrc = React.useCallback(
    (playerId: number | null | undefined): string | undefined => {
      if (playerId == null) return undefined;
      const raw = playerIdToAvatarBase64?.[playerId];
      if (typeof raw !== "string" || !raw.trim()) return undefined;
      return raw.startsWith("data:") ? raw : `data:image/jpeg;base64,${raw}`;
    },
    [playerIdToAvatarBase64],
  );

  // const storyFilterBuckets = React.useMemo((): Record<
  //   StoryFilterKey,
  //   FilterBucket
  // > => {
  //   const rallyBadges = rallyBadgesRef.current;
  //   rallyBadges.clear();

  //   const addBadge = (rallyIndex: number, b: RallyBadge) => {
  //     const arr = rallyBadges.get(rallyIndex);
  //     if (!arr) {
  //       rallyBadges.set(rallyIndex, [b]);
  //       return;
  //     }
  //     // dedupe
  //     if (
  //       arr.some(
  //         (x) => x.team === b.team && x.key === b.key && x.stake === b.stake,
  //       )
  //     )
  //       return;
  //     arr.push(b);
  //   };

  //   const initStake = (): StakeCounts => ({
  //     rallyIndexes: new Set<number>(),
  //     t0: 0,
  //     t1: 0,
  //     teams: { 0: new Set<number>(), 1: new Set<number>() },
  //     players: {
  //       0: new Set<number>(),
  //       1: new Set<number>(),
  //       2: new Set<number>(),
  //       3: new Set<number>(),
  //     },
  //     playerCounts: {
  //       0: 0,
  //       1: 0,
  //       2: 0,
  //       3: 0,
  //     },
  //   });

  //   const init = (key: StoryFilterKey, label: string): FilterBucket => ({
  //     key,
  //     label,
  //     rallyIndexes: new Set<number>(),
  //     t0: 0,
  //     t1: 0,
  //     stakes: {
  //       opportunityLost: initStake(),
  //       gamePointLost: initStake(),
  //     },
  //   });

  //   const buckets: Record<StoryFilterKey, FilterBucket> = {
  //     missedServe: init("missedServe", "Missed serves"),
  //     missedReturn: init("missedReturn", "Missed returns"),
  //     missed3rdDrop: init("missed3rdDrop", "Missed 3rd drops"),
  //     missed3rdDrive: init("missed3rdDrive", "Missed 3rd drives"),

  //     faultNet: init("faultNet", "Net / tape"),
  //     faultOut: init("faultOut", "Hit out"),
  //     unforcedError: init("unforcedError", "Unforced errors"),
  //     forcedFault: init("forcedFault", "Forced faults (pressure)"),
  //     popupExploited: init("popupExploited", "Popups exploited"),
  //   };

  //   // feb 25, 2026 console.error("rows, buckets", {rows, buckets});

  //   for (const r of rows ?? []) {
  //     if (!r) continue;

  //     // use the same logic as the chip row
  //     // (Object.keys(STORY_TO_RALLY_FILTER) as StoryFilterKey[]).forEach((sk) => {
  //     (Object.keys(buckets) as StoryFilterKey[]).forEach((sk) => {
  //       const rk = STORY_TO_RALLY_FILTER[sk];
  //       // console.error({ sk, rk });
  //       // const { match, errTeam } = matchFilter(r, rk);
  //       // if (!match) return;

  //       // const { match, errTeam } = matchFilter(r, rk);
  //       // if (!match || errTeam == null) return;

  //       const { match, errTeam, errPlayerId } = matchFilter(r, rk);
  //       if (!match || errTeam == null) return;

  //       buckets[sk].rallyIndexes.add(r.rallyIndex);

  //       if (errTeam === 0) buckets[sk].t0 += 1;
  //       if (errTeam === 1) buckets[sk].t1 += 1;

  //       // NEW: stake classification (for the team that made the error)
  //       const st = stakeForTeam(r, errTeam);
  //       // if (st) {
  //       //   buckets[sk].stakes[st].rallyIndexes.add(r.rallyIndex);
  //       //   buckets[sk].stakes[st].teams[errTeam].add(r.rallyIndex);

  //       //   if (st) addBadge(r.rallyIndex, { stake: st, key: sk, team: errTeam });

  //       //   if (errTeam === 0) buckets[sk].stakes[st].t0 += 1;
  //       //   if (errTeam === 1) buckets[sk].stakes[st].t1 += 1;
  //       // }

  //       if (st) {
  //         buckets[sk].stakes[st].rallyIndexes.add(r.rallyIndex);
  //         buckets[sk].stakes[st].teams[errTeam].add(r.rallyIndex);

  //         if (errPlayerId != null) {
  //           buckets[sk].stakes[st].players[errPlayerId].add(r.rallyIndex);
  //           buckets[sk].stakes[st].playerCounts[errPlayerId] += 1;
  //         }

  //         if (st) addBadge(r.rallyIndex, { stake: st, key: sk, team: errTeam });

  //         if (errTeam === 0) buckets[sk].stakes[st].t0 += 1;
  //         if (errTeam === 1) buckets[sk].stakes[st].t1 += 1;
  //       }
  //     });
  //   }
  //   return buckets;
  // }, [rows, stakesFilter]);

  const { storyFilterBuckets, badgesByRallyIndex } = React.useMemo(() => {
    const rallyBadges = new Map<number, RallyBadge[]>();

    const addBadge = (rallyIndex: number, b: RallyBadge) => {
      const arr = rallyBadges.get(rallyIndex);
      if (!arr) {
        rallyBadges.set(rallyIndex, [b]);
        return;
      }
      if (
        arr.some(
          (x) => x.team === b.team && x.key === b.key && x.stake === b.stake,
        )
      ) {
        return;
      }
      arr.push(b);
    };

    const initStake = (): StakeCounts => ({
      rallyIndexes: new Set<number>(),
      t0: 0,
      t1: 0,
      teams: { 0: new Set<number>(), 1: new Set<number>() },
      players: {
        0: new Set<number>(),
        1: new Set<number>(),
        2: new Set<number>(),
        3: new Set<number>(),
      },
      playerCounts: {
        0: 0,
        1: 0,
        2: 0,
        3: 0,
      },
    });

    const init = (key: StoryFilterKey, label: string): FilterBucket => ({
      key,
      label,
      rallyIndexes: new Set<number>(),
      t0: 0,
      t1: 0,
      stakes: {
        opportunityLost: initStake(),
        gamePointLost: initStake(),
      },
    });

    const buckets: Record<StoryFilterKey, FilterBucket> = {
      missedServe: init("missedServe", "Missed serves"),
      missedReturn: init("missedReturn", "Missed returns"),
      missed3rdDrop: init("missed3rdDrop", "Missed 3rd drops"),
      missed3rdDrive: init("missed3rdDrive", "Missed 3rd drives"),
      faultNet: init("faultNet", "Net / tape"),
      faultOut: init("faultOut", "Hit out"),
      unforcedError: init("unforcedError", "Unforced errors"),
      //forcedFault: init("forcedFault", "Forced faults (pressure)"),
      forcedFault: init("forcedFault", "Forced faults"),
      popupExploited: init("popupExploited", "Popups exploited"),
    };

    for (const r of rows ?? []) {
      if (!r) continue;

      (Object.keys(buckets) as StoryFilterKey[]).forEach((sk) => {
        const rk = STORY_TO_RALLY_FILTER[sk];
        const { match, errTeam, errPlayerId } = matchFilter(r, rk);
        if (!match || errTeam == null) return;

        buckets[sk].rallyIndexes.add(r.rallyIndex);

        if (errTeam === 0) buckets[sk].t0 += 1;
        if (errTeam === 1) buckets[sk].t1 += 1;

        const st = stakesForErrTeam(r, errTeam);
        if (st !== "other") {
          const bucketStake = buckets[sk].stakes[st];
          bucketStake.rallyIndexes.add(r.rallyIndex);
          bucketStake.teams[errTeam].add(r.rallyIndex);
          if (errTeam === 0) bucketStake.t0 += 1;
          if (errTeam === 1) bucketStake.t1 += 1;

          if (
            typeof errPlayerId === "number" &&
            (errPlayerId === 0 ||
              errPlayerId === 1 ||
              errPlayerId === 2 ||
              errPlayerId === 3)
          ) {
            bucketStake.players[errPlayerId].add(r.rallyIndex);
          }

          addBadge(r.rallyIndex, {
            team: errTeam,
            key: sk,
            stake: st,
          });
        }
      });
    }

    (Object.keys(buckets) as StoryFilterKey[]).forEach((sk) => {
      (["opportunityLost", "gamePointLost"] as const).forEach((st) => {
        const s = buckets[sk].stakes[st];
        s.playerCounts = {
          0: s.players[0].size,
          1: s.players[1].size,
          2: s.players[2].size,
          3: s.players[3].size,
        };
      });
    });

    return {
      storyFilterBuckets: buckets,
      badgesByRallyIndex: rallyBadges,
    };
  }, [rows]);

  React.useEffect(() => {
    rallyBadgesRef.current = badgesByRallyIndex;
  }, [badgesByRallyIndex]);

  const storyFilterBucketsForFocusedPlayer = React.useMemo((): Record<
    StoryFilterKey,
    FilterBucket
  > => {
    if (focusedPlayerId == null) return storyFilterBuckets;

    const focusedTeam = teamOfPlayerId(focusedPlayerId);

    const out = {} as Record<StoryFilterKey, FilterBucket>;

    (Object.keys(storyFilterBuckets) as StoryFilterKey[]).forEach((k) => {
      const b = storyFilterBuckets[k];

      // const cloneStake = (st: StakeKey): StakeCounts => {
      //   const src = b.stakes[st];
      //   const focusedSet = src.players[focusedPlayerId] ?? new Set<number>();

      //   return {
      //     rallyIndexes: new Set<number>(focusedSet),
      //     t0: focusedTeam === 0 ? (src.playerCounts[focusedPlayerId] ?? 0) : 0,
      //     t1: focusedTeam === 1 ? (src.playerCounts[focusedPlayerId] ?? 0) : 0,
      //     teams: {
      //       0:
      //         focusedTeam === 0
      //           ? new Set<number>(focusedSet)
      //           : new Set<number>(),
      //       1:
      //         focusedTeam === 1
      //           ? new Set<number>(focusedSet)
      //           : new Set<number>(),
      //     },
      //     players: {
      //       0: new Set<number>(),
      //       1: new Set<number>(),
      //       2: new Set<number>(),
      //       3: new Set<number>(),
      //     },
      //     playerCounts: {
      //       0: 0,
      //       1: 0,
      //       2: 0,
      //       3: 0,
      //     },
      //   };
      // };

      const cloneStakeForFocusedPlayer = (
        src: StakeCounts,
        focusedPlayerId: number,
        focusedTeam: Team01 | null,
      ): StakeCounts => {
        const focusedSet = src.players[focusedPlayerId] ?? new Set<number>();
        const focusedCount =
          src.playerCounts[focusedPlayerId] ?? focusedSet.size;

        return {
          rallyIndexes: new Set<number>(focusedSet),
          t0: focusedTeam === 0 ? focusedSet.size : 0,
          t1: focusedTeam === 1 ? focusedSet.size : 0,
          teams: {
            0:
              focusedTeam === 0
                ? new Set<number>(focusedSet)
                : new Set<number>(),
            1:
              focusedTeam === 1
                ? new Set<number>(focusedSet)
                : new Set<number>(),
          },
          players: {
            0:
              focusedPlayerId === 0
                ? new Set<number>(focusedSet)
                : new Set<number>(),
            1:
              focusedPlayerId === 1
                ? new Set<number>(focusedSet)
                : new Set<number>(),
            2:
              focusedPlayerId === 2
                ? new Set<number>(focusedSet)
                : new Set<number>(),
            3:
              focusedPlayerId === 3
                ? new Set<number>(focusedSet)
                : new Set<number>(),
          },
          playerCounts: {
            0: focusedPlayerId === 0 ? focusedCount : 0,
            1: focusedPlayerId === 1 ? focusedCount : 0,
            2: focusedPlayerId === 2 ? focusedCount : 0,
            3: focusedPlayerId === 3 ? focusedCount : 0,
          },
        };
      };

      const gp = cloneStakeForFocusedPlayer(
        b.stakes.gamePointLost,
        focusedPlayerId,
        focusedTeam,
      );

      const opp = cloneStakeForFocusedPlayer(
        b.stakes.opportunityLost,
        focusedPlayerId,
        focusedTeam,
      );
      const combined = new Set<number>();
      gp.rallyIndexes.forEach((x) => combined.add(x));
      opp.rallyIndexes.forEach((x) => combined.add(x));

      out[k] = {
        ...b,
        rallyIndexes: combined,
        t0: gp.t0 + opp.t0,
        t1: gp.t1 + opp.t1,
        stakes: {
          gamePointLost: gp,
          opportunityLost: opp,
        },
      };
    });

    return out;
  }, [storyFilterBuckets, focusedPlayerId]);

  const selectedRallyBadges = React.useMemo(() => {
    const rallyIndex = activeRow?.rallyIndex ?? null;
    if (rallyIndex == null) return [];
    return rallyBadgesRef.current.get(rallyIndex) ?? [];
  }, [activeRow?.rallyIndex, storyFilterBuckets]); // storyFilterBuckets forces refresh

  // const filteredRowsForTimeline = React.useMemo(() => {
  //   if (!rows?.length) return rows;

  //   console.error({ activeStoryFilters });

  //   if (Object.keys(activeStoryFiltersByStake).length === 0) return rows;

  //   const allowed = new Set<number>();
  //   for (const k of activeStoryFilters) {
  //     const idxs = storyFilterBuckets[k]?.rallyIndexes;
  //     if (!idxs) continue;
  //     idxs.forEach((idx) => allowed.add(idx));
  //   }

  //   return rows.filter((r) => r && allowed.has(r.rallyIndex));
  // }, [rows, activeStoryFilters, storyFilterBuckets]);

  function intersectSets(a: Set<number>, b: Set<number>): Set<number> {
    const out = new Set<number>();
    a.forEach((x) => {
      if (b.has(x)) out.add(x);
    });
    return out;
  }
  // const reasonScopeRallyIndexes = React.useMemo(() => {
  //   const stakeKeys = Object.keys(activeStoryFilters) as StakeKey[];
  //   if (!stakeKeys.length) return null;

  //   const s = new Set<number>();

  //   stakeKeys.forEach((st) => {
  //     const reasons = activeStoryFilters[st];
  //     if (!reasons) return;

  //     (Object.keys(reasons) as StoryFilterKey[]).forEach((k) => {
  //       const teams = reasons[k];
  //       if (!teams) return;

  //       ([0, 1] as Team01[]).forEach((t) => {
  //         if (!teams[t]) return;
  //         const idxs = storyFilterBuckets[k]?.stakes?.[st]?.teams?.[t];
  //         idxs?.forEach((idx) => s.add(idx));
  //       });
  //     });
  //   });

  //   return s;
  // }, [activeStoryFilters, storyFilterBuckets]);

  const activeBucketsForUi = React.useMemo(
    () =>
      focusedPlayerId == null
        ? storyFilterBuckets
        : storyFilterBucketsForFocusedPlayer,
    [focusedPlayerId, storyFilterBuckets, storyFilterBucketsForFocusedPlayer],
  );

  const reasonScopeRallyIndexes = React.useMemo(() => {
    const stakeKeys = Object.keys(activeStoryFilters) as StakeKey[];
    if (!stakeKeys.length) return null;

    const s = new Set<number>();

    stakeKeys.forEach((st) => {
      const reasons = activeStoryFilters[st];
      if (!reasons) return;

      (Object.keys(reasons) as StoryFilterKey[]).forEach((k) => {
        const teams = reasons[k];
        if (!teams) return;

        ([0, 1] as Team01[]).forEach((t) => {
          if (!teams[t]) return;
          const idxs = activeBucketsForUi[k]?.stakes?.[st]?.teams?.[t];
          idxs?.forEach((idx) => s.add(idx));
        });
      });
    });

    return s;
  }, [activeStoryFilters, activeBucketsForUi]);

  const stakeCounts = React.useMemo(() => {
    return computeStakeCounts({
      rows,
      scopeRallyIndexes: reasonScopeRallyIndexes,
    });
  }, [rows, reasonScopeRallyIndexes]);

  const includedRallies = React.useMemo(() => {
    if (!rows?.length) return null;

    const hasReason = Object.keys(activeStoryFilters).length > 0;
    const hasStake = activeStakeFilters.length > 0;

    if (!hasReason && !hasStake) return null;

    let allowed = new Set<number>();
    rows.forEach((r) => allowed.add(r.rallyIndex));

    if (hasReason) {
      const byReason = new Set<number>();

      (Object.keys(activeStoryFilters) as StakeKey[]).forEach((st) => {
        const reasons = activeStoryFilters[st];
        if (!reasons) return;

        (Object.keys(reasons) as StoryFilterKey[]).forEach((k) => {
          const teams = reasons[k];
          if (!teams) return;

          ([0, 1] as Team01[]).forEach((t) => {
            if (!teams[t]) return;
            const idxs = activeBucketsForUi[k]?.stakes?.[st]?.teams?.[t];
            idxs?.forEach((idx) => byReason.add(idx));
          });
        });
      });

      allowed = intersectSets(allowed, byReason);
    }

    if (hasStake) {
      const byStake = new Set<number>();

      (rows ?? []).forEach((r) => {
        const loser = losingTeamForRow(r);
        if (loser == null) return;

        const st = stakeForTeam(r, loser);
        if (!st) return;

        if (activeStakeFilters.includes(st)) {
          byStake.add(r.rallyIndex);
        }
      });

      allowed = intersectSets(allowed, byStake);
    }

    return allowed;
  }, [rows, activeStoryFilters, activeStakeFilters, activeBucketsForUi]);

  // const stakeCounts = React.useMemo(() => {
  //   return computeStakeCounts({
  //     rows,
  //     scopeRallyIndexes: reasonScopeRallyIndexes,
  //   });
  // }, [rows, reasonScopeRallyIndexes]);

  // const includedRallies = React.useMemo(() => {
  //   if (!rows?.length) return null;

  //   // const hasReason = Object.keys(activeStoryFiltersByStake).length > 0;
  //   const hasReason = Object.keys(activeStoryFilters).length > 0;

  //   const hasStake = activeStakeFilters.length > 0;

  //   if (!hasReason && !hasStake) return null;

  //   // Start with "all rallies" then intersect down.
  //   let allowed = new Set<number>();
  //   rows.forEach((r) => allowed.add(r.rallyIndex));

  //   if (hasReason) {
  //     const byReason = new Set<number>();

  //     (Object.keys(activeStoryFilters) as StakeKey[]).forEach((st) => {
  //       const reasons = activeStoryFilters[st];
  //       if (!reasons) return;

  //       (Object.keys(reasons) as StoryFilterKey[]).forEach((k) => {
  //         const teams = reasons[k];
  //         if (!teams) return;

  //         ([0, 1] as Team01[]).forEach((t) => {
  //           if (!teams[t]) return;
  //           const idxs = storyFilterBuckets[k]?.stakes?.[st]?.teams?.[t];
  //           idxs?.forEach((idx) => byReason.add(idx));
  //         });
  //       });
  //     });

  //     allowed = intersectSets(allowed, byReason);
  //   }

  //   if (hasStake) {
  //     const byStake = new Set<number>();

  //     (rows ?? []).forEach((r) => {
  //       const loser = losingTeamForRow(r);
  //       if (loser == null) return;

  //       const st = stakeForTeam(r, loser);
  //       if (!st) return;

  //       if (activeStakeFilters.includes(st)) {
  //         byStake.add(r.rallyIndex);
  //       }
  //     });

  //     allowed = intersectSets(allowed, byStake);
  //   }

  //   return allowed;
  // }, [rows, activeStoryFilters, activeStakeFilters, storyFilterBuckets]);

  // React.useEffect(() => {
  //   if (!rows?.length) return;
  //   if (Object.keys(activeStoryFiltersByStake).length !== 0) return;

  //   // when clearing filters, keep current rally if possible; otherwise go first
  //   if (!activeRow && rows[0]) setActiveRow(rows[0]);
  // }, [rows, Object.keys(activeStoryFiltersByStake).length, activeRow]);

  // const filterSummary = React.useMemo(() => {
  //   if (!rows?.length) return "—";
  //   if (!Object.keys(activeStoryFiltersByStake).length)
  //     return `Showing: All rallies (${rows.length})`;

  //   const labels = activeStoryFilters.map(
  //     (k) => storyFilterBuckets[k]?.label ?? k,
  //   );
  //   const n = includedRallies?.size ?? 0;

  //   return `Showing: ${labels.join(" OR ")} (${n} rallies)`;
  // }, [
  //   rows?.length,
  //   activeStoryFilters,
  //   storyFilterBuckets,
  //   includedRallies?.size,
  // ]);

  React.useEffect(() => {
    if (iInsightsJson) {
      const result = buildMatchImpactFactsFromInsights({
        packageId: packageId,
        insights: iInsightsJson,
      });
// console.error("buildMatchImpactFactsFromInsights", { result });
      setMatchImpactFacts(result);
    }
  }, [iInsightsJson]);

  React.useEffect(() => {
    if (!rows?.length) return;
    if (!includedRallies || includedRallies.size === 0) return;

    const activeOk = activeRow && includedRallies.has(activeRow.rallyIndex);

    if (!activeOk) {
      const firstIncluded =
        rows.find((r) => includedRallies.has(r.rallyIndex)) ?? null;
      if (firstIncluded) {
        setActiveRow(firstIncluded);
        setActiveShotNumber(null);
      }
    }
  }, [rows, includedRallies]); // intentionally not depending on activeRow

  const clamp = (v: number, lo: number, hi: number) =>
    Math.max(lo, Math.min(hi, v));

  const onTimelineResizeMouseDown = (e: React.MouseEvent) => {
    e.preventDefault();
    resizeDragRef.current = { startY: e.clientY, startH: timelineBarsH };

    const onMove = (ev: MouseEvent) => {
      const st = resizeDragRef.current;
      if (!st) return;
      const dy = ev.clientY - st.startY;
      setTimelineBarsH(clamp(st.startH + dy, 60, 260));
    };

    const onUp = () => {
      resizeDragRef.current = null;
      window.removeEventListener("mousemove", onMove);
      window.removeEventListener("mouseup", onUp);
    };

    window.addEventListener("mousemove", onMove);
    window.addEventListener("mouseup", onUp);
  };

  const pickRallyIndex = React.useCallback(
    (rallyIndex: number | undefined | null) => {
      if (typeof rallyIndex === "number") {
        const row = rows.find((r) => r.rallyIndex === rallyIndex) ?? null;
        setActiveRow(row);
        setActiveShotNumber(null);
        setBookmarkPlaybackSeed(null);

        if (row) {
          const nonce = Date.now();
          const segmentStartMs = row.segmentStartMs ?? row.startMs ?? 0;
          const segmentEndMs = row.segmentEndMs ?? row.endMs ?? segmentStartMs;
          const durationSec = Math.max(
            0.5,
            (segmentEndMs - segmentStartMs) / 1000,
          );

          setMainPlaybackSeed({
            rallyIndex: row.rallyIndex,
            timeSec: 0,
            paused: false,
            nonce,
          });
          setMainLoopSeed({
            rallyIndex: row.rallyIndex,
            enabled: false,
            aSec: 0,
            bSec: durationSec,
            nonce,
          });
        }
      }
    },
    [rows],
  );

  const openBookmarkedShot = React.useCallback(
    (bookmark: ShotBookmark, openLab: boolean) => {
      const row = rows.find((candidate) => candidate.rallyIndex === bookmark.rallyIndex) ?? null;
      if (!row) return;
      setActiveRow(row);
      setActiveShotNumber(bookmark.shotNumber);
      setMainPlaybackSeed(null);
      setMainLoopSeed(null);
      setBookmarkPlaybackSeed({
        timeSec: Math.max(0, bookmark.timeSec ?? 0),
        paused: true,
        nonce: Date.now(),
      });
      setShotBookmarksOpen(false);
      if (openLab) {
        setShotUniverseBookmarkRestore({ bookmark, nonce: Date.now() });
        setOpenShotUniverse(true);
      }
    },
    [rows],
  );

  const handleBookmarkShotFromVideo = React.useCallback(
    (payload: {
      rallyIndex: number;
      shotNumber: number;
      timeSec: number | null;
      playerId: number | null;
    }) => {
      const existing =
        shotBookmarks.find(
          (bookmark) =>
            bookmark.rallyIndex === payload.rallyIndex &&
            bookmark.shotNumber === payload.shotNumber,
        ) ?? null;
      setPendingVideoBookmark(payload);
      setVideoBookmarkDescriptionDraft(existing?.description ?? "");
    },
    [shotBookmarks],
  );

  const savePendingVideoBookmark = React.useCallback(() => {
    if (!pendingVideoBookmark) return;
    upsertShotBookmark({
      packageId,
      rallyIndex: pendingVideoBookmark.rallyIndex,
      shotNumber: pendingVideoBookmark.shotNumber,
      timeSec: pendingVideoBookmark.timeSec,
      playerId: pendingVideoBookmark.playerId,
      playerName:
        pendingVideoBookmark.playerId == null
          ? null
          : `Player ${pendingVideoBookmark.playerId}`,
      description: videoBookmarkDescriptionDraft,
    });
    setPendingVideoBookmark(null);
    setShotBookmarksOpen(true);
  }, [packageId, pendingVideoBookmark, videoBookmarkDescriptionDraft]);

  const openShotTargetLab = React.useCallback(() => {
    pauseAllActiveVideos();
    setShotUniverseOpportunityContext(null);
    const preferredShotNumber =
      activeRow?.shotNumberOverlays?.find((overlay) => overlay.shotNumber === 2)
        ?.shotNumber ??
      activeRow?.shotNumberOverlays?.find((overlay) => overlay.shotNumber === 3)
        ?.shotNumber ??
      activeRow?.shotNumberOverlays?.find((overlay) => overlay.shotNumber > 1)
        ?.shotNumber ??
      activeShotNumber ??
      null;
    setActiveShotNumber(preferredShotNumber);
    setPendingShotUniverseOpenShotNumber(preferredShotNumber);
  }, [activeRow, activeShotNumber]);

  React.useEffect(() => {
    if (pendingShotUniverseOpenShotNumber == null) return;
    setShotUniverseOpenShotNumber(pendingShotUniverseOpenShotNumber);
    setOpenShotUniverse(true);
    setPendingShotUniverseOpenShotNumber(null);
  }, [pendingShotUniverseOpenShotNumber]);

  const openPointsAddedShotTargetLab = React.useCallback(
    (row: KitchenArrivalRow, shotNumber: number) => {
      pauseAllActiveVideos();
      setShotUniverseOpportunityContext(null);
      setActiveRow(row);
      setActiveShotNumber(shotNumber);
      setShotUniverseOpenShotNumber(shotNumber);
      setOpenShotUniverse(true);
    },
    [],
  );

  const openOpportunityShotTargetLab = React.useCallback(
    (
      row: KitchenArrivalRow,
      shotNumber: number,
      opportunityContext: ShotOpportunityLabContext,
    ) => {
      const loopSeed = buildShotLabCandidateLoopSeed(row, shotNumber);
      const nonce = Date.now();
      pauseAllActiveVideos();
      setShotUniverseOpportunityContext(opportunityContext);
      setActiveRow(row);
      setActiveShotNumber(shotNumber);
      setShotUniverseOpenShotNumber(shotNumber);
      setMainPlaybackSeed(
        loopSeed
          ? {
              rallyIndex: row.rallyIndex,
              timeSec: loopSeed.timeSec,
              paused: true,
              nonce,
            }
          : null,
      );
      setMainLoopSeed(
        loopSeed
          ? {
              rallyIndex: row.rallyIndex,
              enabled: loopSeed.enabled,
              aSec: loopSeed.aSec,
              bSec: loopSeed.bSec,
              nonce,
            }
          : null,
      );
      setOpenShotUniverse(true);
    },
    [],
  );

  const titoShotLabCandidateRow = React.useMemo(
    () =>
      packageId === TITO_SHOT_LAB_CANDIDATE.packageId
        ? rows.find(
            (candidate) => candidate.rallyIndex === TITO_SHOT_LAB_CANDIDATE.rallyIndex,
          ) ?? null
        : null,
    [packageId, rows],
  );

  const openTitoShotLabCandidate = React.useCallback(() => {
    if (packageId !== TITO_SHOT_LAB_CANDIDATE.packageId) return;
    const candidateRow =
      rows.find(
        (candidate) => candidate.rallyIndex === TITO_SHOT_LAB_CANDIDATE.rallyIndex,
      ) ?? null;
    if (!candidateRow) return;
    const loopSeed = buildShotLabCandidateLoopSeed(
      candidateRow,
      TITO_SHOT_LAB_CANDIDATE.shotNumber,
    );
    const nonce = Date.now();
    pauseAllActiveVideos();
    setShotUniverseOpportunityContext({
      title: "Middle seam opportunity",
      subtitle: "Rally 24 · Shot 19 · p0 · score 82",
      shotNumber: TITO_SHOT_LAB_CANDIDATE.shotNumber,
      reason: "Tito hits a controlled slow ball through the middle seam for the point.",
      target: { x: 0.625, z: 0.01 },
      type: "middle_seam",
      outcome: "found",
      teamResult: "won",
      shotEndedRally: true,
      score: 82,
    });
    setActiveRow(candidateRow);
    setActiveShotNumber(TITO_SHOT_LAB_CANDIDATE.shotNumber);
    setShotUniverseOpenShotNumber(TITO_SHOT_LAB_CANDIDATE.shotNumber);
    setMainPlaybackSeed(
      loopSeed
        ? {
            rallyIndex: candidateRow.rallyIndex,
            timeSec: loopSeed.timeSec,
            paused: true,
            nonce,
          }
        : null,
    );
    setMainLoopSeed(
      loopSeed
        ? {
            rallyIndex: candidateRow.rallyIndex,
            enabled: loopSeed.enabled,
            aSec: loopSeed.aSec,
            bSec: loopSeed.bSec,
            nonce,
          }
        : null,
    );
    setOpenShotUniverse(true);
  }, [packageId, rows]);

  const [clipFocusForAsk, setClipFocusForAsk] = React.useState<
    ClipFocus | undefined
  >(undefined);

  //const clamp = (v: number, lo: number, hi: number) => Math.max(lo, Math.min(hi, v));

  // AskAiPanel handlers — keep them flexible and just forward args to your API.
  // (This matches the “RallyColumnAskAIPanel” vibe without hard-coding a strict shape.)
  const handleAskAi = React.useCallback(
    async (args: {
      row: {
        rallyIndex: number;
        segmentStartMs: number;
        segmentEndMs: number;
        //videoUrl: string;
      };
      question: string;
    }) => {
      let normalizedClipFocus: ClipFocus | undefined = undefined;
      try {
        const segStart = args.row.segmentStartMs;
        const segEnd = args.row.segmentEndMs;

        normalizedClipFocus =
          clipFocusForAsk?.kind === "scrubber"
            ? {
                ...clipFocusForAsk,
                rangeStartMs: clamp(
                  clipFocusForAsk.rangeStartMs,
                  segStart,
                  segEnd,
                ),
                rangeEndMs: clamp(clipFocusForAsk.rangeEndMs, segStart, segEnd),
              }
            : clipFocusForAsk;

        // construct the stuff we need
        const body: AiAskRallyBasicQuestionBody = {
          packageId,
          rallyIndex: args.row.rallyIndex,
          question: args.question,
          segmentEndMs: args.row.segmentEndMs,
          segmentStartMs: args.row.segmentStartMs,
          // ✅ include only if present (or send {kind:"full_rally"} if you prefer explicit)
          clipFocus: normalizedClipFocus,
        };

        const res = await fetch("/api/ai-ask-rally-basic-question", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(body),
        });

        // const json = await res.json();
        const json = await res.json().catch(() => null);

        // if (!res.ok) throw new Error(`Ask AI failed: ${res.statusText}`);
        if (!res.ok) {
          throw new Error(
            typeof json?.error === "string"
              ? json.error
              : `Ask AI failed: ${res.statusText || res.status}`,
          );
        }
        //const json = await res.json();

        // Prefer the backend's structured shape: { turn: { result: ... } }
        const extracted =
          json?.turn?.result ?? json?.turn?.analysis ?? json?.result ?? json;

        const responseText =
          typeof extracted?.answerToQuestion === "string"
            ? extracted.answerToQuestion
            : typeof json?.answer === "string"
              ? json.answer
              : undefined;

        const rk = rallyKey(args.row);

        setTurnsByKey((prev) => {
          const cur = Array.isArray(prev[rk]) ? prev[rk] : [];

          const persistedFocus: ClipFocus = normalizedClipFocus ?? {
            rallyIndex: args.row.rallyIndex,
            videoUrl: (activeRow as any)?.videoUrl ?? "",
            //videoUrl:   args.row.videoUrl ?? "",
            segmentStartMs: args.row.segmentStartMs,
            segmentEndMs: args.row.segmentEndMs,
            rangeStartMs: args.row.segmentStartMs,
            rangeEndMs: args.row.segmentEndMs,
            rangeMode: "full",
            kind: "full_rally",
          };

          const newTurn: AiTurn = {
            id: `${Date.now()}_${Math.random().toString(16).slice(2)}`,
            createdAtMs: Date.now(),
            question: args.question,
            focus: persistedFocus, // normalizedClipFocus,
            status: "done" as const,
            responseJson: extracted,
            responseText,
            contextLabel: "Main Screen",
          };

          const nextTurns = [newTurn, ...cur];

          writePerRallyTurns(packageId, args.row.rallyIndex, nextTurns);

          // AiTurnGlobal
          //
          upsertGlobalTurn({
            ...(newTurn as AiTurn),
            packageId,
            rallyIndex: args.row.rallyIndex,
          });

          return {
            ...prev,
            [rk]: [newTurn, ...cur],
          };
        });

        // });

        // // If server returns full turnsByKey:
        // if (data?.turnsByKey && typeof data.turnsByKey === "object") {
        //   setTurnsByKey(data.turnsByKey);
        //   return;
        // }

        // // If server returns { key, turns }:
        // if (data?.key && Array.isArray(data?.turns)) {
        //   setTurnsByKey((prev) => ({ ...prev, [data.key]: data.turns }));
        //   return;
      } catch (error) {
        const message =
          error instanceof Error ? error.message : "Ask AI failed";

        const rk = rallyKey(args.row);

        setTurnsByKey((prev) => {
          const cur = Array.isArray(prev[rk]) ? prev[rk] : [];

          const persistedFocus: ClipFocus = normalizedClipFocus ?? {
            rallyIndex: args.row.rallyIndex,
            videoUrl: (activeRow as any)?.videoUrl ?? "",
            segmentStartMs: args.row.segmentStartMs,
            segmentEndMs: args.row.segmentEndMs,
            rangeStartMs: args.row.segmentStartMs,
            rangeEndMs: args.row.segmentEndMs,
            rangeMode: "full",
            kind: "full_rally",
          };

          const errorTurn: AiTurn = buildErrorTurn({
            question: args.question,
            focus: persistedFocus,
            contextLabel: "Main Screen",
            message,
          });

          const nextTurns = [errorTurn, ...cur];

          writePerRallyTurns(packageId, args.row.rallyIndex, nextTurns);

          upsertGlobalTurn({
            ...(errorTurn as AiTurn),
            packageId,
            rallyIndex: args.row.rallyIndex,
          });

          return {
            ...prev,
            [rk]: nextTurns,
          };
        });
      }
    },

    // Otherwise: no-op (panel may refetch itself)
    //},
    [packageId, clipFocusForAsk, setTurnsByKey, activeRow],
  );

  const handleDeleteTurn = React.useCallback(
    async (t: AiTurn) => {
      if (!activeRow) return;

      const rk = rallyKey(activeRow);

      setTurnsByKey((prev) => {
        const cur = Array.isArray(prev[rk]) ? prev[rk] : [];
        const nextTurns = cur.filter((x) => x.id !== t.id);

        // keep per-rally storage in sync
        writePerRallyTurns(packageId, activeRow.rallyIndex, nextTurns);

        // remove from global history too
        deleteGlobalTurn(packageId, activeRow.rallyIndex, t.id);

        return {
          ...prev,
          [rk]: nextTurns,
        };
      });
    },
    [activeRow, packageId],
  );

  React.useEffect(() => {
    let firefightClips: FirefightClip[] = computeFirefightsForAllRows({
      rows: rows,
      thresholdMs: FIREFIGHT_REACTION_THRESHOLD_MS,
      fireFightMinShots: FIREFIGHT_MIN_SHOTS,
      getTeamFromPlayerId: (playerId: number) =>
        (playerIdToTeamForPopup(playerId) ?? teamOfPlayerId(playerId)) as 0 | 1,
      preMs: 700,
      postMs: 700,
    });

    setFirefightClips(firefightClips);
  }, [rows, playerIdToTeamForPopup]);

  React.useEffect(() => {
    let cancelled = false;

    (async () => {
      setLoading(true);
      onLoadingChange?.(true);
      setErr(null);
      setCvJson(null);
      setPlayerIdToAvatarBase64({});
      setSideOutGameInfluenceReport(null);
      setPounceWindowRows([]);

      try {
        const res = await fetch("/api/kitchen-arrival-report", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ packageId }),
        });

        if (!res.ok) {
          throw new Error(
            `Report load failed: ${res.status} ${res.statusText}`,
          );
        }

        const data: ReportResponse = (await res.json()) as ReportResponse;
        if (cancelled) return;

        setPlayerIdToAvatarBase64(data.playerIdToAvatarBase64 ?? {});
        setSideOutGameInfluenceReport(data.sideOutGameInfluenceReport ?? null);
        setRows(data.rows ?? []);
        setTurnsByKey(data.turnsByKey ?? {});
        setInsightsJson(data.insightsJson ?? {});
        const cvFromReport = data.cvJson ?? null;
        setCvJson(cvFromReport);

        const first = (data.rows ?? [])[0] ?? null;
        setActiveRow(first);
        setActiveShotNumber(null);
        setPounceWindowRows(data.pounceWindowRows ?? []);

        void (async () => {
          try {
            if (!cvFromReport) {
              const cvRes = await fetch(
                `/api/package/${encodeURIComponent(packageId)}/cv`,
              );
              if (cvRes.ok) {
                const cvData = (await cvRes.json()) as {
                  id?: string;
                  pbvCv?: CvJson | null;
                };
                if (cancelled) return;

                setCvJson(cvData.pbvCv ?? null);
              }
            }

            const enrichedRes = await fetch("/api/kitchen-arrival-report", {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({
                packageId,
                includeEnrichment: true,
              }),
            });
            if (!enrichedRes.ok) return;

            const enrichedData =
              (await enrichedRes.json()) as ReportResponse;
            if (cancelled) return;

            const enrichedRows = enrichedData.rows ?? [];
            setPlayerIdToAvatarBase64(
              enrichedData.playerIdToAvatarBase64 ?? {},
            );
            setSideOutGameInfluenceReport(
              enrichedData.sideOutGameInfluenceReport ?? null,
            );
            setRows(enrichedRows);
            setTurnsByKey(enrichedData.turnsByKey ?? {});
            setInsightsJson(enrichedData.insightsJson ?? {});
            setPounceWindowRows(enrichedData.pounceWindowRows ?? []);
            if (enrichedData.cvJson) {
              setCvJson(enrichedData.cvJson);
            }
            setActiveRow((prev) => {
              if (!enrichedRows.length) return prev;
              const rallyIndex = prev?.rallyIndex;
              if (rallyIndex == null) return enrichedRows[0] ?? null;
              return (
                enrichedRows.find((row) => row.rallyIndex === rallyIndex) ??
                prev
              );
            });
          } catch {
            // Enrichment is non-critical for the first report; details hydrate later.
          }
        })();
      } catch (e: any) {
        if (!cancelled) setErr(String(e?.message ?? e));
      } finally {
        if (!cancelled) {
          setLoading(false);
          onLoadingChange?.(false);
        }
      }
    })();

    return () => {
      cancelled = true;
      onLoadingChange?.(false);
    };
  }, [packageId, onLoadingChange]);

  const firefightRallySet = React.useMemo(() => {
    const s = new Set<number>();
    for (const c of firefightClips ?? []) {
      if (typeof c?.seq?.rallyIndex === "number") s.add(c.seq.rallyIndex);
    }
// console.error({ firefightRallySet: s });
    return s;
  }, [firefightClips]);

  // React.useEffect(() => {
  //   // if (!open) return;

  //   let cancelled = false;
  //   (async () => {
  //     setLoading(true);
  //     setErr(null);
  //     try {
  //       const res = await fetch("/api/kitchen-arrival-report", {
  //         method: "POST",
  //         headers: { "Content-Type": "application/json" },
  //         body: JSON.stringify({ packageId }),
  //       });
  //       if (!res.ok)
  //         throw new Error(
  //           `Report load failed: ${res.status} ${res.statusText}`,
  //         );
  //       const data: ReportResponse = (await res.json()) as ReportResponse;

  //       if (cancelled) return;

  //       setPlayerIdToAvatarBase64(data.playerIdToAvatarBase64 ?? {});
  //       setSideOutGameInfluenceReport(data.sideOutGameInfluenceReport ?? null);
  //       setRows(data.rows ?? []);
  //       setTurnsByKey(data.turnsByKey ?? {});
  //       setInsightsJson(data.insightsJson ?? {});
  //       setCvJson(data.cvJson ?? null);
  //       const first = (data.rows ?? [])[0] ?? null;
  //       setActiveRow(first);
  //       setActiveShotNumber(null);
  //       setPounceWindowRows(data.pounceWindowRows ?? []);
  //     } catch (e: any) {
  //       if (!cancelled) setErr(String(e?.message ?? e));
  //     } finally {
  //       if (!cancelled) setLoading(false);
  //     }
  //   })();

  //   return () => {
  //     cancelled = true;
  //   };
  // }, [packageId]);

  React.useEffect(() => {
    if (!onSetTopMatchOutcomeBanner) return;

    onSetTopMatchOutcomeBanner(
      iInsightsJson ? (
        <MatchOutcomeBanner
          insights={iInsightsJson}
          onHoverTeam={setHoverTeamAttr}
        />
      ) : null,
    );

    return () => {
      onSetTopMatchOutcomeBanner(null);
    };
  }, [iInsightsJson, onSetTopMatchOutcomeBanner]);

  const story = React.useMemo(() => computeStory(rows), [rows]);
  const pointsAddedFinalScore = React.useMemo(
    () =>
      iInsightsJson
        ? computeFinalScoreFromInsightsJson(iInsightsJson).finalScore
        : story.finalScore,
    [iInsightsJson, story.finalScore],
  );

  const scoreTimeline = React.useMemo(() => computeScoreTimeline(rows), [rows]);

  // Score label should reflect the *active rally*, not always the final score.
  const activeScore = React.useMemo((): [number, number] => {
    if (!activeRow) return story.finalScore ?? [0, 0];

    // Score label should reflect the *active rally*, not always the final score.

    const before = scoreTimeline.before.get(activeRow.rallyIndex);
    const after = scoreTimeline.after.get(activeRow.rallyIndex);

    // Prefer "before" (score when the rally starts). Fallback to after/final.
    return before ?? after ?? story.finalScore ?? [0, 0];
  }, [activeRow, scoreTimeline.before, scoreTimeline.after, story.finalScore]);

  const activeScoreBefore = React.useMemo((): [number, number] => {
    if (!activeRow) return story.finalScore ?? [0, 0];

    const before = scoreTimeline.before.get(activeRow.rallyIndex);
    const after = scoreTimeline.after.get(activeRow.rallyIndex);

    return before ?? after ?? story.finalScore ?? [0, 0];
  }, [activeRow, scoreTimeline.before, scoreTimeline.after, story.finalScore]);

  const activeScoreAfter = React.useMemo((): [number, number] => {
    if (!activeRow) return story.finalScore ?? [0, 0];

    const after = scoreTimeline.after.get(activeRow.rallyIndex);
    const before = scoreTimeline.before.get(activeRow.rallyIndex);

    return after ?? before ?? story.finalScore ?? [0, 0];
  }, [activeRow, scoreTimeline.before, scoreTimeline.after, story.finalScore]);

  const activeWinner = React.useMemo((): number | null => {
    const wt = activeRow ? getWinningTeam(activeRow as any) : null;
    return wt ?? story.winner ?? null;
  }, [activeRow, story.winner]);

  const onPickMoment = React.useCallback(
    (m: KeyMoment) => {
      // jump selection (ActiveRallyVideo will follow activeRow)
      pickRallyIndex(m.rallyIndex);
    },
    [pickRallyIndex],
  );

  const rowsByRallyIndex = React.useMemo(() => {
    const m = new Map<number, KitchenArrivalRow>();
    for (const r of rows) m.set(r.rallyIndex, r);
    return m;
  }, [rows]);

  function getReasonRallyIndexes(args: {
    team: Team01;
    reason: StoryFilterKey;
    stake?: StakeKey | "both";
  }): number[] {
    const b = storyFilterBuckets[args.reason];
    if (!b) return [];

    const s = new Set<number>();

    const addStake = (st: StakeKey) => {
      b.stakes?.[st]?.teams?.[args.team]?.forEach((ri) => s.add(ri));
    };

    if (!args.stake || args.stake === "both") {
      addStake("opportunityLost");
      addStake("gamePointLost");
    } else {
      addStake(args.stake);
    }

    // newest first
    return Array.from(s).sort((a, b) => b - a);
  }

  function getReasonPreviewSegments(args: {
    team: Team01;
    reason: StoryFilterKey;
    stake?: StakeKey | "both";
  }): RallyVideoPreviewSeg[] {
    const { team, reason, stake } = args;

    const rallyIdxs = getReasonRallyIndexes({ team, reason, stake });
    const segs: RallyVideoPreviewSeg[] = [];

    for (const rallyIndex of rallyIdxs) {
      const r = rowsByRallyIndex.get(rallyIndex);
      if (!r) continue;

      const startMs =
        typeof r.segmentStartMs === "number" ? r.segmentStartMs : null;
      const endMs = typeof r.segmentEndMs === "number" ? r.segmentEndMs : null;
      if (startMs == null || endMs == null) continue;

      const src = (r as any).videoUrl ?? "";
      if (!src) continue;

      segs.push({
        rallyIndex,
        src,
        // ✅ whole-rally bounds (absolute seconds in the source video)
        startSec: Math.max(0, startMs / 1000),
        endSec: Math.max(0, endMs / 1000),
        label: `R${rallyIndex}`,
      });
    }

    return segs;
  }

  const focusedFilter = React.useMemo(
    () => deriveFocusedReasonStakeForSingleTeam(activeStoryFilters),
    [activeStoryFilters],
  );

  const activeBadgeFilter = React.useMemo(
    () =>
      focusedFilter
        ? {
            team: focusedFilter.team,
            key: focusedFilter.reason,
            stake: focusedFilter.stake,
          }
        : null,
    [focusedFilter],
  );

  // const [focusedFilter, setFocusedFilter] =
  //   React.useState<FocusedReasonStakeForTeam | null>(null);

  // React.useEffect(() => {
  //   setFocusedFilter(deriveFocusedReasonStakeForSingleTeam(activeStoryFilters));
  // }, [activeStoryFilters]);

  const handleFocusedFilterChange = React.useCallback(
    (next: FocusedReasonStakeForTeam | null) => {
      if (!next) {
        setActiveStoryFilters({});
        return;
      }

      // SINGLE SELECT globally: replace *all* filters with only this one selection
      setActiveStoryFilters({
        [next.stake]: {
          [next.reason]: {
            [next.team]: true,
          },
        },
      } as StakeReasonTeamFilters);
    },
    [setActiveStoryFilters],
  );

  // const focusedFilter = React.useMemo(
  //   () => deriveFocusedReasonStakeForSingleTeam(activeStoryFilters),
  //   [activeStoryFilters],
  // );

  //   React.useEffect(() => {
  //   // focusedFilter is the source of truth. Always overwrite filters from it.
  //   if (!focusedFilter) {
  //     setActiveStoryFilters({});
  //     return;
  //   }

  //   const { team, reason, stake } = focusedFilter;

  //   const next: StakeReasonTeamFilters = {};
  //   const setOne = (st: StakeKey) => {
  //     next[st] = next[st] ?? {};
  //     next[st]![reason] = next[st]![reason] ?? {};
  //     next[st]![reason]![team] = true;
  //   };

  //   // if (stake === "both") {
  //   //   setOne("gamePointLost");
  //   //   setOne("opportunityLost");
  //   // } else {
  //     setOne(stake);
  //   // }

  //   setActiveStoryFilters(next);
  // }, [focusedFilter]);

  const [fastReactionMs, setFastReactionMs] = React.useState<number>(600);

  const [openFastReactionsPopup, setOpenFastReactionsPopup] =
    React.useState(false);
  const [fastReactionsAnchorEl, setFastReactionsAnchorEl] =
    React.useState<HTMLElement | null>(null);

  const [openShotQualityPopup, setOpenShotQualityPopup] = React.useState(false);
  const [shotQualityAnchorEl, setShotQualityAnchorEl] =
    React.useState<HTMLElement | null>(null);

  const [openPounceWindowsPopup, setOpenPounceWindowsPopup] =
    React.useState(false);
  const [pounceWindowsAnchorEl, setPounceWindowsAnchorEl] =
    React.useState<HTMLElement | null>(null);

  const [fastShotMph, setFastShotMph] = React.useState<number>(
    FAST_SHOT_MPH_THRESHOLD,
  );

  const [openFastShotsPopup, setOpenFastShotsPopup] = React.useState(false);
  const [openLobShotsPopup, setOpenLobShotsPopup] = React.useState(false);

  const [openSolar, setOpenSolar] = React.useState(false);

  const [openFirefights, setOpenFirefights] = React.useState(false);

  const [fastShotsAnchorEl, setFastShotsAnchorEl] =
    React.useState<HTMLElement | null>(null);

  const [lobShotsAnchorEl, setLobShotsAnchorEl] =
    React.useState<HTMLElement | null>(null);

  const [firefightsAnchorEl, setFirefightsAnchorEl] =
    React.useState<HTMLElement | null>(null);

  const featureLauncherAnchor = React.useCallback((selector: string) => {
    if (typeof document === "undefined") return null;
    return document.querySelector(selector) as HTMLElement | null;
  }, []);

  React.useEffect(() => {
    if (!featureLaunchRequest) return;
    switch (featureLaunchRequest.key) {
      case "pounce":
        setPounceWindowsAnchorEl(featureLauncherAnchor('[data-happy-path="gs-open-pounce"]'));
        setOpenPounceWindowsPopup(true);
        break;
      case "third-shot":
        setThirdShotAnchorEl(featureLauncherAnchor('[data-happy-path="gs-open-third-shot"]'));
        setOpenThirdShotPopup(true);
        break;
      case "fourth-shot":
        setFourthShotAnchorEl(featureLauncherAnchor('[data-happy-path="gs-open-fourth-shot"]'));
        setOpenFourthShotPopup(true);
        break;
      case "fifth-shot":
        setFifthShotAnchorEl(featureLauncherAnchor('[data-happy-path="gs-open-fifth-shot"]'));
        setOpenFifthShotPopup(true);
        break;
      case "dinks":
        setDinkSegmentsAnchorEl(featureLauncherAnchor('[data-happy-path="gs-open-dinks"]'));
        setOpenDinkSegmentsPopup(true);
        break;
      case "serve":
        setServeAnchorEl(featureLauncherAnchor('[data-happy-path="gs-open-serve"]'));
        setOpenServePopup(true);
        break;
      case "return":
        setReturnAnchorEl(featureLauncherAnchor('[data-happy-path="gs-open-return"]'));
        setOpenReturnPopup(true);
        break;
      case "serve-return-risk":
        setServeReturnRiskAnchorEl(featureLauncherAnchor('[data-happy-path="gs-open-serve-return-risk"]'));
        setOpenServeReturnRiskPopup(true);
        break;
      case "opportunity-finder":
        setOpenOpportunityFinder(true);
        break;
      case "shot-quality":
        setShotQualityAnchorEl(featureLauncherAnchor('[data-happy-path="gs-open-shot-quality"]'));
        setOpenShotQualityPopup(true);
        break;
      case "rally-quality":
        setRallyQualityOverviewAnchorEl(featureLauncherAnchor('[data-happy-path="gs-open-rally-quality"]'));
        setOpenRallyQualityOverviewPopup(true);
        break;
      case "fast-shots":
        setFastShotsAnchorEl(featureLauncherAnchor('[data-happy-path="gs-open-fast-shots"]'));
        setOpenFastShotsPopup(true);
        break;
      case "candidate-speedups":
        setOpenCandidateSpeedupsPopup(true);
        break;
      case "candidate-bodybags":
        setOpenCandidateBodybagsPopup(true);
        break;
      case "possible-popups":
        setOpenPossiblePopupsPopup(true);
        break;
      case "paddle-readiness":
        setOpenPaddleReadinessPopup(true);
        break;
      case "dink-readiness":
        setOpenDinkReadinessPopup(true);
        break;
      case "left-side-coverage":
        setOpenLeftSideCoveragePopup(true);
        break;
      case "atps":
        setAtpAnchorEl(featureLauncherAnchor('[data-happy-path="gs-open-atps"]'));
        setOpenAtpPopup(true);
        break;
      case "fast-reactions":
        setFastReactionsAnchorEl(featureLauncherAnchor('[data-happy-path="gs-open-fast-reactions"]'));
        setOpenFastReactionsPopup(true);
        break;
      case "firefights":
        setFirefightsAnchorEl(featureLauncherAnchor('[data-happy-path="gs-open-firefights"]'));
        setOpenFirefights(true);
        break;
      case "positioning-patterns":
        openExperiment("positioningPatterns");
        break;
      case "match-identity":
        openExperiment("matchIdentity");
        break;
      case "rally-causality":
        openExperiment("rallyCausality");
        break;
      case "single-top-focus":
        openExperiment("singleTopFocus");
        break;
      case "trajectory-wall":
        openExperiment("trajectoryWall");
        break;
      case "points-added-report":
        openExperiment("pointsAddedReport");
        break;
      case "ai-history":
        setAiHistoryOpen(true);
        break;
      case "full-game-ai":
        setOpenGameAiPopup(true);
        break;
      default:
        break;
    }
  }, [
    featureLaunchRequest?.key,
    featureLaunchRequest?.nonce,
    featureLauncherAnchor,
    openExperiment,
  ]);

  const PRE_MS = 1200;
  const POST_MS = 1000;

  // Compute events for all rallies
  const fastReactionsAllEvents = React.useMemo(() => {
    const all: FastReactionEvent[] = [];
    for (let rallyIndex = 0; rallyIndex < rows.length; rallyIndex++) {
      const rally = rows[rallyIndex];
      const ev = computeFastReactionsForRally({
        rally,
        rallyIndex,
        thresholdMs: fastReactionMs,
        getTeamFromPlayerId: (playerId: number) =>
          playerIdToTeamForPopup(playerId) ?? 0,
      });
      all.push(...ev);
    }
    return all;
  }, [rows, fastReactionMs, playerIdToTeamForPopup]);

  const shotQualityAllEvents = React.useMemo(() => {
    const all: ShotQualityEvent[] = [];

    for (let rallyIndex = 0; rallyIndex < rows.length; rallyIndex++) {
      const rally = rows[rallyIndex];
      const ev = computeShotQualityEventsForRally({
        rally,
        rallyIndex,
        getTeamFromPlayerId: (playerId: number) =>
          playerIdToTeamForPopup(playerId) ?? 0,
      });
      all.push(...ev);
    }

    return all;
  }, [rows, playerIdToTeamForPopup]);

  const shotQualityClipsAll = React.useMemo(() => {
    return shotQualityAllEvents.map((ev) =>
      buildShotQualityClip({
        event: ev,
        preMs: PRE_MS,
        postMs: POST_MS,
      }),
    );
  }, [shotQualityAllEvents]);

  const shotQualityClipsThisRally = React.useMemo(() => {
    if (activeRow?.rallyIndex == null) return [];
    return shotQualityClipsAll.filter(
      (c) => c.event.rallyIndex === activeRow.rallyIndex,
    );
  }, [shotQualityClipsAll, activeRow?.rallyIndex]);

  const erneClipsAll = React.useMemo(() => {
    return computeErneClipsFromRows(rows);
  }, [rows]);

  const erneClipsThisRally = React.useMemo(() => {
    if (activeRow == null) return [];
    return erneClipsAll.filter(
      (c) => c.event.rallyIndex === activeRow.rallyIndex,
    );
  }, [erneClipsAll, activeRow?.rallyIndex]);

  const atpClipsAll = React.useMemo(() => {
    return computeAtpClipsFromRows(rows, playerIdToTeamForPopup);
  }, [rows, playerIdToTeamForPopup]);

  const atpClipsThisRally = React.useMemo(() => {
    if (activeRow == null) return [];
    return atpClipsAll.filter(
      (c) => c.event.rallyIndex === activeRow.rallyIndex,
    );
  }, [atpClipsAll, activeRow?.rallyIndex]);

  const lobClipsAll: LobClip[] = [];
  for (let rallyIndex = 0; rallyIndex < rows.length; rallyIndex++) {
    const events = computeLobEventsForRally({
      rally: rows[rallyIndex],
      rallyIndex,
      getTeamFromPlayerId: (playerId: number) =>
        playerIdToTeamForPopup(playerId) ?? 0,
      preShots: 1,
      postShots: 4,
    });
    for (const e of events) lobClipsAll.push(buildLobClip(e));
  }

  const fastReactionClipsAll = React.useMemo(() => {
    return fastReactionsAllEvents.map((ev) =>
      buildFastReactionClip({ event: ev, preMs: PRE_MS, postMs: POST_MS }),
    );
  }, [fastReactionsAllEvents]);

  const fastReactionClipsThisRally = React.useMemo(() => {
// console.error({ fastReactionClipsAll });
    if (activeRow?.rallyIndex == null) return [];
    return fastReactionClipsAll.filter(
      (c) => c.event.rallyIndex === activeRow?.rallyIndex,
    );
  }, [fastReactionClipsAll, activeRow?.rallyIndex]);

  // fast shots

  const fastShotsAllEvents = React.useMemo(() => {
    const all: FastShotEvent[] = [];
    for (let rallyIndex = 0; rallyIndex < rows.length; rallyIndex++) {
      const rally = rows[rallyIndex];
      const ev = computeFastShotsForRally({
        rally,
        rallyIndex,
        thresholdMph: fastShotMph,
        getTeamFromPlayerId: (playerId: number) =>
          playerIdToTeamForPopup(playerId) ?? 0,
      });
      all.push(...ev);
    }
    return all;
  }, [rows, fastShotMph, playerIdToTeamForPopup]);

  const fastShotClipsAll = React.useMemo(() => {
    return fastShotsAllEvents.map((ev) =>
      buildFastShotClip({ event: ev, preMs: PRE_MS, postMs: POST_MS }),
    );
  }, [fastShotsAllEvents]);

  const fastShotClipsThisRally = React.useMemo(() => {
// console.error({ fastShotClipsAll });
    if (activeRow?.rallyIndex == null) return [];
    return fastShotClipsAll.filter(
      (c) => c.event.rallyIndex === activeRow?.rallyIndex,
    );
  }, [fastShotClipsAll, activeRow?.rallyIndex]);

  // fast shots end

  const candidateSpeedupMoments = React.useMemo(() => {
    return buildCandidateSpeedupMoments({
      packageId,
      rows,
      playerIdToTeam: playerIdToTeamForPopup,
      insightsToCvPlayerIndex,
    });
  }, [packageId, rows, playerIdToTeamForPopup, insightsToCvPlayerIndex]);

  const candidateBodybagMoments = React.useMemo(() => {
    return buildCandidateBodybagMoments({
      packageId,
      rows,
      playerIdToTeam: playerIdToTeamForPopup,
      insightsToCvPlayerIndex,
    });
  }, [packageId, rows, playerIdToTeamForPopup, insightsToCvPlayerIndex]);

  const possiblePopupMoments = React.useMemo(() => {
    return buildPossiblePopupMoments({
      packageId,
      rows,
      playerIdToTeam: playerIdToTeamForPopup,
      insightsToCvPlayerIndex,
    });
  }, [packageId, rows, playerIdToTeamForPopup, insightsToCvPlayerIndex]);

  const paddleReadinessMoments = React.useMemo(() => {
    return buildPaddleReadinessMoments({
      packageId,
      rows,
      playerIdToTeam: playerIdToTeamForPopup,
      insightsToCvPlayerIndex,
    });
  }, [packageId, rows, playerIdToTeamForPopup, insightsToCvPlayerIndex]);

  const dinkReadinessMoments = React.useMemo(() => {
    return buildDinkReadinessMoments({
      packageId,
      rows,
      playerIdToTeam: playerIdToTeamForPopup,
      insightsToCvPlayerIndex,
    });
  }, [packageId, rows, playerIdToTeamForPopup, insightsToCvPlayerIndex]);

  const leftSideCoverageMoments = React.useMemo(() => {
    return buildLeftSideCoverageMoments({
      packageId,
      rows,
      playerIdToTeam: playerIdToTeamForPopup,
      insightsToCvPlayerIndex,
    });
  }, [packageId, rows, playerIdToTeamForPopup, insightsToCvPlayerIndex]);

  const activeRallyLensMoments = React.useMemo<ActiveRallyLensMoment[]>(() => {
    if (!activeRow) return [];

    const overlayByShotNumber = new Map<number, ShotNumberOverlay>();
    for (const overlay of activeRow.shotNumberOverlays ?? []) {
      overlayByShotNumber.set(overlay.shotNumber, overlay);
    }

    const segmentStartMs = activeRow.segmentStartMs ?? 0;

    const mapMoment = (
      moment: CoachViewMoment,
    ): ActiveRallyLensMoment | null => {
      if (moment.rallyIndex !== activeRow.rallyIndex) return null;
      const lens =
        moment.kind === "candidateSpeedup"
          ? "candidateSpeedups"
          : moment.kind === "candidateBodybag"
            ? "candidateBodybags"
          : moment.kind === "possiblePopup"
            ? "possiblePopups"
          : moment.kind === "paddleReadiness" || moment.kind === "dinkReadiness"
            ? "paddleReadiness"
            : "leftSideCoverage";
      const overlay = overlayByShotNumber.get(moment.shotNumber) ?? null;
      const timeSec = Math.max(
        0,
        (moment.contactTimestamp - segmentStartMs) / 1000,
      );
      return {
        key: `${lens}-${moment.key}`,
        lens,
        shotNumber: moment.shotNumber,
        timeSec,
        title: activeRallyLensMomentTitle(moment),
        detail: activeRallyLensMomentDetail(moment),
        reviewedPlayerId: moment.reviewedPlayerId,
        hitterPlayerId: moment.hitterPlayerId,
        partnerPlayerId: moment.partnerPlayerId,
        courtPlayers: activeRallyLensCourtPlayers(
          overlay,
          moment,
          playerIdToTeamForPopup,
        ),
      };
    };

    return [
      ...candidateSpeedupMoments,
      ...candidateBodybagMoments,
      ...possiblePopupMoments,
      ...paddleReadinessMoments,
      ...dinkReadinessMoments,
      ...leftSideCoverageMoments,
    ]
      .map(mapMoment)
      .filter((moment): moment is ActiveRallyLensMoment => moment != null)
      .sort((a, b) => a.timeSec - b.timeSec);
  }, [
    activeRow,
    candidateSpeedupMoments,
    candidateBodybagMoments,
    possiblePopupMoments,
    paddleReadinessMoments,
    dinkReadinessMoments,
    leftSideCoverageMoments,
    playerIdToTeamForPopup,
  ]);

  // dink rallies

  // dink segments

  const dinkSegmentsAllEvents = React.useMemo(() => {
    const all: DinkSegmentEvent[] = [];

    for (let rallyIndex = 0; rallyIndex < rows.length; rallyIndex++) {
      const rally = rows[rallyIndex];

      const ev = computeDinkSegmentsForRally({
        overlays: rally.shotNumberOverlays!,
        rallyIndex,
        playerIdToTeam: playerIdToTeamForPopup,

        // keep consistent with your team convention
        // getTeamFromPlayerId: (playerId: number) => {
        //   return playerId < 2 ? 0 : 1;
        // },

        // knobs (leeway)
        ignoreFirstNShots: 4,
        gapAllowedShots: dinkGapAllowedShots,
        minDinkPhaseShots: dinkMinPhaseShots,
      });

      all.push(...ev);
    }

    return all;
  }, [rows, dinkGapAllowedShots, dinkMinPhaseShots, playerIdToTeamForPopup]);

  const dinkSegmentClipsAll = React.useMemo(() => {
    return dinkSegmentsAllEvents.map((ev) =>
      buildDinkSegmentClip({ event: ev, preMs: PRE_MS, postMs: POST_MS }),
    );
  }, [dinkSegmentsAllEvents]);

  const dinkSegmentClipsThisRally = React.useMemo(() => {
    if (activeRow?.rallyIndex == null) return [];
    return dinkSegmentClipsAll.filter(
      (c) => c.event.rallyIndex === activeRow.rallyIndex,
    );
  }, [dinkSegmentClipsAll, activeRow?.rallyIndex]);

  // dink segments end

  // dink rallies end

  const filterToggleSx = {
    color: "rgba(255,255,255,0.85)",
    borderColor: "rgba(255,255,255,0.22)",
    backgroundColor: "rgba(255,255,255,0.06)",
    "&.Mui-selected": {
      backgroundColor: "rgba(255,255,255,0.14)",
      borderColor: "rgba(255,255,255,0.38)",
      color: "rgba(255,255,255,0.95)",
    },
    "&.Mui-selected:hover": {
      backgroundColor: "rgba(255,255,255,0.18)",
    },
    textTransform: "none",
    flexShrink: 0,
    whiteSpace: "nowrap",
  };

  const shotQualityButtonSx = {
    ...filterToggleSx,
    borderColor: "rgba(212, 175, 55, 0.42)",
    backgroundColor: "rgba(212, 175, 55, 0.10)",
    color: "rgba(255, 236, 179, 0.96)",
    "&:hover": {
      borderColor: "rgba(212, 175, 55, 0.62)",
      backgroundColor: "rgba(212, 175, 55, 0.16)",
    },
  };

  const topGroupSx = {
    display: "flex",
    alignItems: "center",
    gap: 1,
    flexWrap: "wrap",
  } as const;

  const topDividerSx = {
    width: 1,
    alignSelf: "stretch",
    background: "rgba(255,255,255,0.10)",
    mx: 0.25,
  } as const;

  const [hoveredTeam, setHoveredTeam] = React.useState<0 | 1 | null>(null);
  const rootRef = React.useRef<HTMLDivElement | null>(null);

  const setHoverTeamAttr = (t: 0 | 1 | null) => {
    const el = rootRef.current;
    if (!el) return;
    el.setAttribute("data-hoverteam", t == null ? "none" : String(t));
  };

  const happyPathHooksEnabled =
    typeof window !== "undefined" &&
    new URLSearchParams(window.location.search).get("happyPath") === "1";

  const closeHappyPathPopups = () => {
    if (happyPathHooksEnabled) {
      document.querySelectorAll("video").forEach((video) => {
        try {
          video.pause();
          video.removeAttribute("src");
          video.load();
        } catch {
          // Best-effort cleanup for headless happy-path runs.
        }
      });
    }
    setOpenPounceWindowsPopup(false);
    setPounceWindowsAnchorEl(null);
    setOpenThirdShotPopup(false);
    setThirdShotAnchorEl(null);
    setOpenFourthShotPopup(false);
    setFourthShotAnchorEl(null);
    setOpenFifthShotPopup(false);
    setFifthShotAnchorEl(null);
    setOpenDinkSegmentsPopup(false);
    setDinkSegmentsAnchorEl(null);
    setOpenServePopup(false);
    setServeAnchorEl(null);
    setOpenReturnPopup(false);
    setReturnAnchorEl(null);
    setOpenServeReturnRiskPopup(false);
    setServeReturnRiskAnchorEl(null);
    setOpenShotQualityPopup(false);
    setShotQualityAnchorEl(null);
    setOpenRallyQualityOverviewPopup(false);
    setRallyQualityOverviewAnchorEl(null);
    setOpenFastShotsPopup(false);
    setFastShotsAnchorEl(null);
    setOpenCandidateSpeedupsPopup(false);
    setOpenCandidateBodybagsPopup(false);
    setOpenPossiblePopupsPopup(false);
    setOpenPaddleReadinessPopup(false);
    setOpenLeftSideCoveragePopup(false);
    setOpenFastReactionsPopup(false);
    setFastReactionsAnchorEl(null);
    setOpenFirefights(false);
    setFirefightsAnchorEl(null);
    setOpenPointsAddedPopup(false);
    setAiHistoryOpen(false);
    setOpenGameAiPopup(false);
    setOpenExperimentPositioningPatterns(false);
    setMatchIdentityOpen(false);
    setOpenRallyCausalityOverviewPopup(false);
    setOpenExperimentSingleTopFocus(false);
    setOpenTrajectoryWall(false);
    setOpenShotUniverse(false);
    setOpenLobShotsPopup(false);
    setLobShotsAnchorEl(null);
    setOpenErnePopup(false);
    setErneAnchorEl(null);
    setOpenAtpPopup(false);
    setAtpAnchorEl(null);
    setOpenAllVideos(false);
    setShotBookmarksOpen(false);
    setPendingVideoBookmark(null);
    onCloseQuickTriage();
    onCloseSingleTopFocus();
    onCloseThreeMinuteReview();
    onClosePlayerLensReview();
    onClosePositioningPatterns();
  };

  React.useEffect(() => {
    if (!happyPathHooksEnabled) return;
    const onClose = () => closeHappyPathPopups();
    window.addEventListener("pbv-close-happy-path-popups", onClose);
    return () => window.removeEventListener("pbv-close-happy-path-popups", onClose);
  });

  React.useEffect(() => {
    if (!happyPathHooksEnabled) return;
    const onOpenExperiment = (event: Event) => {
      const key = String(
        (event as CustomEvent<{ key?: string }>).detail?.key || "",
      );
      closeHappyPathPopups();
      window.setTimeout(() => openExperiment(key), 0);
    };
    window.addEventListener(
      "pbv-open-happy-path-experiment",
      onOpenExperiment,
    );
    return () =>
      window.removeEventListener(
        "pbv-open-happy-path-experiment",
        onOpenExperiment,
      );
  });

  return (
    <Box
      ref={rootRef}
      data-hoverteam={hoveredTeam === null ? "none" : String(hoveredTeam)}
      sx={{
        // how strong the cue is
        "--spot0": teamRgba(Team_0, 0.55),
        "--spot0Soft": teamRgba(Team_0, 0.18),
        "--spot1": teamRgba(Team_1, 0.55),
        "--spot1Soft": teamRgba(Team_1, 0.18),

        // Default: do nothing
        "&[data-hoverteam='none'] [data-team]": {},

        // TEAM 0 spotlight
        "&[data-hoverteam='0'] [data-team='0']": {
          outline: "2px solid var(--spot0)",
          outlineOffset: 1,
          borderRadius: 1,
        },

        // TEAM 1 spotlight
        "&[data-hoverteam='1'] [data-team='1']": {
          outline: "2px solid var(--spot1)",
          outlineOffset: 1,
          borderRadius: 1,
        },
      }}
    >
      {loading ? <Box sx={{ opacity: 0.8, mb: 1 }}>Loading…</Box> : null}
      {err ? <Box sx={{ color: "#ff7777", mb: 1 }}>{err}</Box> : null}

      {/* {iInsightsJson && (
        <Box>
          <Box
            sx={{
              display: "flex",
              alignItems: "flex-start",
              justifyContent: "space-between",
              gap: 1.5,
              width: "100%",
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: 0.75,
                minWidth: 0,
              }}
            >
              <MatchOutcomeBanner
                insights={iInsightsJson}
                onHoverTeam={setHoverTeamAttr}
              />
            </Box>
          </Box>
        </Box>
      )} */}

      {/* <Box sx={{ display: "flex", justifyContent: "flex-start", mt: "12px" }}>
        <Box
          sx={{
            display: "flex",
            alignItems: "stretch",
            gap: 1.1,
            flexWrap: "wrap",
          }}
        > */}

      {/* <SingleTopFocusCardView
  card={singleTopFocusCard}
  winnerKey={singleTopFocusResult?.topFocus?.key ?? null}
  winnerScore={singleTopFocusResult?.topFocus?.totalScore ?? null}
  onOpenEvidence={(ev) => {
    console.log("singleTopFocus evidence", ev);
  }}
/> */}
      <Box
        sx={{
          display: "block",
          mt: "10px",
          mb: 1.1,
          width: "100%",
          maxWidth: "100%",
          minWidth: 0,
          overflowX: "auto",
          overflowY: "hidden",
          pb: 0.5,
        }}
      >
        <Box
          sx={{
            display: "inline-flex",
            alignItems: "stretch",
            gap: 1.1,
            flexWrap: "nowrap",
            minWidth: "max-content",
            pr: 0.5,
          }}
        >
          <Box
            sx={{
              "--groupLabelLeft": groupLabelLeft,
              position: "relative",
              display: "inline-flex",
              alignItems: "center",
              gap: 1,
              flexWrap: "nowrap",
              flex: "0 0 auto",
              pl: 1.5,
              pr: 0.25,
              pt: 2.15,
              pb: 0.15,
              "&::before": {
                content: '""',
                position: "absolute",
                left: 8,
                right: 0,
                top: 6,
                borderTop: "1px solid rgba(255,255,255,0.22)",
                pointerEvents: "none",
              },
            }}
          >
            <Box
              sx={{
                position: "absolute",
                top: 0,
                left: "var(--groupLabelLeft)",
                px: 0.55,
                fontSize: 14,
                fontWeight: 800,
                letterSpacing: "0.04em",
                color: "rgba(255,255,255,0.78)",
                background: "#000",
                lineHeight: 1,
                zIndex: 1,
              }}
            >
              Patterns
            </Box>

            <Button
              size="small"
              variant="outlined"
              data-happy-path="gs-open-pounce"
              onClick={(e: any) => {
                setPounceWindowsAnchorEl(e.currentTarget);
                setOpenPounceWindowsPopup(true);
              }}
              sx={{
                ...filterToggleSx,
                minWidth: 0,
                px: 0.85,
                py: 0.42,
              }}
            >
              <Box
                sx={{
                  position: "relative",
                  width: 110,
                  height: 36,
                  display: "flex",
                  alignItems: "center",
                  overflow: "visible", // "hidden",
                }}
              >
                <Box
                  sx={{
                    position: "absolute",
                    left: 21, // 24, // 15, //-2,
                    top: "calc(50% + 3px)", // "50%",
                    transform: "translateY(-50%)",
                    zIndex: 1,
                    pointerEvents: "none",
                    opacity: 0.92, //0.88, //0.7, //0.88,
                    overflow: "visible",
                  }}
                >
                  <PounceCatIcon size={41} />
                </Box>

                <Box
                  sx={{
                    position: "absolute",
                    inset: 2,
                    background:
                      "linear-gradient(90deg, rgba(0,0,0,0.72) 0%, rgba(0,0,0,0.46) 42%, rgba(0,0,0,0.08) 72%, rgba(0,0,0,0) 100%)",
                    zIndex: 1,
                  }}
                />

                <Box
                  sx={{
                    position: "absolute",
                    top: 2,
                    bottom: 2,
                    right: 0, //-2,
                    width: 18, // 14,
                    background:
                      "linear-gradient(90deg, rgba(0,0,0,0) 0%, rgba(0,0,0,0.025) 45%, rgba(0,0,0,0.065) 100%)",
                    zIndex: 3,
                    pointerEvents: "none",
                    borderTopRightRadius: "6px",
                    borderBottomRightRadius: "6px",
                  }}
                />
                <Box
                  sx={{
                    position: "absolute",
                    left: 0,
                    top: "50%",
                    transform: "translateY(-50%)",
                    zIndex: 3,
                    width: 84, // 102,
                    textAlign: "left",
                    lineHeight: "16px",
                    //fontWeight: 700,
                    fontSize: 13,
                    color: "rgba(255,255,255,0.98)",
                    textShadow: "0 1px 2px rgba(0,0,0,0.78)",
                    whiteSpace: "normal",
                  }}
                >
                  <Box>Pounce</Box>
                  <Box sx={{ marginLeft: "6px" }}>Opportunities</Box>
                </Box>

                <Box
                  sx={{
                    position: "absolute",
                    top: -3.5,
                    bottom: -2,
                    right: -9,
                    width: 20,
                    pointerEvents: "none",
                    zIndex: 3,
                    overflow: "visible",
                    borderTopRightRadius: "14px 18px",
                    borderBottomRightRadius: "14px 18px",
                    background:
                      "linear-gradient(90deg, rgba(255,120,40,0.00) 0%, rgba(255,140,60,0.08) 58%, rgba(255,190,110,0.16) 100%)",
                    "&::before": {
                      content: '""',
                      position: "absolute",
                      top: 0,
                      bottom: 0,
                      right: 0,
                      width: "2px",
                      borderTopRightRadius: "16px 18px",
                      borderBottomRightRadius: "14px 18px",
                      background: `
        linear-gradient(
          180deg,
          rgba(255,255,255,0.32) 0%,
          rgba(255,255,255,0.22) 40%,
          rgba(255,175,115,0.40) 56%,
          rgba(255,170,110,0.82) 66%,
          rgba(255,195,135,0.52) 77%,
          rgba(255,255,255,0.32) 100%
        )
      `,
                    },
                    "&::after": {
                      content: '""',
                      position: "absolute",
                      inset: 0,
                      borderTopRightRadius: "14px 18px",
                      borderBottomRightRadius: "14px 18px",
                      borderTop: "1px solid rgba(255,255,255,0.26)",
                      borderBottom: "1px solid rgba(255,255,255,0.22)",
                      borderRight: "1px solid transparent",
                      maskImage:
                        "linear-gradient(90deg, transparent 0%, transparent 35%, black 75%, black 100%)",
                      WebkitMaskImage:
                        "linear-gradient(90deg, transparent 0%, transparent 35%, black 75%, black 100%)",
                    },
                  }}
                />
                <Box
                  sx={{
                    position: "absolute",
                    top: -3.5,
                    right: -7,
                    width: 2.5,
                    height: "0.5px",
                    backgroundColor: "rgba(255,255,255,0.22)",
                    pointerEvents: "none",
                    zIndex: 4,
                  }}
                />
              </Box>
            </Button>

            <Button
              size="small"
              variant="outlined"
              data-happy-path="gs-open-third-shot"
              onClick={(e: any) => {
                setThirdShotAnchorEl(e.currentTarget);
                setOpenThirdShotPopup(true);
              }}
              sx={filterToggleSx}
            >
              3rd Shot Locations
            </Button>

            <Button
              size="small"
              variant="outlined"
              data-happy-path="gs-open-fourth-shot"
              onClick={(e: any) => {
                setFourthShotAnchorEl(e.currentTarget);
                setOpenFourthShotPopup(true);
              }}
              sx={filterToggleSx}
            >
              4th Shot Locations
            </Button>

            <Button
              size="small"
              variant="outlined"
              data-happy-path="gs-open-fifth-shot"
              onClick={(e: any) => {
                setFifthShotAnchorEl(e.currentTarget);
                setOpenFifthShotPopup(true);
              }}
              sx={filterToggleSx}
            >
              5th Shot Locations
            </Button>

            <Button
              size="small"
              variant="outlined"
              data-happy-path="gs-open-dinks"
              startIcon={DinkSvgIcon({
                size: 22,
                color: "rgba(255,255,255,0.85)",
              })}
              onClick={(e: any) => {
                setDinkSegmentsAnchorEl(e.currentTarget);
                setOpenDinkSegmentsPopup(true);
              }}
              sx={filterToggleSx}
            >
              Dinks
            </Button>

            <Button
              size="small"
              variant="outlined"
              data-happy-path="gs-open-serve"
              onClick={(e: any) => {
                setServeAnchorEl(e.currentTarget);
                setOpenServePopup(true);
              }}
              sx={filterToggleSx}
            >
              Serve Locations
            </Button>

            <Button
              size="small"
              variant="outlined"
              data-happy-path="gs-open-return"
              onClick={(e: any) => {
                setReturnAnchorEl(e.currentTarget);
                setOpenReturnPopup(true);
              }}
              sx={filterToggleSx}
            >
              Return Locations
            </Button>

            <Button
              size="small"
              variant="outlined"
              data-happy-path="gs-open-serve-return-risk"
              onClick={(e: any) => {
                setServeReturnRiskAnchorEl(e.currentTarget);
                setOpenServeReturnRiskPopup(true);
              }}
              sx={filterToggleSx}
            >
              Serve/Return Risk
            </Button>

          </Box>

          <Box
            sx={{
              "--groupLabelLeft": groupLabelLeft,
              position: "relative",
              display: "inline-flex",
              alignItems: "center",
              gap: 1,
              flexWrap: "nowrap",
              flex: "0 0 auto",
              pl: 1.5,
              pr: 0.25,
              pt: 2.15,
              pb: 0.15,
              "&::before": {
                content: '""',
                position: "absolute",
                left: 8,
                right: 0,
                top: 6,
                borderTop: "1px solid rgba(255,255,255,0.22)",
                pointerEvents: "none",
              },
            }}
          >
            <Box
              sx={{
                position: "absolute",
                top: 0,
                left: "var(--groupLabelLeft)",
                px: 0.55,
                fontSize: 14,
                fontWeight: 800,
                letterSpacing: "0.04em",
                color: "rgba(255,255,255,0.78)",
                background: "#000",
                lineHeight: 1,
                zIndex: 1,
              }}
            >
              Moments
            </Box>

            <Box
              sx={{
                display: "none",
                alignItems: "center",
                gap: 1,
                minWidth: 150,
              }}
            >
              <FormControl size="small" sx={{ minWidth: 140 }}>
                <Select
                  value={String(fastReactionMs)}
                  onChange={(e: any) =>
                    setFastReactionMs(Number(e.target.value))
                  }
                  displayEmpty
                  MenuProps={{
                    PaperProps: {
                      sx: {
                        mt: 0.75,
                        borderRadius: 1.5,
                        bgcolor: "rgba(20,20,20,0.96)",
                        border: "1px solid rgba(255,255,255,0.14)",
                        "& .MuiMenuItem-root": {
                          fontSize: 12,
                          fontWeight: 800,
                          color: "rgba(255,255,255,0.92)",
                        },
                        "& .MuiMenuItem-root.Mui-selected": {
                          bgcolor: "rgba(255,255,255,0.12)",
                        },
                        "& .MuiMenuItem-root.Mui-selected:hover": {
                          bgcolor: "rgba(255,255,255,0.16)",
                        },
                        "& .MuiMenuItem-root:hover": {
                          bgcolor: "rgba(255,255,255,0.10)",
                        },
                      },
                    },
                  }}
                  sx={{
                    height: 24,
                    borderRadius: 1,
                    fontSize: 12,
                    fontWeight: 900,
                    bgcolor: "rgba(0,0,0,0.20)",
                    color: "rgba(255,255,255,0.92)",
                    border: "1px solid rgba(255,255,255,0.22)",
                    "&:hover": { borderColor: "rgba(255,255,255,0.40)" },
                    "&.Mui-focused": { borderColor: "rgba(255,255,255,0.55)" },
                    "& .MuiOutlinedInput-notchedOutline": { border: "none" },
                    "& .MuiSelect-select": {
                      py: 0,
                      pl: 1,
                      pr: 3.0,
                      display: "flex",
                      alignItems: "center",
                    },
                    "& .MuiSelect-icon": {
                      color: "rgba(255,255,255,0.70)",
                      right: 8,
                    },
                  }}
                >
                  {FAST_REACTION_MS_OPTIONS.map((ms) => (
                    <MenuItem key={ms} value={String(ms)}>
                      ≤ {ms}ms
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>

            <Button
              size="small"
              variant="outlined"
              data-happy-path="gs-open-shot-quality"
              startIcon={
                <Box
                  sx={{
                    width: 18,
                    height: 18,
                    borderRadius: "5px",
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                    backgroundColor: "rgba(212, 175, 55, 0.16)",
                    // border: "1px solid rgba(212, 175, 55, 0.34)",
                  }}
                >
                  <StarIcon
                    sx={{ fontSize: 12, color: "rgba(235, 200, 90, 0.95)" }}
                  />
                </Box>
              }
              onClick={(e: any) => {
                setShotQualityAnchorEl(e.currentTarget);
                setOpenShotQualityPopup(true);
              }}
              sx={filterToggleSx}
            >
              Shot Quality
            </Button>

            <Button
              size="small"
              variant="outlined"
              data-happy-path="gs-open-rally-quality"
              startIcon={
                <Box
                  sx={{
                    width: 18,
                    height: 18,
                    borderRadius: "5px",
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                    backgroundColor: "rgba(255,255,255,0.08)",
                  }}
                >
                  📈
                </Box>
              }
              onClick={(e: any) => {
                setRallyQualityOverviewAnchorEl(e.currentTarget);
                setOpenRallyQualityOverviewPopup(true);
              }}
              sx={filterToggleSx}
            >
              Rally Quality
            </Button>

            {/* <Button
              size="small"
              variant="outlined"
              startIcon={
                <Box
                  sx={{
                    width: 18,
                    height: 18,
                    borderRadius: "5px",
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                    backgroundColor: "rgba(255,255,255,0.08)",
                  }}
                >
                  📈
                </Box>
              }
              onClick={(e: any) => {
                //setRallyQualityOverviewAnchorEl(e.currentTarget);
                setOpenRallyCausalityOverviewPopup(true);
              }}
              sx={filterToggleSx}
            >
              Rally Causality
            </Button> */}

            <Button
              size="small"
              variant="outlined"
              data-happy-path="gs-open-fast-shots"
              startIcon={iconFastShot(10)}
              onClick={(e: any) => {
                setFastShotsAnchorEl(e.currentTarget);
                setOpenFastShotsPopup(true);
              }}
              sx={filterToggleSx}
            >
              Fast shots
            </Button>

            <Button
              size="small"
              variant="outlined"
              data-happy-path="gs-open-candidate-speedups"
              startIcon={<FlashOnIcon sx={{ fontSize: 14 }} />}
              onClick={() => {
                setOpenCandidateSpeedupsPopup(true);
              }}
              sx={filterToggleSx}
            >
              Speedups
            </Button>

            <Button
              size="small"
              variant="outlined"
              data-happy-path="gs-open-possible-popups"
              startIcon={<FlashOnIcon sx={{ fontSize: 14, color: "#ef6c00" }} />}
              onClick={() => {
                setOpenPossiblePopupsPopup(true);
              }}
              sx={filterToggleSx}
            >
              Possible Popups
            </Button>

            {SHOW_CANDIDATE_BODYBAGS_POPUP ? (
              <Button
                size="small"
                variant="outlined"
                data-happy-path="gs-open-candidate-bodybags"
                startIcon={<FlashOnIcon sx={{ fontSize: 14, color: "#ce93d8" }} />}
                onClick={() => {
                  setOpenCandidateBodybagsPopup(true);
                }}
                sx={filterToggleSx}
              >
                Jammed / Bodybags
              </Button>
            ) : null}

            <Button
              size="small"
              variant="outlined"
              data-happy-path="gs-open-paddle-readiness"
              startIcon={<PaddleReadinessIcon size={16} />}
              onClick={() => {
                setOpenPaddleReadinessPopup(true);
              }}
              sx={filterToggleSx}
            >
              Paddle Readiness
            </Button>

            <Button
              size="small"
              variant="outlined"
              data-happy-path="gs-open-dink-readiness"
              startIcon={<PaddleReadinessIcon size={16} />}
              onClick={() => {
                setOpenDinkReadinessPopup(true);
              }}
              sx={filterToggleSx}
            >
              Dink Focus
            </Button>

            <Button
              size="small"
              variant="outlined"
              data-happy-path="gs-open-left-side-coverage"
              startIcon={<LeftRightCoverageIcon size={16} />}
              onClick={() => {
                setOpenLeftSideCoveragePopup(true);
              }}
              sx={filterToggleSx}
            >
              Left Coverage
            </Button>

            <Button
              size="small"
              variant="outlined"
              data-happy-path="gs-open-atps"
              startIcon={<SportsTennisIcon sx={{ fontSize: 14 }} />}
              onClick={(e: any) => {
                setAtpAnchorEl(e.currentTarget);
                setOpenAtpPopup(true);
              }}
              sx={filterToggleSx}
            >
              ATPs
            </Button>

            <Button
              size="small"
              variant="outlined"
              data-happy-path="gs-open-fast-reactions"
              startIcon={iconReaction(14)}
              onClick={(e: any) => {
                setFastReactionsAnchorEl(e.currentTarget);
                setOpenFastReactionsPopup(true);
              }}
              sx={filterToggleSx}
            >
              Fast reactions
            </Button>
            <Button
              size="small"
              variant="outlined"
              data-happy-path="gs-open-firefights"
              startIcon={<>🔥</>}
              onClick={(e: any) => {
                setFirefightsAnchorEl(e.currentTarget);
                setOpenFirefights(true);
              }}
              sx={filterToggleSx}
            >
              Firefights
            </Button>
          </Box>

          <Box
            sx={{
              "--groupLabelLeft": groupLabelLeft,
              position: "relative",
              display: "inline-flex",
              alignItems: "center",
              gap: 1,
              flexWrap: "nowrap",
              flex: "0 0 auto",
              pl: 1.5,
              pr: 0.25,
              pt: 2.15,
              pb: 0.15,
              "&::before": {
                content: '""',
                position: "absolute",
                left: 8,
                right: 0,
                top: 6,
                borderTop: "1px solid rgba(255,255,255,0.22)",
                pointerEvents: "none",
              },
            }}
          >
            <Box
              sx={{
                position: "absolute",
                top: 0,
                left: "var(--groupLabelLeft)",
                px: 0.55,
                fontSize: 14,
                fontWeight: 800,
                letterSpacing: "0.04em",
                color: "rgba(255,255,255,0.78)",
                background: "#000",
                lineHeight: 1,
                zIndex: 1,
              }}
            >
              Other
            </Box>

            <Select
              size="small"
              data-happy-path="gs-open-experiments"
              displayEmpty
              value=""
              onChange={(event) => {
                const key = String(event.target.value || "");
                openExperiment(key);
              }}
              renderValue={() => "Experiments"}
              sx={{
                ...filterToggleSx,
                minWidth: 128,
                height: 30,
                "& .MuiSelect-select": {
                  py: 0.45,
                  pl: 1.25,
                  pr: "28px !important",
                  fontSize: 13,
                  fontWeight: 600,
                },
                "& .MuiOutlinedInput-notchedOutline": {
                  borderColor: "rgba(102,179,255,0.35)",
                },
                "& .MuiSelect-icon": {
                  color: "#66b3ff",
                },
              }}
              MenuProps={{
                PaperProps: {
                  sx: {
                    bgcolor: "#111",
                    color: "rgba(255,255,255,0.88)",
                    border: "1px solid rgba(255,255,255,0.18)",
                    "& .MuiMenuItem-root": {
                      fontSize: 13,
                      minHeight: 30,
                    },
                  },
                },
              }}
            >
              <MenuItem
                value="positioningPatterns"
                data-happy-path="gs-experiment-positioningPatterns"
              >
                Positioning Patterns
              </MenuItem>
              <MenuItem value="matchIdentity" data-happy-path="gs-experiment-matchIdentity">
                Match Identity
              </MenuItem>
              <MenuItem value="rallyCausality" data-happy-path="gs-experiment-rallyCausality">
                Rally Causality
              </MenuItem>
              <MenuItem value="singleTopFocus" data-happy-path="gs-experiment-singleTopFocus">
                Single Top Focus
              </MenuItem>
              <MenuItem value="trajectoryWall" data-happy-path="gs-experiment-trajectoryWall">
                Trajectory Wall
              </MenuItem>
              <MenuItem
                value="pointsAddedReport"
                data-happy-path="gs-experiment-pointsAddedReport"
              >
                Points Added Report
              </MenuItem>
            </Select>

            <Button
              size="small"
              variant="outlined"
              data-happy-path="gs-open-ai-history"
              onClick={() => {
                setAiHistoryOpen(true);
              }}
              sx={filterToggleSx}
            >
              AI History
            </Button>

            <Button
              size="small"
              variant="outlined"
              data-happy-path="gs-open-full-game-ai"
              onClick={() => setOpenGameAiPopup(true)}
              sx={filterToggleSx}
            >
              Full Game AI (WIP)
            </Button>

          </Box>
        </Box>
      </Box>

      {/* <Box
        sx={{
          display: "none", //"flex",
          flexDirection: "column",
          gap: 0.75,
          alignItems: "stretch",
          flexWrap: "nowrap",
          mt: 0.75,
          mb: 0.75,
        }}
      >
        <Typography sx={{ fontSize: 12, fontWeight: 800, opacity: 0.8 }}>
          Stakes:
        </Typography>

        {(
          [
            ["opportunityLost", "Opportunity lost"],
            ["gamePointLost", "Game point lost"],
          ] as const
        ).map(([st, stLabel], iWhich) => {
          const selectedStake = activeStakeFilters.includes(st);
          const c = stakeCounts[st];
          const totalStake = (c?.t0 ?? 0) + (c?.t1 ?? 0);

          return (
            <Box
              key={st}
              sx={{
                display: "flex",
                gap: 1,
                alignItems: "center",
                flexWrap: "wrap",
              }}
            >
              <Box>{stLabel}</Box>

              {(
                [
                  "faultNet",
                  "faultOut",
                  "unforcedError",
                  "forcedFault",
                  "popupExploited",
                  "missedServe",
                  "missedReturn",
                  "missed3rdDrop",
                  "missed3rdDrive",
                ] as StoryFilterKey[]
              ).map((k) => {
                const b = storyFilterBuckets[k];
                const sb = b?.stakes?.[st];
                const total = (sb?.t0 ?? 0) + (sb?.t1 ?? 0);
                const selected = hasStakeStoryFilter(
                  activeStoryFiltersByStake,
                  st,
                  k,
                );

                const sel0 = isTeamSelected(st, k, 0);
                const sel1 = isTeamSelected(st, k, 1);
                const anySel = sel0 || sel1;

                return (
                  <Tooltip
                    key={`${st}:${k}`}
                    title={
                      total === 0 ? "No rallies match this filter" : undefined //"Click to filter the timeline"
                    }
                    arrow
                  >
                    <span>
                      <Chip
                        clickable={false}
                        disabled={total === 0}
                        // onClick={() => {
                        //   if (total === 0) return;
                        //   setActiveStoryFiltersByStake((prev) =>
                        //     toggleStakeStoryFilter(prev, st, k),
                        //   );
                        // }}
                        icon={selected ? <DoneIcon /> : undefined}
                        label={
                          <Box
                            sx={{
                              display: "inline-flex",
                              alignItems: "center",
                            }}
                          >
                            <Box
                              sx={{
                                fontWeight: 800,
                                fontSize: 11,
                                marginRight: "3px",
                              }}
                            >
                              {b.label}
                            </Box>


                            <CountPill
                              n={sb?.t0 ?? 0}
                              bg={teamRgba(Team_0, 0.85)}
                              selected={sel0}
                              onClick={() => {
                                if (sb?.t0 ?? 0) toggleTeam(st, k, 0);
                              }}
                            />

                            <CountPill
                              n={sb?.t1 ?? 0}
                              bg={teamRgba(Team_1, 0.8)}
                              selected={sel1}
                              onClick={() => {
                                if (sb?.t1 ?? 0) toggleTeam(st, k, 1);
                              }}
                            />
                          </Box>
                        }
                        variant={selected ? "filled" : "outlined"}
                        sx={{
                          cursor: "default",
                          fontWeight: 800,
                          opacity: total === 0 ? 0.4 : 1,
                          ...(selected
                            ? {
                                borderColor: "rgba(255,255,255,0.70)",
                                bgcolor: "rgba(255,255,255,0.16)",
                              }
                            : {
                                borderColor: "rgba(255,255,255,0.22)",
                                bgcolor: "rgba(0,0,0,0.06)",
                              }),
                        }}
                      />
                    </span>
                  </Tooltip>
                );
              })}

              {Boolean(activeStoryFiltersByStake[st]?.length) ? (
                <Chip
                  clickable
                  onClick={() =>
                    setActiveStoryFiltersByStake((prev) => {
                      const out = { ...prev };
                      delete out[st];
                      return out;
                    })
                  }
                  icon={<ClearIcon />}
                  label="Clear"
                  variant="outlined"
                  sx={{ fontWeight: 800, opacity: 0.9 }}
                />
              ) : null}
            </Box>
          );
        })}

        {Object.keys(activeStoryFiltersByStake).length > 0 ||
        activeStakeFilters.length > 0 ? (
          <Chip
            clickable
            onClick={() => {
              setActiveStoryFiltersByStake({});
              setActiveStakeFilters([]);
            }}
            icon={<ClearIcon />}
            label="Clear all"
            variant="outlined"
            sx={{ fontWeight: 800, opacity: 0.9, alignSelf: "flex-start" }}
          />
        ) : null}
      </Box> */}

      <Box
        data-demo="game-story-timeline"
        sx={{
          flex: "0 0 auto",
          width: "100%",
          maxWidth: "100%",
          minWidth: 0,
          overflowX: "hidden",
          borderBottom: "1px solid rgba(0,0,0,0.12)",
        }}
      >
        <CondensedRallyTimeline
          rallyBadgesRef={rallyBadgesRef}
          rows={rows}
          includedRallies={includedRallies}
          activeRallyIndex={activeRow?.rallyIndex ?? null}
          onPickRally={(rallyIndex: number) => pickRallyIndex(rallyIndex)}
          barsAreaHeightPx={timelineBarsH}
          onHoverBadge={setHoveredBadge}
          activeBadgeFilter={activeBadgeFilter}
          firefightRallySet={firefightRallySet}
          matchImpactFacts={matchImpactFacts}
        />
        {/* drag handle */}
        <Box
          onMouseDown={onTimelineResizeMouseDown}
          sx={{
            mt: 0.75,
            height: 10,
            cursor: "row-resize",
            borderRadius: 999,
            userSelect: "none",
            // background: "rgba(0,0,0,0.06)",
            // "&:hover": { background: "rgba(0,0,0,0.12)" },

            background: "rgba(255,255,255,0.08)",
            "&:hover": { background: "rgba(255,255,255,0.14)" },
          }}
        />
      </Box>

      <Box
        sx={{
          display: "flex",
          gap: 1.5,
          marginTop: "6px",
          mb: 1.75,
          alignItems: "stretch",
          width: "100%",
          maxWidth: "100%",
          minWidth: 0,
          overflowX: "hidden",
        }}
      >
        {/* MIDDLE: video */}
        <Box
          data-demo="main-active-rally-video"
          sx={{
            flex: "0 0 auto",
            width: 640,
            maxWidth: "44vw",
            maxHeight: 360,
            color: "black",
          }}
        >
          <ActiveRallyVideo
            renderPlayerIdentity={renderPlayerIdentity}
            resolvePlayerAvatarSrc={resolvePlayerAvatarSrc}
            aiContextLabel="Main Screen"
            insightsToCvPlayerIndex={insightsToCvPlayerIndex}
            focusedFilter={focusedFilter}
            focusedPlayerId={focusedPlayerId}
            cvJson={cvJson}
            controlsPlacement="left" // "top"
            packageId={packageId}
            row={activeRow}
            rows={rows}
            showAi={false}
            showCondensedTimeline={false}
            showShotSpaceButton={true}
            onOpenShotSpace={openShotTargetLab}
            showShotBookmarksButton={true}
            shotBookmarksCount={shotBookmarks.length}
            onOpenShotBookmarks={() => setShotBookmarksOpen(true)}
            onBookmarkShot={handleBookmarkShotFromVideo}
            onOpenRallyFromSimilarPopup={pickRallyIndex}
            fontColor={"white"}
            activeShotNumber={activeShotNumber}
            rallyLensMoments={activeRallyLensMoments}
            seedPlayback={
              bookmarkPlaybackSeed ??
              (mainPlaybackSeed &&
              mainPlaybackSeed.rallyIndex === activeRow?.rallyIndex
                ? {
                    timeSec: mainPlaybackSeed.timeSec,
                    paused: mainPlaybackSeed.paused,
                    nonce: mainPlaybackSeed.nonce,
                  }
                : undefined)
            }
            seedLoopRegion={
              mainLoopSeed &&
              mainLoopSeed.rallyIndex === activeRow?.rallyIndex
                ? {
                    enabled: mainLoopSeed.enabled,
                    aSec: mainLoopSeed.aSec,
                    bSec: mainLoopSeed.bSec,
                    nonce: mainLoopSeed.nonce,
                  }
                : undefined
            }
            beginningScore={
              activeRow
                ? (scoreTimeline.before.get(activeRow.rallyIndex) ?? null)
                : null
            }
            endingScore={
              activeRow
                ? (scoreTimeline.after.get(activeRow.rallyIndex) ?? null)
                : null
            }
            firefightsClips={firefightClips}
            firefightRallySet={firefightRallySet}
            //onClipFocusChange={setClipFocusForAsk}
          />
          <Button
            size="small"
            variant="outlined"
            data-happy-path="gs-open-opportunity-finder"
            onClick={() => setOpenOpportunityFinder(true)}
            sx={{
              mt: 0.75,
              mr: 0.75,
              color: "#fff",
              borderColor: "rgba(255,255,255,0.35)",
              textTransform: "none",
              fontWeight: 850,
              bgcolor: "rgba(0,0,0,0.18)",
              "&:hover": {
                borderColor: "rgba(255,255,255,0.62)",
                bgcolor: "rgba(255,255,255,0.1)",
              },
            }}
          >
            Opportunity Finder
          </Button>
          {titoShotLabCandidateRow ? (
            <Button
              size="small"
              variant="outlined"
              onClick={openTitoShotLabCandidate}
              sx={{
                mt: 0.75,
                color: "#fff",
                borderColor: "rgba(255,255,255,0.35)",
                textTransform: "none",
                fontWeight: 850,
                bgcolor: "rgba(0,0,0,0.18)",
                "&:hover": {
                  borderColor: "rgba(255,255,255,0.62)",
                  bgcolor: "rgba(255,255,255,0.1)",
                },
              }}
            >
              Open Tito Qtrs Rally 24 Shot 19
            </Button>
          ) : null}
        </Box>

        {/* RIGHT: Ask AI */}
        <Box
          sx={{
            flex: `0 0 ${askOpen ? ASK_W_OPEN : ASK_W_CLOSED}px`,
            width: askOpen ? ASK_W_OPEN : ASK_W_CLOSED,
            transition: "width 160ms ease",
            minWidth: 0,
            position: "relative",
          }}
        >
          {/* The skinny rail stays visible even when closed */}
          <Box
            data-demo="ask-ai-rail"
            onClick={() => setAskOpen((v) => !v)}
            sx={{
              position: "absolute",
              left: 0,
              top: 0,
              bottom: 0,
              width: askOpen ? 0 : ASK_W_CLOSED,
              // display: "flex",
              display: askOpen ? "none" : "flex",
              flexDirection: "column",
              alignItems: "center",
              pt: 1,
              border: "1px solid rgba(255,255,255,0.12)",
              borderRadius: 2,
              bgcolor: "rgba(255,255,255,0.03)",
              cursor: "pointer",
            }}
          >
            <Box
              sx={{
                mt: 0.5,
                writingMode: "vertical-rl",
                transform: "rotate(180deg)",
                fontSize: 14,
                color: "white",
                //opacity: 0.75,
                userSelect: "none",
                letterSpacing: 0.5,
              }}
            >
              Ask AI about Rally
            </Box>
          </Box>

          {/* Expanded content area */}
          <Box
            sx={{
              ml: "6px",
              height: "100%",
              overflow: "hidden",
              display: askOpen ? "flex" : "none",
              flexDirection: "column",
              border: "1px solid rgba(255,255,255,0.12)",
              borderRadius: 2,
              bgcolor: "rgba(20,20,20,0.55)",
            }}
          >
            <Box
              sx={{
                px: 1.25,
                py: 0.75,
                display: "flex",
                alignItems: "center",
                gap: 1,
                borderBottom: "1px solid rgba(255,255,255,0.10)",
              }}
            >
              <Box sx={{ fontWeight: 900, fontSize: 13 }}>
                {"Ask AI about Rally " +
                  `${activeRow ? activeRow?.rallyIndex + 1 : ""}`}
              </Box>
              <Box sx={{ flex: 1 }} />
              <IconButton
                size="small"
                data-demo="ask-ai-close"
                onClick={() => setAskOpen(false)}
              >
                <CloseIcon sx={{ color: "red" }} fontSize="small" />
              </IconButton>
            </Box>

            <Box sx={{ p: 1.0, overflow: "auto", minHeight: 0 }}>
              <AskAiPanel
                noTitleStuff={true}
                packageId={packageId}
                row={activeRow}
                turns={activeRow ? (turnsByKey[rallyKey(activeRow)] ?? []) : []}
                onAskAi={handleAskAi}
                onDeleteTurn={handleDeleteTurn}
              />
            </Box>
          </Box>
        </Box>

        <Box>
          <Box
            sx={{
              textAlign: "center",
              flex: "1 1 auto",
              minWidth: 0,
              display: "flex",
              gap: 1.25,
              alignItems: "stretch",
              marginLeft: "8px",
              marginRight: 0,
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 0.75,
              }}
            >
              <Box
                sx={{
                  fontSize: 14,
                  fontWeight: 700,
                  color: "rgba(255,255,255,0.82)",
                }}
              >
                Player focus:
              </Box>

              <Box
                data-demo="player-focus-selector"
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 0.4,
                  px: 0.5,
                  py: 0.35,
                  borderRadius: 2,
                  bgcolor: "rgba(255,255,255,0.04)",
                  border: "1px solid transparent", //  rgba(255,255,255,0.10)",
                }}
              >
                {[
                  { key: "all", label: "All", playerId: null },
                  { key: "p0", label: "p0", playerId: 0 },
                  { key: "p1", label: "p1", playerId: 1 },
                  { key: "p2", label: "p2", playerId: 2 },
                  { key: "p3", label: "p3", playerId: 3 },
                ].map((item) => {
                  const active = focusedPlayerId === item.playerId;

                  return (
                    <Box
                      key={item.key}
                      data-demo={`player-focus-${item.key}`}
                      data-player-id={item.playerId == null ? "" : String(item.playerId)}
                      data-selected={active ? "true" : "false"}
                      onClick={() => {
                        // console.error("click setFocusedPlayerId", item.playerId);
                        setFocusedPlayerId(item.playerId);
                      }}
                      sx={{
                        px: 1,
                        py: 0.45,
                        borderRadius: 1.5,
                        fontSize: 13,
                        fontWeight: 800,
                        lineHeight: 1,
                        cursor: "pointer",
                        userSelect: "none",
                        color: "white",
                        bgcolor: active
                          ? "rgba(255,255,255,0.18)"
                          : "rgba(255,255,255,0.04)",
                        border: active
                          ? "1px solid rgba(255,255,255,0.25)"
                          : "1px solid rgba(255,255,255,0.08)",
                        "&:hover": {
                          bgcolor: active
                            ? "rgba(255,255,255,0.22)"
                            : "rgba(255,255,255,0.10)",
                        },
                      }}
                    >
                      {typeof item.playerId === "number" && (
                        <Box sx={{ fontSize: 11, marginBottom: "4px" }}>
                          p{item.playerId}
                        </Box>
                      )}
                      {typeof item.playerId === "number" &&
                      playerIdToAvatarBase64[item.playerId] ? (
                        <img
                          src={
                            playerIdToAvatarBase64[item.playerId].startsWith(
                              "data:",
                            )
                              ? playerIdToAvatarBase64[item.playerId]
                              : `data:image/jpeg;base64,${playerIdToAvatarBase64[item.playerId]}`
                          }
                          //alt={`p${item.playerId}`}
                          style={{
                            width: 50,
                            height: 50,
                            borderRadius: "2px",
                            objectFit: "fill", //"cover",
                            objectPosition: "center",
                            display: "block",
                            border:
                              teamRgba(
                                playerIdToTeamForPopup(item.playerId) as Team01,
                                0.85,
                              ) + " solid 2px",
                          }}
                        />
                      ) : (
                        item.label
                      )}
                    </Box>
                  );
                })}
              </Box>
            </Box>
            <Button
              data-demo="clear-story-filters"
              size="small"
              variant="outlined"
              startIcon={<ClearIcon />}
              onClick={clearAllStoryFilters}
              sx={{
                color: "rgba(255,255,255,0.82)",
                borderColor: "rgba(255,255,255,0.16)",
                minWidth: "auto",
                px: 0.9,
                py: 0.5,
                alignSelf: "center",
                textTransform: "none",
                fontWeight: 700,
                fontSize: 14,
                "&:hover": {
                  borderColor: "rgba(255,255,255,0.28)",
                  backgroundColor: "rgba(255,255,255,0.04)",
                  color: "rgba(255,255,255,0.92)",
                },
              }}
            >
              Clear Filters
            </Button>
          </Box>

          <Box
            sx={{
              textAlign: "center",
              flex: "1 1 auto",
              minWidth: 0,
              display: "flex",
              gap: 0.85,
              alignItems: "stretch",
              overflowX: "hidden",
              mb: 0.8,
            }}
          >
            <Box sx={{ flex: "1 1 0", minWidth: 0, overflowX: "hidden" }}>
              <TeamReasonsTable
                team={0}
                // storyFilterBuckets={storyFilterBuckets}
                storyFilterBuckets={storyFilterBucketsForFocusedPlayer}
                focusedPlayerId={focusedPlayerId}
                activeStoryFilters={activeStoryFilters}
                // setActiveStoryFilters={setActiveStoryFilters}
                selectedRallyBadges={selectedRallyBadges}
                hoveredBadge={hoveredBadge}
                getReasonPreviewSegments={getReasonPreviewSegments}
                onFocusedFilterChange={handleFocusedFilterChange}
                focusedFilter={focusedFilter}
              />
            </Box>

            <Box sx={{ flex: "1 1 0", minWidth: 0, overflowX: "hidden" }}>
              <TeamReasonsTable
                team={1}
                // storyFilterBuckets={storyFilterBuckets}
                storyFilterBuckets={storyFilterBucketsForFocusedPlayer}
                focusedPlayerId={focusedPlayerId}
                activeStoryFilters={activeStoryFilters}
                // setActiveStoryFilters={setActiveStoryFilters}
                selectedRallyBadges={selectedRallyBadges}
                hoveredBadge={hoveredBadge}
                getReasonPreviewSegments={getReasonPreviewSegments}
                onFocusedFilterChange={handleFocusedFilterChange}
                focusedFilter={focusedFilter}
              />
            </Box>
          </Box>
        </Box>
      </Box>

      {happyPathHooksEnabled ? (
        <>
          <Box
            data-happy-path="gs-popup-state"
            data-open-pounce={openPounceWindowsPopup ? "true" : "false"}
            data-open-third-shot={openThirdShotPopup ? "true" : "false"}
            data-open-fourth-shot={openFourthShotPopup ? "true" : "false"}
            data-open-fifth-shot={openFifthShotPopup ? "true" : "false"}
            data-open-dinks={openDinkSegmentsPopup ? "true" : "false"}
            data-open-serve={openServePopup ? "true" : "false"}
            data-open-return={openReturnPopup ? "true" : "false"}
            data-open-serve-return-risk={
              openServeReturnRiskPopup ? "true" : "false"
            }
            data-open-shot-quality={openShotQualityPopup ? "true" : "false"}
            data-open-rally-quality={
              openRallyQualityOverviewPopup ? "true" : "false"
            }
            data-open-fast-shots={openFastShotsPopup ? "true" : "false"}
            data-open-candidate-speedups={
              openCandidateSpeedupsPopup ? "true" : "false"
            }
            data-open-candidate-bodybags={
              openCandidateBodybagsPopup ? "true" : "false"
            }
            data-open-possible-popups={
              openPossiblePopupsPopup ? "true" : "false"
            }
            data-open-paddle-readiness={
              openPaddleReadinessPopup ? "true" : "false"
            }
            data-open-dink-readiness={
              openDinkReadinessPopup ? "true" : "false"
            }
            data-open-left-side-coverage={
              openLeftSideCoveragePopup ? "true" : "false"
            }
            data-open-atps={openAtpPopup ? "true" : "false"}
            data-open-fast-reactions={
              openFastReactionsPopup ? "true" : "false"
            }
            data-open-firefights={openFirefights ? "true" : "false"}
            data-open-points-added-report={
              openPointsAddedPopup ? "true" : "false"
            }
            data-open-ai-history={aiHistoryOpen ? "true" : "false"}
            data-open-full-game-ai={openGameAiPopup ? "true" : "false"}
            data-open-experiment-positioning-patterns={
              openExperimentPositioningPatterns ? "true" : "false"
            }
            data-open-experiment-match-identity={
              matchIdentityOpen ? "true" : "false"
            }
            data-open-experiment-rally-causality={
              openRallyCausalityOverviewPopup ? "true" : "false"
            }
            data-open-experiment-single-top-focus={
              openExperimentSingleTopFocus ? "true" : "false"
            }
            data-open-experiment-trajectory-wall={
              openTrajectoryWall ? "true" : "false"
            }
            data-open-start-here={openQuickTriage ? "true" : "false"}
            data-open-player-lens={openPlayerLensReview ? "true" : "false"}
            sx={{ display: "none" }}
          />
          <Button
            data-happy-path="gs-close-all-popups"
            aria-hidden="true"
            tabIndex={-1}
            onClick={closeHappyPathPopups}
            sx={{ display: "none" }}
          >
            Close happy path popups
          </Button>
        </>
      ) : null}

      <ThirdShotLocationsPopup
        insightsToCvPlayerIndex={insightsToCvPlayerIndex}
        renderPlayerIdentity={renderPlayerIdentity}
        open={openThirdShotPopup}
        anchorEl={thirdShotAnchorEl}
        onClose={() => {
          setOpenThirdShotPopup(false);
          setThirdShotAnchorEl(null);
        }}
        packageId={packageId}
        rows={rows}
        popupH_VideoPart={1000}
        popupW_VideoPart={1000}
        // popupW={800}
        // popupH={1000}
        playerIdToTeam={playerIdToTeamForPopup}
        teamColor={(team, alpha) => teamRgba(team, alpha ?? 1)}
        firefightsClips={firefightClips}
        firefightRallySet={firefightRallySet}
      />

      <FourthShotLocationsPopup
        insightsToCvPlayerIndex={insightsToCvPlayerIndex}
        renderPlayerIdentity={renderPlayerIdentity}
        open={openFourthShotPopup}
        anchorEl={fourthShotAnchorEl}
        onClose={() => {
          setOpenFourthShotPopup(false);
          setFourthShotAnchorEl(null);
        }}
        packageId={packageId}
        rows={rows}
        popupH_VideoPart={1000}
        popupW_VideoPart={1000}
        // popupW={800}
        // popupH={1000}
        playerIdToTeam={playerIdToTeamForPopup}
        teamColor={(team, alpha) => teamRgba(team, alpha ?? 1)}
        firefightsClips={firefightClips}
        firefightRallySet={firefightRallySet}
      />

            <FifthShotLocationsPopup
        insightsToCvPlayerIndex={insightsToCvPlayerIndex}
        renderPlayerIdentity={renderPlayerIdentity}
        open={openFifthShotPopup}
        anchorEl={fifthShotAnchorEl}
        onClose={() => {
          setOpenFifthShotPopup(false);
          setFifthShotAnchorEl(null);
        }}
        packageId={packageId}
        rows={rows}
        popupH_VideoPart={1000}
        popupW_VideoPart={1000}
        // popupW={800}
        // popupH={1000}
        playerIdToTeam={playerIdToTeamForPopup}
        teamColor={(team, alpha) => teamRgba(team, alpha ?? 1)}
        firefightsClips={firefightClips}
        firefightRallySet={firefightRallySet}
      />

      <ShotQualityPopup
        insightsToCvPlayerIndex={insightsToCvPlayerIndex}
        renderPlayerIdentity={renderPlayerIdentity}
        open={openShotQualityPopup}
        anchorEl={shotQualityAnchorEl}
        onClose={() => setOpenShotQualityPopup(false)}
        packageId={packageId}
        activeRallyIndex={activeRow?.rallyIndex ?? null}
        clipsThisRally={shotQualityClipsThisRally}
        clipsAll={shotQualityClipsAll}
        teamColor={(team: Team01, alpha: any) => teamRgba(team, alpha ?? 1)}
        rows={rows}
        firefightsClips={firefightClips}
        firefightRallySet={firefightRallySet}
      />

      <FastReactionsPopup
        insightsToCvPlayerIndex={insightsToCvPlayerIndex}
        renderPlayerIdentity={renderPlayerIdentity}
        open={openFastReactionsPopup}
        anchorEl={fastReactionsAnchorEl}
        onClose={() => setOpenFastReactionsPopup(false)}
        packageId={packageId}
        activeRallyIndex={activeRow?.rallyIndex ?? null}
        clipsThisRally={fastReactionClipsThisRally}
        clipsAll={fastReactionClipsAll}
        playerLabel={(id) => `P${id}`}
        teamLabel={(t) => (t === 0 ? "Team 0" : "Team 1")}
        teamColor={(team, alpha) => teamRgba(team, alpha ?? 1)}
        rows={rows}
        firefightsClips={firefightClips}
        firefightRallySet={firefightRallySet}
      />

      <RallyCausalityOverviewPopup
        //cvJson={cvJson}
        insightsToCvPlayerIndex={insightsToCvPlayerIndex}
        renderPlayerIdentity={renderPlayerIdentity}
        pounceWindowRows={pounceWindowRows}
        open={openRallyCausalityOverviewPopup}
        //anchorEl={pounceWindowsAnchorEl}
        onClose={() => setOpenRallyCausalityOverviewPopup(false)}
        packageId={packageId}
        activeRallyIndex={activeRow?.rallyIndex ?? null}
        rows={rows}
        firefightsClips={firefightClips}
        firefightRallySet={firefightRallySet}
        cvJson={cvJson}
        //teamColor={(team, alpha) => teamRgba(team, alpha ?? 1)}
      />

      <PounceWindowsPopup
        cvJson={cvJson}
        insightsToCvPlayerIndex={insightsToCvPlayerIndex}
        renderPlayerIdentity={renderPlayerIdentity}
        pounceWindowRows={pounceWindowRows}
        open={openPounceWindowsPopup}
        anchorEl={pounceWindowsAnchorEl}
        onClose={() => setOpenPounceWindowsPopup(false)}
        packageId={packageId}
        activeRallyIndex={activeRow?.rallyIndex ?? null}
        //clipsThisRally={fastReactionClipsThisRally}
        //clipsAll={fastReactionClipsAll}
        //playerLabel={(id) => `P${id}`}
        // teamLabel={(t) => (t === 0 ? "Team 0" : "Team 1")}
        //         teamColor={(team, alpha) => teamRgba(team, alpha ?? 1)}

        rows={rows}
        firefightsClips={firefightClips}
        firefightRallySet={firefightRallySet}
        teamColor={(team, alpha) => teamRgba(team, alpha ?? 1)}
        playerIdToTeam={playerIdToTeamForPopup}
      />

      <FastShotsPopup
        insightsToCvPlayerIndex={insightsToCvPlayerIndex}
        teamColor={(team, alpha?) => {
          return teamRgba(team, alpha);
        }}
        renderPlayerIdentity={renderPlayerIdentity}
        open={openFastShotsPopup}
        anchorEl={fastShotsAnchorEl}
        onClose={() => setOpenFastShotsPopup(false)}
        packageId={packageId}
        activeRallyIndex={activeRow?.rallyIndex ?? null}
        clipsThisRally={fastShotClipsThisRally}
        clipsAll={fastShotClipsAll}
        playerLabel={(id) => `P${id}`}
        teamLabel={(t) => (t === 0 ? "Team 0" : "Team 1")}
        rows={rows}
        firefightsClips={firefightClips}
        firefightRallySet={firefightRallySet}
      />

      <CandidateSpeedupsPopup
        open={openCandidateSpeedupsPopup}
        onClose={() => setOpenCandidateSpeedupsPopup(false)}
        packageId={packageId}
        rows={rows}
        moments={candidateSpeedupMoments}
        insightsToCvPlayerIndex={insightsToCvPlayerIndex}
        renderPlayerIdentity={renderPlayerIdentity}
        playerLabel={(id) => `player ${id}`}
        teamLabel={(t) => (t === 0 ? "Team 0" : "Team 1")}
        firefightsClips={firefightClips}
        firefightRallySet={firefightRallySet}
      />

      <CandidateBodybagsPopup
        open={openCandidateBodybagsPopup}
        onClose={() => setOpenCandidateBodybagsPopup(false)}
        packageId={packageId}
        rows={rows}
        moments={candidateBodybagMoments}
        insightsToCvPlayerIndex={insightsToCvPlayerIndex}
        renderPlayerIdentity={renderPlayerIdentity}
        playerLabel={(id) => `player ${id}`}
        teamLabel={(t) => (t === 0 ? "Team 0" : "Team 1")}
        firefightsClips={firefightClips}
        firefightRallySet={firefightRallySet}
      />

      <PossiblePopupsPopup
        open={openPossiblePopupsPopup}
        onClose={() => setOpenPossiblePopupsPopup(false)}
        packageId={packageId}
        rows={rows}
        moments={possiblePopupMoments}
        insightsToCvPlayerIndex={insightsToCvPlayerIndex}
        renderPlayerIdentity={renderPlayerIdentity}
        playerLabel={(id) => `player ${id}`}
        teamLabel={(t) => (t === 0 ? "Team 0" : "Team 1")}
        firefightsClips={firefightClips}
        firefightRallySet={firefightRallySet}
        cvJson={cvJson}
      />

      <PaddleReadinessReviewPopup
        open={openPaddleReadinessPopup}
        onClose={() => setOpenPaddleReadinessPopup(false)}
        packageId={packageId}
        rows={rows}
        moments={paddleReadinessMoments}
        insightsToCvPlayerIndex={insightsToCvPlayerIndex}
        renderPlayerIdentity={renderPlayerIdentity}
        playerLabel={(id) => `player ${id}`}
        teamLabel={(t) => (t === 0 ? "Team 0" : "Team 1")}
        firefightsClips={firefightClips}
        firefightRallySet={firefightRallySet}
      />

      <DinkReadinessReviewPopup
        open={openDinkReadinessPopup}
        onClose={() => setOpenDinkReadinessPopup(false)}
        packageId={packageId}
        rows={rows}
        moments={dinkReadinessMoments}
        insightsToCvPlayerIndex={insightsToCvPlayerIndex}
        renderPlayerIdentity={renderPlayerIdentity}
        playerLabel={(id) => `player ${id}`}
        teamLabel={(t) => (t === 0 ? "Team 0" : "Team 1")}
        firefightsClips={firefightClips}
        firefightRallySet={firefightRallySet}
      />

      <LeftSideCoverageReviewPopup
        open={openLeftSideCoveragePopup}
        onClose={() => setOpenLeftSideCoveragePopup(false)}
        packageId={packageId}
        rows={rows}
        moments={leftSideCoverageMoments}
        insightsToCvPlayerIndex={insightsToCvPlayerIndex}
        renderPlayerIdentity={renderPlayerIdentity}
        playerLabel={(id) => `player ${id}`}
        teamLabel={(t) => (t === 0 ? "Team 0" : "Team 1")}
        firefightsClips={firefightClips}
        firefightRallySet={firefightRallySet}
      />

      <LobsPopup
        insightsToCvPlayerIndex={insightsToCvPlayerIndex}
        renderPlayerIdentity={renderPlayerIdentity}
        open={openLobShotsPopup}
        anchorEl={lobShotsAnchorEl}
        onClose={() => setOpenLobShotsPopup(false)}
        packageId={packageId}
        activeRallyIndex={activeRow?.rallyIndex ?? null}
        clipsThisRally={lobClipsAll}
        clipsAll={lobClipsAll}
        playerLabel={(id) => `P${id}`}
        teamLabel={(t) => (t === 0 ? "Team 0" : "Team 1")}
        rows={rows}
        firefightsClips={firefightClips}
        firefightRallySet={firefightRallySet}
        teamColor={(team, alpha) => teamRgba(team, alpha ?? 1)}
      />

      <ATPPopup
        insightsToCvPlayerIndex={insightsToCvPlayerIndex}
        renderPlayerIdentity={renderPlayerIdentity}
        open={openAtpPopup}
        anchorEl={atpAnchorEl}
        onClose={() => setOpenAtpPopup(false)}
        packageId={packageId}
        activeRallyIndex={activeRow?.rallyIndex ?? null}
        clipsThisRally={atpClipsThisRally}
        clipsAll={atpClipsAll}
        playerLabel={(id) => `P${id}`}
        teamLabel={(t) => (t === 0 ? "Team 0" : "Team 1")}
        rows={rows}
        firefightsClips={firefightClips}
        firefightRallySet={firefightRallySet}
      />

      <FirefightsPopup
        insightsToCvPlayerIndex={insightsToCvPlayerIndex}
        renderPlayerIdentity={renderPlayerIdentity}
        anchorEl={firefightsAnchorEl}
        open={openFirefights}
        onClose={() => setOpenFirefights(false)}
        rows={rows}
        packageId={packageId}
        activeRallyIndex={activeRow?.rallyIndex ?? null}
        clipsAll={firefightClips}
        firefightRallySet={firefightRallySet}
        teamColor={(team, alpha) => teamRgba(team, alpha ?? 1)}
      />

      <GameStoryGameAIPopup
        open={openGameAiPopup}
        renderPlayerIdentity={renderPlayerIdentity}
        onClose={() => setOpenGameAiPopup(false)}
        packageId={packageId}
        onOpenRally={(rallyIndex) => {
          pickRallyIndex(rallyIndex);
        }}
      />

      <PointsAddedPopup
        open={openPointsAddedPopup}
        onClose={() => setOpenPointsAddedPopup(false)}
        rows={rows}
        packageId={packageId}
        finalScore={pointsAddedFinalScore}
        renderPlayerIdentity={renderPlayerIdentity}
        insightsToCvPlayerIndex={insightsToCvPlayerIndex}
        playerIdToTeam={playerIdToTeamForPopup}
        cvJson={cvJson}
        firefightsClips={firefightClips}
        firefightRallySet={firefightRallySet}
        onOpenShotTargetLab={openPointsAddedShotTargetLab}
      />

      <MatchIdentityPopup
        insightsToCvPlayerIndex={insightsToCvPlayerIndex}
        open={matchIdentityOpen}
        // anchorEl={dinkSegmentsAnchorEl}
        onClose={() => setMatchIdentityOpen(false)}
        packageId={packageId}
        //activeRallyIndex={activeRow?.rallyIndex ?? null}
        // clipsThisRally={dinkSegmentClipsThisRally}
        // clipsAll={dinkSegmentClipsAll}
        // playerLabel={(id: number) => `P${id}`}
        // teamLabel={(t: number) => (t === 0 ? "Team 0" : "Team 1")}
        // teamColor={(team, alpha) => teamRgba(team, alpha ?? 1)}
        renderPlayerIdentity={renderPlayerIdentity}
        rows={rows}
        firefightsClips={firefightClips}
        firefightRallySet={firefightRallySet}
      />


      <AiTurnsHistoryPopup
        insightsToCvPlayerIndex={insightsToCvPlayerIndex}
        open={aiHistoryOpen}
        onClose={() => setAiHistoryOpen(false)}
        packageId={packageId}
        rows={rows}
        firefightsClips={firefightClips}
        renderPlayerIdentity={renderPlayerIdentity}
        firefightRallySet={firefightRallySet}
        onOpenRally={({ rallyIndex }) => {
          pickRallyIndex(rallyIndex);
        }}
      />
      <DinkSegmentPopup
        insightsToCvPlayerIndex={insightsToCvPlayerIndex}
        open={openDinkSegmentsPopup}
        anchorEl={dinkSegmentsAnchorEl}
        onClose={() => setOpenDinkSegmentsPopup(false)}
        packageId={packageId}
        activeRallyIndex={activeRow?.rallyIndex ?? null}
        clipsThisRally={dinkSegmentClipsThisRally}
        clipsAll={dinkSegmentClipsAll}
        playerLabel={(id: number) => `P${id}`}
        teamLabel={(t: number) => (t === 0 ? "Team 0" : "Team 1")}
        teamColor={(team, alpha) => teamRgba(team, alpha ?? 1)}
        renderPlayerIdentity={renderPlayerIdentity}
        rows={rows}
        firefightsClips={firefightClips}
        firefightRallySet={firefightRallySet}
      />

      {/* <ErnePopup
        insightsToCvPlayerIndex={insightsToCvPlayerIndex}
        open={openErnePopup}
        anchorEl={erneAnchorEl}
        onClose={() => setOpenErnePopup(false)}
        packageId={packageId}
        activeRallyIndex={activeRow?.rallyIndex ?? null}
        rows={rows}
        clipsThisRally={erneClipsThisRally}
        clipsAll={erneClipsAll}
        playerLabel={(id: number) => `P${id}`}
        teamLabel={(t: number) => (t === 0 ? "Team 0" : "Team 1")}
        firefightsClips={firefightClips}
        firefightRallySet={firefightRallySet}
      /> */}

      {/* <ServeLocationsPopup
  open={serveOpen}
  onClose={() => setServeOpen(false)}
  rows={rows}
  playerIdToTeam={playerIdToTeamForPopup}
  teamColor={teamRgba}
/>

<ReturnLocationsPopup
  open={returnOpen}
  onClose={() => setReturnOpen(false)}
  rows={rows}
  playerIdToTeam={playerIdToTeamForPopup}
  teamColor={teamRgba}
/> */}

      <ServeLocationsPopup
        insightsToCvPlayerIndex={insightsToCvPlayerIndex}
        open={openServePopup}
        anchorEl={serveAnchorEl}
        onClose={() => {
          setOpenServePopup(false);
          setServeAnchorEl(null);
        }}
        packageId={packageId}
        rows={rows}
        popupH_VideoPart={1000}
        popupW_VideoPart={1000}
        playerIdToTeam={playerIdToTeamForPopup}
        teamColor={(team, alpha) => teamRgba(team, alpha ?? 1)}
        renderPlayerIdentity={renderPlayerIdentity}
      />

      <ReturnLocationsPopup
        insightsToCvPlayerIndex={insightsToCvPlayerIndex}
        open={openReturnPopup}
        anchorEl={returnAnchorEl}
        onClose={() => {
          setOpenReturnPopup(false);
          setReturnAnchorEl(null);
        }}
        packageId={packageId}
        rows={rows}
        popupH_VideoPart={1000}
        popupW_VideoPart={1000}
        playerIdToTeam={playerIdToTeamForPopup}
        teamColor={(team, alpha) => teamRgba(team, alpha ?? 1)}
        renderPlayerIdentity={renderPlayerIdentity}
      />

      <ServeReturnRiskRewardPopup
        insightsToCvPlayerIndex={insightsToCvPlayerIndex}
        open={openServeReturnRiskPopup}
        anchorEl={serveReturnRiskAnchorEl}
        onClose={() => {
          setOpenServeReturnRiskPopup(false);
          setServeReturnRiskAnchorEl(null);
        }}
        packageId={packageId}
        rows={rows}
        playerIdToTeam={playerIdToTeamForPopup}
        teamColor={(team, alpha) => teamRgba(team, alpha ?? 1)}
        renderPlayerIdentity={renderPlayerIdentity}
        firefightsClips={firefightClips}
        firefightRallySet={firefightRallySet}
      />

      <RallyQualityOverviewPopup
        open={openRallyQualityOverviewPopup}
        onClose={() => {
          setOpenRallyQualityOverviewPopup(false);
          setRallyQualityOverviewAnchorEl(null);
        }}
        packageId={packageId}
        rows={rows}
        activeRallyIndex={activeRow?.rallyIndex ?? null}
        renderPlayerIdentity={renderPlayerIdentity}
        insightsToCvPlayerIndex={insightsToCvPlayerIndex}
        firefightsClips={firefightClips}
        firefightRallySet={firefightRallySet}
      />

      <SingleTopFocusPopup
        open={!!openSingleTopFocus || openExperimentSingleTopFocus}
        onClose={() => {
          setOpenExperimentSingleTopFocus(false);
          onCloseSingleTopFocus();
        }}
        packageId={packageId}
        rows={rows}
        insightsJson={iInsightsJson}
        cvJson={cvJson}
        renderPlayerIdentity={renderPlayerIdentity}
        insightsToCvPlayerIndex={insightsToCvPlayerIndex}
        firefightsClips={firefightClips}
        firefightRallySet={firefightRallySet}
      />
      <ThreeMinuteReviewPopup
        open={!!openThreeMinuteReview}
        onClose={onCloseThreeMinuteReview}
        packageId={packageId}
        rows={rows}
        insightsJson={iInsightsJson}
        cvJson={cvJson}
        renderPlayerIdentity={renderPlayerIdentity}
        insightsToCvPlayerIndex={insightsToCvPlayerIndex}
        firefightsClips={firefightClips}
        firefightRallySet={firefightRallySet}
        badgesByRallyIndex={badgesByRallyIndex}
        pounceWindowRows={pounceWindowRows}
      />
      <PlayerLensReviewPopup
        open={!!openPlayerLensReview}
        onClose={onClosePlayerLensReview}
        packageId={packageId}
        rows={rows}
        cvJson={cvJson}
        renderPlayerIdentity={renderPlayerIdentity}
        insightsToCvPlayerIndex={insightsToCvPlayerIndex}
        firefightsClips={firefightClips}
        firefightRallySet={firefightRallySet}
        badgesByRallyIndex={badgesByRallyIndex}
        pounceWindowRows={pounceWindowRows}
      />
      <PositioningPatternsPopup
        open={!!openPositioningPatterns || openExperimentPositioningPatterns}
        onClose={() => {
          setOpenExperimentPositioningPatterns(false);
          onClosePositioningPatterns();
        }}
        packageId={packageId}
        rows={rows}
        cvJson={cvJson}
        renderPlayerIdentity={renderPlayerIdentity}
        insightsToCvPlayerIndex={insightsToCvPlayerIndex}
        firefightsClips={firefightClips}
        firefightRallySet={firefightRallySet}
      />
      <RallyTrajectoryWallPopup
        open={openTrajectoryWall}
        onClose={() => setOpenTrajectoryWall(false)}
        packageId={packageId}
        rows={rows}
        insightsJson={iInsightsJson}
        cvJson={cvJson}
        renderPlayerIdentity={renderPlayerIdentity}
        playerIdToTeam={playerIdToTeamForPopup}
        insightsToCvPlayerIndex={insightsToCvPlayerIndex}
        firefightsClips={firefightClips}
        firefightRallySet={firefightRallySet}
        onSelectRally={pickRallyIndex}
      />
      <OpportunityFinderPopup
        open={openOpportunityFinder}
        onClose={() => setOpenOpportunityFinder(false)}
        rows={rows}
        playerIdToTeam={playerIdToTeamForPopup}
        onOpenShotLab={(row, shotNumber, context) => {
          setOpenOpportunityFinder(false);
          openOpportunityShotTargetLab(row, shotNumber, context);
        }}
      />
      <GameStoryShotUniversePopup
        open={openShotUniverse}
        onClose={() => {
          setOpenShotUniverse(false);
          setShotUniverseOpenShotNumber(null);
          setShotUniverseOpportunityContext(null);
        }}
        packageId={packageId}
        row={activeRow}
        rows={rows}
        shotNumber={shotUniverseOpenShotNumber ?? activeShotNumber}
        insightsJson={iInsightsJson}
        cvJson={cvJson}
        renderPlayerIdentity={renderPlayerIdentity}
        insightsToCvPlayerIndex={insightsToCvPlayerIndex}
        firefightsClips={firefightClips}
        firefightRallySet={firefightRallySet}
        opportunityContext={shotUniverseOpportunityContext}
        restoreBookmark={shotUniverseBookmarkRestore}
        onBackToOpportunities={() => {
          setOpenShotUniverse(false);
          setShotUniverseOpenShotNumber(null);
          setShotUniverseOpportunityContext(null);
          setOpenOpportunityFinder(true);
        }}
        onWatchBookmark={(bookmark) => {
          openBookmarkedShot(bookmark, false);
          setOpenShotUniverse(false);
        }}
      />
      {pendingVideoBookmark ? (
        <Box
          data-demo="bookmark-dialog"
          onPointerDown={(event) => event.stopPropagation()}
          onMouseDown={(event) => event.stopPropagation()}
          onClick={(event) => event.stopPropagation()}
          sx={{
            position: "fixed",
            inset: 0,
            zIndex: 13000,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            bgcolor: "rgba(0,0,0,0.52)",
          }}
        >
          <Box
            sx={{
              width: "min(360px, calc(100vw - 32px))",
              p: 1.35,
              border: "1px solid rgba(255,255,255,0.25)",
              borderRadius: 1,
              bgcolor: "rgba(8,8,8,0.98)",
              color: "#fff",
              boxShadow: "0 14px 44px rgba(0,0,0,0.64)",
            }}
          >
            <Box sx={{ fontWeight: 900, mb: 0.75 }}>Bookmark this shot</Box>
            <Box
              sx={{
                mb: 0.75,
                color: "rgba(255,255,255,0.68)",
                fontSize: 12.5,
                fontWeight: 800,
              }}
            >
              Shot {pendingVideoBookmark.shotNumber} ·{" "}
              {pendingVideoBookmark.playerId == null
                ? "Player unknown"
                : `Player ${pendingVideoBookmark.playerId}`}
            </Box>
            <Box
              component="textarea"
              data-demo="bookmark-description"
              value={videoBookmarkDescriptionDraft}
              placeholder="Reason for bookmarking"
              onChange={(event) => setVideoBookmarkDescriptionDraft(event.target.value)}
              sx={{
                width: "100%",
                minHeight: 86,
                resize: "vertical",
                boxSizing: "border-box",
                border: "1px solid rgba(255,255,255,0.2)",
                borderRadius: 0.75,
                bgcolor: "rgba(0,0,0,0.5)",
                color: "#fff",
                px: 1,
                py: 0.8,
                font: "inherit",
                fontSize: 13,
                outline: "none",
              }}
            />
            <Box sx={{ mt: 1, display: "flex", justifyContent: "flex-end", gap: 0.75 }}>
              <Button
                size="small"
                variant="outlined"
                onClick={() => setPendingVideoBookmark(null)}
                sx={{ textTransform: "none", minHeight: 28 }}
              >
                Cancel
              </Button>
              <Button
                size="small"
                variant="contained"
                data-demo="bookmark-save"
                onClick={savePendingVideoBookmark}
                sx={{ textTransform: "none", minHeight: 28 }}
              >
                Save
              </Button>
            </Box>
          </Box>
        </Box>
      ) : null}
      <ShotBookmarksPopup
        open={shotBookmarksOpen}
        bookmarks={shotBookmarks}
        onClose={() => setShotBookmarksOpen(false)}
        onWatch={(bookmark) => openBookmarkedShot(bookmark, false)}
        onOpenLab={(bookmark) => openBookmarkedShot(bookmark, true)}
        onUpdateDescription={(bookmarkId, description) =>
          updateShotBookmarkDescription(packageId, bookmarkId, description)
        }
        onDelete={(bookmarkId) => deleteShotBookmark(packageId, bookmarkId)}
      />
      {openQuickTriage ? (
        <GameStoryTriagePopup
          packageId={packageId}
          rows={rows}
          onClose={() => onCloseQuickTriage()}
          open={openQuickTriage}
          insightsToCvPlayerIndex={insightsToCvPlayerIndex}
          renderPlayerIdentity={renderPlayerIdentity}
          firefightsClips={firefightClips}
          firefightRallySet={firefightRallySet}
          pounceWindowRows={pounceWindowRows}
          badgesByRallyIndex={badgesByRallyIndex}

          // onOpenRally={(rallyIndex) => {
          //   pickRallyIndex(rallyIndex);
          // }}
        />
      ) : null}

      <AllRallyVideosPopup_FromKitchenArrivalRows
        open={openAllVideos}
        onClose={() => setOpenAllVideos(false)}
        rows={rows}
        packageId={packageId}
      />
    </Box>
  );
}

function isScorePair(x: any): x is [number, number] {
  return (
    Array.isArray(x) &&
    x.length === 2 &&
    Number.isFinite(x[0]) &&
    Number.isFinite(x[1])
  );
}

export function computeFinalScoreFromInsightsJson(insights: InsightsJson): {
  finalScore: [number, number] | null;
  winningTeam: Team01 | null;
  source:
    | "game_data.game_outcome"
    | "rally.scoring_info.running_score (likely_correct)"
    | "rally.scoring_info.running_score"
    | "reconstructed from rally.winning_team"
    | "none";
} {
  // 1) game-level outcome
  const gameOutcome = insights?.game_data?.game_outcome;
  if (isScorePair(gameOutcome)) {
    const winningTeam: Team01 | null =
      gameOutcome[0] > gameOutcome[1]
        ? 0
        : gameOutcome[1] > gameOutcome[0]
          ? 1
          : null;
    return {
      finalScore: gameOutcome,
      winningTeam,
      source: "game_data.game_outcome",
    };
  }

  const rallies = Array.isArray(insights?.rallies) ? insights.rallies : [];

  // 2) last likely-correct running score
  let lastLikely: [number, number] | null = null;
  for (const r of rallies) {
    if (r?.scoring_info?.likely_correct_score !== true) continue;
    const rs = r?.scoring_info?.running_score;
    if (isScorePair(rs)) lastLikely = rs;
  }
  if (lastLikely) {
    const winningTeam: Team01 | null =
      lastLikely[0] > lastLikely[1]
        ? 0
        : lastLikely[1] > lastLikely[0]
          ? 1
          : null;
    return {
      finalScore: lastLikely,
      winningTeam,
      source: "rally.scoring_info.running_score (likely_correct)",
    };
  }

  // 3) last running score of any kind
  let lastAny: [number, number] | null = null;
  for (const r of rallies) {
    const rs = r?.scoring_info?.running_score;
    if (isScorePair(rs)) lastAny = rs;
  }
  if (lastAny) {
    const winningTeam: Team01 | null =
      lastAny[0] > lastAny[1] ? 0 : lastAny[1] > lastAny[0] ? 1 : null;
    return {
      finalScore: lastAny,
      winningTeam,
      source: "rally.scoring_info.running_score",
    };
  }

  // 4) reconstruct by rally winners (this is NOT the same as points, but better than nothing)
  // Only do this if you truly have no scoring.
  let w0 = 0;
  let w1 = 0;
  for (const r of rallies) {
    if (r?.winning_team === 0) w0++;
    else if (r?.winning_team === 1) w1++;
  }
  if (w0 !== 0 || w1 !== 0) {
    const winningTeam: Team01 | null = w0 > w1 ? 0 : w1 > w0 ? 1 : null;
    return {
      finalScore: [w0, w1],
      winningTeam,
      source: "reconstructed from rally.winning_team",
    };
  }

  return { finalScore: null, winningTeam: null, source: "none" };
}

export function MatchOutcomeBanner(props: {
  insights: InsightsJson;
  onHoverTeam?: (t: 0 | 1 | null) => void;
}) {
  const { finalScore, winningTeam } = computeFinalScoreFromInsightsJson(
    props.insights,
  );

  return (
    <Box
      sx={{
        // width: "100%",
        display: "flex",
        justifyContent: "left",
        mt: 0,
      }}
    >
      <Box
        sx={{
          width: "100%",
          maxWidth: 1400, // tune this to your layout
          px: 0, // small gutter
        }}
      >
        <MatchOutcomeBanner_AssumeThingsCalculated
          winningTeam={winningTeam}
          finalScore={finalScore}
          leftLabel="Team 0"
          rightLabel="Team 1"
          onHoverTeam={props.onHoverTeam}
        />
      </Box>
    </Box>
  );
}

export function MatchOutcomeBanner_AssumeThingsCalculated(props: {
  winningTeam: Team01 | null;
  finalScore: [number, number] | null;
  leftLabel: string;
  rightLabel: string;
  onHoverTeam?: (t: 0 | 1 | null) => void;
}) {
  const { winningTeam, finalScore, leftLabel, rightLabel } = props;

  const s0 = finalScore?.[0];
  const s1 = finalScore?.[1];

  const is0Winner = winningTeam === 0;
  const is1Winner = winningTeam === 1;

  const leftTitle = is0Winner
    ? "" //"Won"
    : winningTeam === null
      ? "TEAM 0"
      : ""; // "Lost";
  const rightTitle = is1Winner
    ? "" //"Won"
    : winningTeam === null
      ? "TEAM 1"
      : ""; // "Lost";

  const titleSx = {
    fontSize: 12,
    fontWeight: 700,
    letterSpacing: 0.05,
    lineHeight: 1,
    opacity: 0.86,
  };

  const labelSx = {
    fontSize: 13,
    fontWeight: 650,
    lineHeight: 1,
  };

  const scoreSx = {
    fontSize: 16,
    fontWeight: 900,
    lineHeight: 1,
    width: 22,
    textAlign: "center" as const,
    fontVariantNumeric: "tabular-nums" as const,
  };

  const leftTextOpacity = is0Winner ? 1 : 0.92;
  const rightTextOpacity = is1Winner ? 1 : 0.92;

  return (
    <Box
      sx={{
        position: "relative",
        display: "inline-flex",
        width: "fit-content",
        height: 32,
        borderRadius: "7px",
        overflow: "hidden",
        backgroundColor: "rgba(255,255,255,0.03)",
        boxShadow: "inset 0 0 0 1px rgba(255,255,255,0.10)",
      }}
    >
      {/* LEFT */}
      <Box
        data-team="0"
        onMouseEnter={() => props.onHoverTeam?.(0)}
        onMouseLeave={() => props.onHoverTeam?.(null)}
        sx={{
          flex: "0 0 auto",
          backgroundColor: teamRgba(Team_0, is0Winner ? 0.92 : 0.56),
          display: "flex",
          alignItems: "center",
          px: 0.85,
          gap: 0.55,
          color: "white",
          whiteSpace: "nowrap",
        }}
      >
        <Box sx={{ ...titleSx, opacity: leftTextOpacity }}>{leftTitle}</Box>
        <Box sx={{ ...labelSx, opacity: leftTextOpacity }}>{leftLabel}</Box>
        <Box sx={{ ...scoreSx, ml: 0.2 }}>
          {typeof s0 === "number" ? s0 : "—"}
        </Box>
      </Box>

      {/* DIVIDER */}
      <Box
        sx={{
          width: 1,
          backgroundColor: "rgba(255,255,255,0.12)",
        }}
      />

      {/* RIGHT */}
      <Box
        data-team="1"
        onMouseEnter={() => props.onHoverTeam?.(1)}
        onMouseLeave={() => props.onHoverTeam?.(null)}
        sx={{
          flex: "0 0 auto",
          backgroundColor: teamRgba(Team_1, is1Winner ? 0.92 : 0.56),
          display: "flex",
          alignItems: "center",
          px: 0.95,
          gap: 0.6,
          color: "white",
          whiteSpace: "nowrap",
        }}
      >
        <Box sx={scoreSx}>{typeof s1 === "number" ? s1 : "—"}</Box>
        <Box sx={{ ...labelSx, opacity: rightTextOpacity }}>{rightLabel}</Box>
        <Box sx={{ ...titleSx, ml: 0.08, opacity: rightTextOpacity }}>
          {rightTitle}
        </Box>
      </Box>
    </Box>
  );
}
export function MatchOutcomeBanner_AssumeThingsCalculated_buttonlike(props: {
  winningTeam: Team01 | null;
  finalScore: [number, number] | null;
  leftLabel: string;
  rightLabel: string;
  onHoverTeam?: (t: 0 | 1 | null) => void;
}) {
  const { winningTeam, finalScore, leftLabel, rightLabel } = props;

  const s0 = finalScore?.[0];
  const s1 = finalScore?.[1];

  const is0Winner = winningTeam === 0;
  const is1Winner = winningTeam === 1;

  const leftTitle = is0Winner
    ? "Won"
    : winningTeam === null
      ? "TEAM 0"
      : "Lost";
  const rightTitle = is1Winner
    ? "Won"
    : winningTeam === null
      ? "TEAM 1"
      : "Lost";

  const titleSx = {
    fontSize: 14,
    fontWeight: 900,
    letterSpacing: 0.15,
    lineHeight: 1,
  };
  const labelSx = {
    fontSize: 14,
    fontWeight: 700,
    opacity: 0.95,
    lineHeight: 1,
  };

  const scoreSx = {
    fontSize: 14,
    fontWeight: 900,
    lineHeight: 1,
    width: 26, // <- key: makes 4 and 11 feel balanced
    textAlign: "center" as const,
    fontVariantNumeric: "tabular-nums" as const,
  };

  return (
    <Box
      sx={{
        position: "relative",
        display: "inline-flex",
        width: "fit-content",
        height: 38,
        borderRadius: "6px",
        overflow: "hidden",
        boxShadow: "inset 0 0 0 1px rgba(255,255,255,0.10)",
      }}
    >
      {/* LEFT */}
      <Box
        data-team="0"
        onMouseEnter={() => props.onHoverTeam?.(0)}
        onMouseLeave={() => props.onHoverTeam?.(null)}
        sx={{
          flex: "0 0 auto",
          backgroundColor: teamRgba(Team_0, is0Winner ? 1 : 0.78),
          display: "flex",
          alignItems: "center",
          px: 1.1,
          gap: 1,
          color: "white",
          whiteSpace: "nowrap",
        }}
      >
        <Box sx={titleSx}>{leftTitle}</Box>
        <Box sx={labelSx}>{leftLabel}</Box>
        <Box sx={{ ...scoreSx, ml: 0.4 }}>
          {typeof s0 === "number" ? s0 : "—"}
        </Box>
      </Box>

      {/* DIVIDER */}
      <Box
        sx={{
          width: 1,
          backgroundColor: "rgba(255,255,255,0.18)", // softer
        }}
      />

      {/* RIGHT */}
      <Box
        data-team="1"
        onMouseEnter={() => props.onHoverTeam?.(1)}
        onMouseLeave={() => props.onHoverTeam?.(null)}
        sx={{
          flex: "0 0 auto",
          backgroundColor: teamRgba(Team_1, is1Winner ? 1 : 0.78),
          display: "flex",
          alignItems: "center",
          px: 1.1,
          gap: 1,
          color: "white",
          whiteSpace: "nowrap",
        }}
      >
        <Box sx={scoreSx}>{typeof s1 === "number" ? s1 : "—"}</Box>
        <Box sx={{ ...titleSx, ml: 0.2 }}>{rightTitle}</Box>
        <Box sx={labelSx}>{rightLabel}</Box>
      </Box>
    </Box>
  );
}
